/**
 * File generated by js-routes 2.2.10
 * Based on Rails 7.0.8 routes of AdaliaMonitoringAndEvaluation::Application
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                module.exports = routes;
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                define([], function () {
                    return routes;
                });
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {"format":"json"},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (keyword_parameters.trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            result += keyword_parameters.anchor
                ? "#" + keyword_parameters.anchor
                : "";
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return false
                ? result
                : encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
        }
    }
    const Utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return Utils.route(parts_table, route_spec, absolute);
        },
    };
    const result = {
        ...__jsr,
        configure: (config) => {
            return Utils.configure(config);
        },
        config: () => {
            return Utils.config();
        },
        serialize: (object) => {
            return Utils.serialize(object);
        },
        ...{},
    };
    Utils.define_module("ESM", result);
    return result;
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * (/:locale)/access_denied(/:type)(/:programme_identifier)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const access_denied_path = /*#__PURE__*/ __jsr.r({"locale":{},"type":{},"programme_identifier":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"access_denied"],[2,[1,[2,[7,"/"],[3,"type"]]],[2,[1,[2,[7,"/"],[3,"programme_identifier"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/faq/create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_faq_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"faq"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/faq/delete/:faq_content_id(.:format)
 * @param {any} faq_content_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_faq_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"faq_content_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"faq"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"faq_content_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/faq/delete_document/:file_id(.:format)
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_faq_delete_document_path = /*#__PURE__*/ __jsr.r({"locale":{},"file_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"faq"],[2,[7,"/"],[2,[6,"delete_document"],[2,[7,"/"],[2,[3,"file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/faq/edit/:faq_content_id(.:format)
 * @param {any} faq_content_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_faq_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"faq_content_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"faq"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"faq_content_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/faq/get_document/:file_id(.:format)
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_faq_get_document_path = /*#__PURE__*/ __jsr.r({"locale":{},"file_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"faq"],[2,[7,"/"],[2,[6,"get_document"],[2,[7,"/"],[2,[3,"file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/faq/get_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_faq_get_documents_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"faq"],[2,[7,"/"],[2,[6,"get_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/faq(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_faq_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"faq"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/faq/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_faq_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"faq"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/faq/preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_faq_preview_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"faq"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/faq/update/:faq_content_id(.:format)
 * @param {any} faq_content_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_faq_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"faq_content_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"faq"],[2,[7,"/"],[2,[6,"update"],[2,[7,"/"],[2,[3,"faq_content_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/faq/update_sort_order(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_faq_update_sort_order_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"faq"],[2,[7,"/"],[2,[6,"update_sort_order"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/faq/upload_document(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_faq_upload_document_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"faq"],[2,[7,"/"],[2,[6,"upload_document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/system_message(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_system_message_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"system_message"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/system_message/delete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_system_message_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"system_message"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/system_message/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_system_message_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"system_message"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/system_message/save(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_system_message_save_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"system_message"],[2,[7,"/"],[2,[6,"save"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/roles/create/:user_group_id(.:format)
 * @param {any} user_group_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_type_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"user_group_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[6,"create"],[2,[7,"/"],[2,[3,"user_group_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/roles/delete/:user_type_id(.:format)
 * @param {any} user_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_type_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"user_type_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"user_type_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/roles/edit/:user_type_id(.:format)
 * @param {any} user_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_type_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"user_type_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"user_type_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/roles/new/:user_group_id(.:format)
 * @param {any} user_group_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_type_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"user_group_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[3,"user_group_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/roles/update/:user_type_id(.:format)
 * @param {any} user_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_type_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"user_type_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[6,"update"],[2,[7,"/"],[2,[3,"user_type_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/all_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const administration_all_users_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"all_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/all_users_json(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const administration_all_users_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"all_users_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/archive_fund/:fund_id/:archive(.:format)
 * @param {any} fund_id
 * @param {any} archive
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const administration_archive_fund_path = /*#__PURE__*/ __jsr.r({"locale":{},"fund_id":{"r":true},"archive":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"archive_fund"],[2,[7,"/"],[2,[3,"fund_id"],[2,[7,"/"],[2,[3,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/create_fund(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const administration_create_fund_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"create_fund"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/delayed_jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const administration_delayed_job_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"delayed_jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/delete_fund/:fund_id(.:format)
 * @param {any} fund_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const administration_delete_fund_path = /*#__PURE__*/ __jsr.r({"locale":{},"fund_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"delete_fund"],[2,[7,"/"],[2,[3,"fund_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/edit_fund/:fund_id(.:format)
 * @param {any} fund_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const administration_edit_fund_path = /*#__PURE__*/ __jsr.r({"locale":{},"fund_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"edit_fund"],[2,[7,"/"],[2,[3,"fund_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/event_calendar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const administration_event_calendar_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"event_calendar"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/feedback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const administration_feedback_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"feedback"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/feedback/mark_as_read/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const administration_feedback_mark_as_read_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"feedback"],[2,[7,"/"],[2,[6,"mark_as_read"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/feedback/show/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const administration_feedback_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"feedback"],[2,[7,"/"],[2,[6,"show"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/form_tools(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const administration_form_tools_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"form_tools"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/funds(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const administration_fund_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"funds"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/list_organizations_json(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const administration_list_organizations_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"list_organizations_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/new_fund(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const administration_new_fund_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"new_fund"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const administration_organizations_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/roles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const administration_role_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/show_fund/:fund_id(.:format)
 * @param {any} fund_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const administration_show_fund_path = /*#__PURE__*/ __jsr.r({"locale":{},"fund_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"show_fund"],[2,[7,"/"],[2,[3,"fund_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/admin/update_fund/:fund_id(.:format)
 * @param {any} fund_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const administration_update_fund_path = /*#__PURE__*/ __jsr.r({"locale":{},"fund_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"update_fund"],[2,[7,"/"],[2,[3,"fund_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/analytic_view/create(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytic_view_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"analytic_view"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/analytic_view/create_cols/:analytic_view_id(.:format)
 * @param {any} programme_identifier
 * @param {any} analytic_view_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytic_view_create_cols_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"analytic_view_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"analytic_view"],[2,[7,"/"],[2,[6,"create_cols"],[2,[7,"/"],[2,[3,"analytic_view_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/analytic_view/:analytic_view_id/create_filter(.:format)
 * @param {any} programme_identifier
 * @param {any} analytic_view_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytic_view_create_filter_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"analytic_view_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"analytic_view"],[2,[7,"/"],[2,[3,"analytic_view_id"],[2,[7,"/"],[2,[6,"create_filter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/analytic_view/:analytic_view_id/create_virtual_column(.:format)
 * @param {any} programme_identifier
 * @param {any} analytic_view_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytic_view_create_virtual_column_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"analytic_view_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"analytic_view"],[2,[7,"/"],[2,[3,"analytic_view_id"],[2,[7,"/"],[2,[6,"create_virtual_column"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/analytic_view/:analytic_view_id/delete_column/:analytic_view_column_id(.:format)
 * @param {any} programme_identifier
 * @param {any} analytic_view_id
 * @param {any} analytic_view_column_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytic_view_delete_column_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"analytic_view_id":{"r":true},"analytic_view_column_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"analytic_view"],[2,[7,"/"],[2,[3,"analytic_view_id"],[2,[7,"/"],[2,[6,"delete_column"],[2,[7,"/"],[2,[3,"analytic_view_column_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/analytic_view/:analytic_view_id/delete_filter/:analytic_view_filter_id(.:format)
 * @param {any} programme_identifier
 * @param {any} analytic_view_id
 * @param {any} analytic_view_filter_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytic_view_delete_filter_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"analytic_view_id":{"r":true},"analytic_view_filter_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"analytic_view"],[2,[7,"/"],[2,[3,"analytic_view_id"],[2,[7,"/"],[2,[6,"delete_filter"],[2,[7,"/"],[2,[3,"analytic_view_filter_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/analytic_view/:analytic_view_id/node/:node_id/delete(.:format)
 * @param {any} programme_identifier
 * @param {any} analytic_view_id
 * @param {any} node_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytic_view_delete_node_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"analytic_view_id":{"r":true},"node_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"analytic_view"],[2,[7,"/"],[2,[3,"analytic_view_id"],[2,[7,"/"],[2,[6,"node"],[2,[7,"/"],[2,[3,"node_id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/analytic_view/:analytic_view_id/delete_virtual_column/:analytic_view_column_id(.:format)
 * @param {any} programme_identifier
 * @param {any} analytic_view_id
 * @param {any} analytic_view_column_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytic_view_delete_virtual_column_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"analytic_view_id":{"r":true},"analytic_view_column_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"analytic_view"],[2,[7,"/"],[2,[3,"analytic_view_id"],[2,[7,"/"],[2,[6,"delete_virtual_column"],[2,[7,"/"],[2,[3,"analytic_view_column_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/analytic_view/:analytic_view_id/edit(.:format)
 * @param {any} programme_identifier
 * @param {any} analytic_view_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytic_view_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"analytic_view_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"analytic_view"],[2,[7,"/"],[2,[3,"analytic_view_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/analytic_view/get_source_cols/:source_type/:source_id(.:format)
 * @param {any} programme_identifier
 * @param {any} source_type
 * @param {any} source_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytic_view_get_source_cols_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"source_type":{"r":true},"source_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"analytic_view"],[2,[7,"/"],[2,[6,"get_source_cols"],[2,[7,"/"],[2,[3,"source_type"],[2,[7,"/"],[2,[3,"source_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/analytic_view/list_json/:analytic_view_id(.:format)
 * @param {any} programme_identifier
 * @param {any} analytic_view_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytic_view_list_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"analytic_view_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"analytic_view"],[2,[7,"/"],[2,[6,"list_json"],[2,[7,"/"],[2,[3,"analytic_view_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/analytic_view/:analytic_view_id/list_tables_with_available_columns(.:format)
 * @param {any} programme_identifier
 * @param {any} analytic_view_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytic_view_list_tables_with_available_columns_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"analytic_view_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"analytic_view"],[2,[7,"/"],[2,[3,"analytic_view_id"],[2,[7,"/"],[2,[6,"list_tables_with_available_columns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/analytic_view/new(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytic_view_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"analytic_view"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/analytic_view/:analytic_view_id/node/:node_id/columns(.:format)
 * @param {any} programme_identifier
 * @param {any} analytic_view_id
 * @param {any} node_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytic_view_node_columns_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"analytic_view_id":{"r":true},"node_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"analytic_view"],[2,[7,"/"],[2,[3,"analytic_view_id"],[2,[7,"/"],[2,[6,"node"],[2,[7,"/"],[2,[3,"node_id"],[2,[7,"/"],[2,[6,"columns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/analytic_view/:analytic_view_id/query(.:format)
 * @param {any} programme_identifier
 * @param {any} analytic_view_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytic_view_query_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"analytic_view_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"analytic_view"],[2,[7,"/"],[2,[3,"analytic_view_id"],[2,[7,"/"],[2,[6,"query"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/analytic_view/:analytic_view_id/preset/create(.:format)
 * @param {any} programme_identifier
 * @param {any} analytic_view_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytic_view_saved_preset_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"analytic_view_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"analytic_view"],[2,[7,"/"],[2,[3,"analytic_view_id"],[2,[7,"/"],[2,[6,"preset"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/analytic_view/source_options(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytic_view_source_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"analytic_view"],[2,[7,"/"],[2,[6,"source_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/analytic_view/:analytic_view_id/update_column_name/:analytic_view_column_id(.:format)
 * @param {any} programme_identifier
 * @param {any} analytic_view_id
 * @param {any} analytic_view_column_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytic_view_update_column_name_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"analytic_view_id":{"r":true},"analytic_view_column_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"analytic_view"],[2,[7,"/"],[2,[3,"analytic_view_id"],[2,[7,"/"],[2,[6,"update_column_name"],[2,[7,"/"],[2,[3,"analytic_view_column_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/analytic_view/:analytic_view_id/update_filter/:analytic_view_filter_id(.:format)
 * @param {any} programme_identifier
 * @param {any} analytic_view_id
 * @param {any} analytic_view_filter_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytic_view_update_filter_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"analytic_view_id":{"r":true},"analytic_view_filter_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"analytic_view"],[2,[7,"/"],[2,[3,"analytic_view_id"],[2,[7,"/"],[2,[6,"update_filter"],[2,[7,"/"],[2,[3,"analytic_view_filter_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/analytic_view/:analytic_view_id/node/:node_id/update_join(.:format)
 * @param {any} programme_identifier
 * @param {any} analytic_view_id
 * @param {any} node_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytic_view_update_join_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"analytic_view_id":{"r":true},"node_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"analytic_view"],[2,[7,"/"],[2,[3,"analytic_view_id"],[2,[7,"/"],[2,[6,"node"],[2,[7,"/"],[2,[3,"node_id"],[2,[7,"/"],[2,[6,"update_join"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/analytic_view/:analytic_view_id/node/:node_id/update_union(.:format)
 * @param {any} programme_identifier
 * @param {any} analytic_view_id
 * @param {any} node_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytic_view_update_union_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"analytic_view_id":{"r":true},"node_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"analytic_view"],[2,[7,"/"],[2,[3,"analytic_view_id"],[2,[7,"/"],[2,[6,"node"],[2,[7,"/"],[2,[3,"node_id"],[2,[7,"/"],[2,[6,"update_union"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/analytic_view/:analytic_view_id/update_virtual_column/:analytic_view_column_id(.:format)
 * @param {any} programme_identifier
 * @param {any} analytic_view_id
 * @param {any} analytic_view_column_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytic_view_update_virtual_column_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"analytic_view_id":{"r":true},"analytic_view_column_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"analytic_view"],[2,[7,"/"],[2,[3,"analytic_view_id"],[2,[7,"/"],[2,[6,"update_virtual_column"],[2,[7,"/"],[2,[3,"analytic_view_column_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/analytic_view/:analytic_view_id/node/:node_id/wrap_join(.:format)
 * @param {any} programme_identifier
 * @param {any} analytic_view_id
 * @param {any} node_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytic_view_wrap_join_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"analytic_view_id":{"r":true},"node_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"analytic_view"],[2,[7,"/"],[2,[3,"analytic_view_id"],[2,[7,"/"],[2,[6,"node"],[2,[7,"/"],[2,[3,"node_id"],[2,[7,"/"],[2,[6,"wrap_join"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/analytic_view/:analytic_view_id/node/:node_id/wrap_union(.:format)
 * @param {any} programme_identifier
 * @param {any} analytic_view_id
 * @param {any} node_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytic_view_wrap_union_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"analytic_view_id":{"r":true},"node_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"analytic_view"],[2,[7,"/"],[2,[3,"analytic_view_id"],[2,[7,"/"],[2,[6,"node"],[2,[7,"/"],[2,[3,"node_id"],[2,[7,"/"],[2,[6,"wrap_union"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/api(/:version)/:method(.:format)
 * @param {any} method
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_path = /*#__PURE__*/ __jsr.r({"locale":{},"version":{},"method":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"api"],[2,[1,[2,[7,"/"],[3,"version"]]],[2,[7,"/"],[2,[3,"method"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/api/:version/:method(.:format)
 * @param {any} version
 * @param {any} method
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v3_path = /*#__PURE__*/ __jsr.r({"locale":{},"version":{"r":true},"method":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"version"],[2,[7,"/"],[2,[3,"method"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/docs
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apitome_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[6,"docs"]]]]);

/**
 * Generates rails route to
 * /api/docs/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apitome_root_path = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[6,"docs"]]]],[7,"/"]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/applicant/applications/:project_id/form/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applicant_application_form_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"applicant"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"form"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/applicant/applications/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applicant_application_progress_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"applicant"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/applicant/application_save/:call_id/:phase_id/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} call_id
 * @param {any} phase_id
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applicant_application_save_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_id":{"r":true},"phase_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"applicant"],[2,[7,"/"],[2,[6,"application_save"],[2,[7,"/"],[2,[3,"call_id"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/applicant/applications(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applicant_applications_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"applicant"],[2,[7,"/"],[2,[6,"applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/applicant/calls(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applicant_calls_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"applicant"],[2,[7,"/"],[2,[6,"calls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/applicant(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applicant_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"applicant"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/applicant/:space_identifier/kms_page/:page_id/edit(.:format)
 * @param {any} programme_identifier
 * @param {any} space_identifier
 * @param {any} page_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applicant_kms_edit_page_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"space_identifier":{"r":true},"page_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"applicant"],[2,[7,"/"],[2,[3,"space_identifier"],[2,[7,"/"],[2,[6,"kms_page"],[2,[7,"/"],[2,[3,"page_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/applicant/:space_identifier/kms_page/:page_id(.:format)
 * @param {any} programme_identifier
 * @param {any} space_identifier
 * @param {any} page_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applicant_kms_page_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"space_identifier":{"r":true},"page_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"applicant"],[2,[7,"/"],[2,[3,"space_identifier"],[2,[7,"/"],[2,[6,"kms_page"],[2,[7,"/"],[2,[3,"page_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/applicant/kms_space(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applicant_kms_space_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"applicant"],[2,[7,"/"],[2,[6,"kms_space"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/applicant/applications/:project_id/users(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applicant_manage_users_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"applicant"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/applicant_projects_json(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applicant_project_list_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"applicant_projects_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/applicant/projects(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applicant_projects_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"applicant"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/applicant/select_organization/:call_id(.:format)
 * @param {any} programme_identifier
 * @param {any} call_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applicant_select_organization_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"applicant"],[2,[7,"/"],[2,[6,"select_organization"],[2,[7,"/"],[2,[3,"call_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/applicant/support(/:case_id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applicant_support_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"case_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"applicant"],[2,[7,"/"],[2,[6,"support"],[2,[1,[2,[7,"/"],[3,"case_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/applicant/applications/unlock_form_edit/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applicant_unlock_form_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"applicant"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"unlock_form_edit"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/applicant/applications/:project_id/annex/:programme_form_link_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} programme_form_link_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const application_annex_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"programme_form_link_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"applicant"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"annex"],[2,[7,"/"],[2,[3,"programme_form_link_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/applicant/applications/load_annexe_statuses/:project_id/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const application_load_annexe_statuses_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"applicant"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"load_annexe_statuses"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/applicant/applications/:project_id/milestones(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const application_milestones_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"applicant"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"milestones"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/applicant/applications/:project_id/project_contract(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const application_project_contract_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"applicant"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project_contract"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/applicant/applications/:project_id/reports(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const application_reports_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"applicant"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/applicant/applications/:project_id/result_framework(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const application_result_framework_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"applicant"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"result_framework"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/assigned_survey/list(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assigned_survey_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"assigned_survey"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/assigned_survey/list_json(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assigned_survey_list_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"assigned_survey"],[2,[7,"/"],[2,[6,"list_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/assigned_survey/:report_api_id/list_responses(.:format)
 * @param {any} programme_identifier
 * @param {any} report_api_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assigned_survey_list_responses_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"report_api_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"assigned_survey"],[2,[7,"/"],[2,[3,"report_api_id"],[2,[7,"/"],[2,[6,"list_responses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/assigned_survey/:report_api_id/list_responses_json(.:format)
 * @param {any} programme_identifier
 * @param {any} report_api_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assigned_survey_list_responses_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"report_api_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"assigned_survey"],[2,[7,"/"],[2,[3,"report_api_id"],[2,[7,"/"],[2,[6,"list_responses_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/assigned_survey/:survey_api_id/show_response(.:format)
 * @param {any} programme_identifier
 * @param {any} survey_api_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assigned_survey_show_response_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"survey_api_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"assigned_survey"],[2,[7,"/"],[2,[3,"survey_api_id"],[2,[7,"/"],[2,[6,"show_response"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/assigned_survey/:report_api_id/update_visible_columns(.:format)
 * @param {any} programme_identifier
 * @param {any} report_api_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assigned_survey_update_visible_columns_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"report_api_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"assigned_survey"],[2,[7,"/"],[2,[3,"report_api_id"],[2,[7,"/"],[2,[6,"update_visible_columns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/assignments/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assignment_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"assignments"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/update_assignments/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assignment_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"update_assignments"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/upload/active(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachment_active_upload_session_tokens_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"upload"],[2,[7,"/"],[2,[6,"active"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/auth(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachment_auth_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"auth"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/upload/token(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachment_create_upload_token_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"upload"],[2,[7,"/"],[2,[6,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/upload/dropzone(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachment_dropzone_upload_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"upload"],[2,[7,"/"],[2,[6,"dropzone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/upload/finalize(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachment_finalize_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"upload"],[2,[7,"/"],[2,[6,"finalize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/upload/finalize_logo(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachment_finalize_logo_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"upload"],[2,[7,"/"],[2,[6,"finalize_logo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/upload/failed(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachment_mark_failed_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"upload"],[2,[7,"/"],[2,[6,"failed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/upload/status/:token(.:format)
 * @param {any} programme_identifier
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachment_status_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"token":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"upload"],[2,[7,"/"],[2,[6,"status"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/attachment_storage/complete_upload(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachment_storage_complete_upload_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"attachment_storage"],[2,[7,"/"],[2,[6,"complete_upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/s3/uploads/:attachment_id(.:format)
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachment_storage_download_path = /*#__PURE__*/ __jsr.r({"locale":{},"attachment_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"s3"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/attachment_storage/presigned_url(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachment_storage_presigned_url_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"attachment_storage"],[2,[7,"/"],[2,[6,"presigned_url"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/upload/update_status/:token(.:format)
 * @param {any} programme_identifier
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachment_update_status_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"token":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"upload"],[2,[7,"/"],[2,[6,"update_status"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/beta_feedback_dialog/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const beta_feedback_dialog_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"beta_feedback_dialog"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/budget/add_row/:project_id/:budget_id/:section_identifier(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} budget_id
 * @param {any} section_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const budget_add_row_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"budget_id":{"r":true},"section_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"budget"],[2,[7,"/"],[2,[6,"add_row"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"budget_id"],[2,[7,"/"],[2,[3,"section_identifier"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/budget/add_section/:project_id/:budget_id(/:section_identifier)(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} budget_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const budget_add_section_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"budget_id":{"r":true},"section_identifier":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"budget"],[2,[7,"/"],[2,[6,"add_section"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"budget_id"],[2,[1,[2,[7,"/"],[3,"section_identifier"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/budget/add_year/:project_id/:budget_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} budget_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const budget_add_year_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"budget_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"budget"],[2,[7,"/"],[2,[6,"add_year"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"budget_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/budget_analysis_report(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const budget_analysis_report_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"budget_analysis_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/budget_analysis_report/:form_id/:field/budget_data(.:format)
 * @param {any} programme_identifier
 * @param {any} form_id
 * @param {any} field
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const budget_analysis_report_budget_data_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"form_id":{"r":true},"field":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"budget_analysis_report"],[2,[7,"/"],[2,[3,"form_id"],[2,[7,"/"],[2,[3,"field"],[2,[7,"/"],[2,[6,"budget_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/budget_analysis_report/:report_id/forms(.:format)
 * @param {any} programme_identifier
 * @param {any} report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const budget_analysis_report_forms_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"budget_analysis_report"],[2,[7,"/"],[2,[3,"report_id"],[2,[7,"/"],[2,[6,"forms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/budget/delete_row/:project_id/:budget_id/:row_identifier(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} budget_id
 * @param {any} row_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const budget_delete_row_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"budget_id":{"r":true},"row_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"budget"],[2,[7,"/"],[2,[6,"delete_row"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"budget_id"],[2,[7,"/"],[2,[3,"row_identifier"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/budget/delete_section/:project_id/:budget_id/:section_identifier(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} budget_id
 * @param {any} section_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const budget_delete_section_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"budget_id":{"r":true},"section_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"budget"],[2,[7,"/"],[2,[6,"delete_section"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"budget_id"],[2,[7,"/"],[2,[3,"section_identifier"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/budget/discard/:project_id/:budget_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} budget_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const budget_discard_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"budget_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"budget"],[2,[7,"/"],[2,[6,"discard"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"budget_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/budget/edit/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const budget_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"budget"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/budget/load/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const budget_load_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"budget"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/budget/open/:project_id/:budget_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} budget_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const budget_open_for_editing_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"budget_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"budget"],[2,[7,"/"],[2,[6,"open"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"budget_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/budget/remove_year/:project_id/:budget_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} budget_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const budget_remove_year_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"budget_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"budget"],[2,[7,"/"],[2,[6,"remove_year"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"budget_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/budget/save/:project_id/:budget_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} budget_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const budget_save_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"budget_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"budget"],[2,[7,"/"],[2,[6,"save"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"budget_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/budget/show/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const budget_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"budget"],[2,[7,"/"],[2,[6,"show"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/budget/update_row/:project_id/:budget_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} budget_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const budget_update_row_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"budget_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"budget"],[2,[7,"/"],[2,[6,"update_row"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"budget_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/budget/update_section/:project_id/:budget_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} budget_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const budget_update_section_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"budget_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"budget"],[2,[7,"/"],[2,[6,"update_section"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"budget_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/budget/update_value/:project_id/:budget_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} budget_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const budget_update_value_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"budget_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"budget"],[2,[7,"/"],[2,[6,"update_value"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"budget_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/evaluator_ai/bulk_evaluate(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_ai_evaluate_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"evaluator_ai"],[2,[7,"/"],[2,[6,"bulk_evaluate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/bulk_email_all_applicants(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_email_all_applicants_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"bulk_email_all_applicants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/bulk_email_all_applicants_dialog/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_email_all_applicants_dialog_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"bulk_email_all_applicants_dialog"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/bulk_email_applicants(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_email_applicants_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"bulk_email_applicants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/bulk_email_applicants_dialog/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_email_applicants_dialog_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"bulk_email_applicants_dialog"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calculator/calculate(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calculator_calculate_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calculator"],[2,[7,"/"],[2,[6,"calculate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/workflows/call/download_attachment/:programme_form_link_id/:call_api_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_form_link_id
 * @param {any} call_api_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const call_workflow_download_attachment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_form_link_id":{"r":true},"call_api_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[6,"call"],[2,[7,"/"],[2,[6,"download_attachment"],[2,[7,"/"],[2,[3,"programme_form_link_id"],[2,[7,"/"],[2,[3,"call_api_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/workflows/call/:call_api_id(.:format)
 * @param {any} programme_identifier
 * @param {any} call_api_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const call_workflow_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_api_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[6,"call"],[2,[7,"/"],[2,[3,"call_api_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/workflows/call/:call_api_id/form/:programme_form_link_id(.:format)
 * @param {any} programme_identifier
 * @param {any} call_api_id
 * @param {any} programme_form_link_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const call_workflow_form_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_api_id":{"r":true},"programme_form_link_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[6,"call"],[2,[7,"/"],[2,[3,"call_api_id"],[2,[7,"/"],[2,[6,"form"],[2,[7,"/"],[2,[3,"programme_form_link_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/workflows/call/:call_api_id/save_form/:programme_form_link_id(.:format)
 * @param {any} programme_identifier
 * @param {any} call_api_id
 * @param {any} programme_form_link_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const call_workflow_save_form_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_api_id":{"r":true},"programme_form_link_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[6,"call"],[2,[7,"/"],[2,[3,"call_api_id"],[2,[7,"/"],[2,[6,"save_form"],[2,[7,"/"],[2,[3,"programme_form_link_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/workflows/call/:call_api_id/submit(.:format)
 * @param {any} programme_identifier
 * @param {any} call_api_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const call_workflow_submit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_api_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[6,"call"],[2,[7,"/"],[2,[3,"call_api_id"],[2,[7,"/"],[2,[6,"submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/workflows/call/upload_attachment(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const call_workflow_upload_attachment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[6,"call"],[2,[7,"/"],[2,[6,"upload_attachment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/support/change_support_request_status(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const change_support_request_status_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"change_support_request_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/login/check_auth_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_auth_token_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"login"],[2,[7,"/"],[2,[6,"check_auth_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/cloudflare_r2/email_attachment/:attachment_id(.:format)
 * @param {any} programme_identifier
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cloudflare_r2_email_attachment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"cloudflare_r2"],[2,[7,"/"],[2,[6,"email_attachment"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/common/user_select/own_direct_reports(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const common_own_direct_reports_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"common"],[2,[7,"/"],[2,[6,"user_select"],[2,[7,"/"],[2,[6,"own_direct_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/common/project_select/options(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const common_project_select_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"common"],[2,[7,"/"],[2,[6,"project_select"],[2,[7,"/"],[2,[6,"options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/common/user_select/organisation_tree_options(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const common_user_organisation_tree_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"common"],[2,[7,"/"],[2,[6,"user_select"],[2,[7,"/"],[2,[6,"organisation_tree_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/common/user_select/options(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const common_user_select_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"common"],[2,[7,"/"],[2,[6,"user_select"],[2,[7,"/"],[2,[6,"options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/common/user_select/user_type_options(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const common_user_type_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"common"],[2,[7,"/"],[2,[6,"user_select"],[2,[7,"/"],[2,[6,"user_type_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/companion/qr_svg(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companion_qr_svg_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"companion"],[2,[7,"/"],[2,[6,"qr_svg"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/save_evaluation/:note_id/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} note_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const concept_evaluation_save_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"note_id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"save_evaluation"],[2,[7,"/"],[2,[3,"note_id"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)(/:programme_identifier)/confirm_enter_new_password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_enter_new_password_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[1,[2,[7,"/"],[3,"programme_identifier"]]],[2,[7,"/"],[2,[6,"confirm_enter_new_password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)(/:programme_identifier)/confirm_login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_login_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[1,[2,[7,"/"],[3,"programme_identifier"]]],[2,[7,"/"],[2,[6,"confirm_login"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)(/:programme_identifier)/confirm_reset_password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_reset_password_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[1,[2,[7,"/"],[3,"programme_identifier"]]],[2,[7,"/"],[2,[6,"confirm_reset_password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/crash(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const crash_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"crash"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/create_application/:programme_id/:person_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} person_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_application_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"person_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"create_application"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[3,"person_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/:id/clone(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_clone_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/:dashboard_id/clone_widget/:widget_id(.:format)
 * @param {any} programme_identifier
 * @param {any} dashboard_id
 * @param {any} widget_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_clone_widget_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"dashboard_id":{"r":true},"widget_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[3,"dashboard_id"],[2,[7,"/"],[2,[6,"clone_widget"],[2,[7,"/"],[2,[3,"widget_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/create(/:type)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"type":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[6,"create"],[2,[1,[2,[7,"/"],[3,"type"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/:dashboard_id/create_widget/:type(.:format)
 * @param {any} programme_identifier
 * @param {any} dashboard_id
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_create_widget_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"dashboard_id":{"r":true},"type":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[3,"dashboard_id"],[2,[7,"/"],[2,[6,"create_widget"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/:id/delete(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/:id/edit(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/:id/edit_user_types(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_edit_user_types_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_user_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/:id/edit_widgets(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_edit_widgets_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_widgets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/:id/widget/:widget_id/get_datasource_data/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} widget_id
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_get_datasource_data_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"widget_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"widget"],[2,[7,"/"],[2,[3,"widget_id"],[2,[7,"/"],[2,[6,"get_datasource_data"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/:id/datasource/:datasource_id/widget/:widget_id/dependent_dashboard(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} datasource_id
 * @param {any} widget_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_get_datasource_dependent_dashboard_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"datasource_id":{"r":true},"widget_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"datasource"],[2,[7,"/"],[2,[3,"datasource_id"],[2,[7,"/"],[2,[6,"widget"],[2,[7,"/"],[2,[3,"widget_id"],[2,[7,"/"],[2,[6,"dependent_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/:id/get_datasources/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_get_datasources_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_datasources"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/:id/get_widgets/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_get_widgets_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_widgets"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dashboard(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_legacy_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dashboard/:id/clone(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_legacy_clone_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dashboard/create(/:type)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_legacy_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"type":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"create"],[2,[1,[2,[7,"/"],[3,"type"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dashboard/:id/delete(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_legacy_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dashboard/:id/edit(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_legacy_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dashboard/:id/edit_user_types(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_legacy_edit_user_types_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_user_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dashboard/:id/edit_widgets(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_legacy_edit_widgets_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_widgets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dashboard/:id/get_widgets(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_legacy_get_widgets_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_widgets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dashboard/list(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_legacy_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dashboard/load_map_state/:country_code(.:format)
 * @param {any} programme_identifier
 * @param {any} country_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_legacy_load_map_state_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"country_code":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"load_map_state"],[2,[7,"/"],[2,[3,"country_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dashboard/new(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_legacy_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dashboard/:id/pdf(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_legacy_pdf_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dashboard/:id/show(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_legacy_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dashboard/:id/update(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_legacy_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dashboard/:id/update_user_types(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_legacy_update_user_types_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_user_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dashboard/:id/update_widgets(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_legacy_update_widgets_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_widgets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/list(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/:id/list_datasource(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_list_datasource_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"list_datasource"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/list_existing_datasource(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_list_existing_datasource_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[6,"list_existing_datasource"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/load_map_state/:country_code(.:format)
 * @param {any} programme_identifier
 * @param {any} country_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_load_map_state_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"country_code":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[6,"load_map_state"],[2,[7,"/"],[2,[3,"country_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/migrate_gen2/:legacy_dashboard_id(.:format)
 * @param {any} programme_identifier
 * @param {any} legacy_dashboard_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_migrate_gen2_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"legacy_dashboard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[6,"migrate_gen2"],[2,[7,"/"],[2,[3,"legacy_dashboard_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/new(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/:id/pdf(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_pdf_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/project/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_project_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/project_filter/my_projects(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_project_filter_my_projects_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[6,"project_filter"],[2,[7,"/"],[2,[6,"my_projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/project_filter/preset/:preset_id(.:format)
 * @param {any} programme_identifier
 * @param {any} preset_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_project_filter_preset_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"preset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[6,"project_filter"],[2,[7,"/"],[2,[6,"preset"],[2,[7,"/"],[2,[3,"preset_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/:id/refresh_datasources/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_refresh_datasources_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refresh_datasources"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/:dashboard_id/search_existing_widgets(.:format)
 * @param {any} programme_identifier
 * @param {any} dashboard_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_search_existing_widgets_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"dashboard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[3,"dashboard_id"],[2,[7,"/"],[2,[6,"search_existing_widgets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/:id/show(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/:id/update(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/:id/global_theme/update(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_update_global_theme_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"global_theme"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/:id/update_layout(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_update_layout_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_layout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/:dashboard_id/widget/:widget_id/update_settings(.:format)
 * @param {any} programme_identifier
 * @param {any} dashboard_id
 * @param {any} widget_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_update_settings_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"dashboard_id":{"r":true},"widget_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[3,"dashboard_id"],[2,[7,"/"],[2,[6,"widget"],[2,[7,"/"],[2,[3,"widget_id"],[2,[7,"/"],[2,[6,"update_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/:id/update_user_types(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_update_user_types_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_user_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/data_capture_log(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_capture_log_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"data_capture_log"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/data_capture_log/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_capture_log_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"data_capture_log"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/add_row/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_add_row_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_row"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/api_client_endpoint_list_json(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_api_client_endpoint_list_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"api_client_endpoint_list_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/clone(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_clone_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dg/collection/create(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_collection_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dg"],[2,[7,"/"],[2,[6,"collection"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dg/collection/:id/delete(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_collection_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dg"],[2,[7,"/"],[2,[6,"collection"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dg/collection/:id/edit(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_collection_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dg"],[2,[7,"/"],[2,[6,"collection"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dg/collection/:id/get(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_collection_get_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dg"],[2,[7,"/"],[2,[6,"collection"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dg/collection/list(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_collection_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dg"],[2,[7,"/"],[2,[6,"collection"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dg/collection/new(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_collection_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dg"],[2,[7,"/"],[2,[6,"collection"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dg/collection/:id/show(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_collection_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dg"],[2,[7,"/"],[2,[6,"collection"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dg/collection/:id/update(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_collection_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dg"],[2,[7,"/"],[2,[6,"collection"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/column_rows_for_select/:datagrid_col_id(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} datagrid_col_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_column_rows_for_select_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"datagrid_col_id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[6,"column_rows_for_select"],[2,[7,"/"],[2,[3,"datagrid_col_id"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/configured_add_row/:project_id/:key(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} project_id
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_configured_add_row_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{"r":true},"key":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"configured_add_row"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"key"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:datagrid_id/bulk_action/create(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} datagrid_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_create_bulk_action_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"datagrid_id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"datagrid_id"],[2,[7,"/"],[2,[6,"bulk_action"],[2,[7,"/"],[2,[6,"create"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/create_datagrid(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_create_datagrid_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[6,"create_datagrid"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:datagrid_id/preset/create(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} datagrid_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_create_preset_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"datagrid_id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"datagrid_id"],[2,[7,"/"],[2,[6,"preset"],[2,[7,"/"],[2,[6,"create"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:datagrid_id/bulk_action/processing_status(.:format)
 * @param {any} programme_identifier
 * @param {any} datagrid_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_current_bulk_action_task_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"datagrid_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"datagrid_id"],[2,[7,"/"],[2,[6,"bulk_action"],[2,[7,"/"],[2,[6,"processing_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/delete(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/delete_col(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_delete_col_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_col"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/delete_data(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_delete_data_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_data"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:datagrid_id/preset/:id/delete(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} datagrid_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_delete_preset_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"datagrid_id":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"datagrid_id"],[2,[7,"/"],[2,[6,"preset"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid_draft/:id/get(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_draft_get_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid_draft"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid_draft/:id/get_component_props_json(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_draft_get_component_props_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid_draft"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_component_props_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid_draft/:id(/:project_id)/show(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_draft_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid_draft"],[2,[7,"/"],[2,[3,"id"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[2,[7,"/"],[2,[6,"show"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid_draft/:id/update_rows/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_draft_update_rows_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid_draft"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_rows"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/edit(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/edit_details(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_edit_details_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_details"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid_excel_import_configs/:id/clone(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_excel_import_config_clone_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid_excel_import_configs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid_excel_import_configs(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_excel_import_config_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid_excel_import_configs"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid_excel_import_configs/:id/delete(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_excel_import_config_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid_excel_import_configs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid_excel_import_configs(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_excel_import_config_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid_excel_import_configs"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid_excel_import_configs/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_excel_import_config_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid_excel_import_configs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid_excel_import_configs/:id/toggle_enabled(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_excel_import_config_toggle_enabled_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid_excel_import_configs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_enabled"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid_excel_import_configs/:id/update(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_excel_import_config_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid_excel_import_configs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid_excel_import_config/list(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_excel_import_configs_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid_excel_import_config"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid_excel_import_config/selectable_configurations(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_excel_import_selectable_configurations_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid_excel_import_config"],[2,[7,"/"],[2,[6,"selectable_configurations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/export_rows/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_export_rows_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export_rows"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_form_context(/:programme_form_id)/definitions(/:programme_form_link_id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_form_context_definitions_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_form_id":{},"programme_form_link_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_form_context"],[2,[1,[2,[7,"/"],[3,"programme_form_id"]]],[2,[7,"/"],[2,[6,"definitions"],[2,[1,[2,[7,"/"],[3,"programme_form_link_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/general_list(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_general_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[6,"general_list"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/general_list_schema(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_general_list_schema_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[6,"general_list_schema"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/get(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_get_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/get_cells_for_column/:datagrid_col_id/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} datagrid_col_id
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_get_cells_for_column_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"datagrid_col_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_cells_for_column"],[2,[7,"/"],[2,[3,"datagrid_col_id"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:datagrid_id/get_component_props_json(.:format)
 * @param {any} programme_identifier
 * @param {any} datagrid_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_get_component_props_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"datagrid_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"datagrid_id"],[2,[7,"/"],[2,[6,"get_component_props_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/get_datagrid(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_get_datagrid_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[6,"get_datagrid"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/get_details(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_get_details_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_details"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/get_dg_permissions(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_get_dg_permissions_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_dg_permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/get_flattened_rows(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_get_flattened_rows_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_flattened_rows"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/get_grouped_rows_by_preset/:datagrid_preset_id/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} datagrid_preset_id
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_get_grouped_rows_by_preset_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"datagrid_preset_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_grouped_rows_by_preset"],[2,[7,"/"],[2,[3,"datagrid_preset_id"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/get/import_config/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_get_import_config_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get"],[2,[7,"/"],[2,[6,"import_config"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/get_navigation_tabs(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_get_navigation_tabs_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_navigation_tabs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/get_row/:project_id/:row_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} project_id
 * @param {any} row_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_get_row_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{"r":true},"row_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_row"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"row_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/get_row_for_programme_form/:datagrid_row_id/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} datagrid_row_id
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_get_row_for_programme_form_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"datagrid_row_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_row_for_programme_form"],[2,[7,"/"],[2,[3,"datagrid_row_id"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/get_rows_for_specific_column/:datagrid_col_id/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} datagrid_col_id
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_get_rows_for_specific_column_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"datagrid_col_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_rows_for_specific_column"],[2,[7,"/"],[2,[3,"datagrid_col_id"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dg/grouped_value/create(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_grouped_value_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dg"],[2,[7,"/"],[2,[6,"grouped_value"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dg/grouped_value/:id/get(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_grouped_value_get_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dg"],[2,[7,"/"],[2,[6,"grouped_value"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dg/grouped_value/list(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_grouped_value_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dg"],[2,[7,"/"],[2,[6,"grouped_value"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dg/grouped_value/:id/update(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_grouped_value_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dg"],[2,[7,"/"],[2,[6,"grouped_value"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/import_rows/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_import_rows_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"import_rows"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/indicator/:id/output(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_indicator_output_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[6,"indicator"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"output"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/list(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[6,"list"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/list_json(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_list_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[6,"list_json"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/mark_as_partitioned(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_mark_as_partitioned_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_partitioned"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:datagrid_id/preset/modify_presets_in_batch(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} datagrid_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_modify_presets_in_batch_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"datagrid_id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"datagrid_id"],[2,[7,"/"],[2,[6,"preset"],[2,[7,"/"],[2,[6,"modify_presets_in_batch"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/nbr_of_rows(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_nbr_of_rows_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"nbr_of_rows"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:datagrid_id/bulk_action/nbr_of_rows(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} datagrid_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_nbr_of_rows_bulk_action_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"datagrid_id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"datagrid_id"],[2,[7,"/"],[2,[6,"bulk_action"],[2,[7,"/"],[2,[6,"nbr_of_rows"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/recalculate_formula(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_recalculate_formula_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"recalculate_formula"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/results_as_per_preset/:datagrid_preset_id/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} datagrid_preset_id
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_results_as_per_preset_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"datagrid_preset_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"results_as_per_preset"],[2,[7,"/"],[2,[3,"datagrid_preset_id"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/schema_options_for_select(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_schema_options_for_select_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"schema_options_for_select"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/select_options_json(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_select_options_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[6,"select_options_json"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id(/:project_id)/show(/:schema)(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"schema":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[2,[7,"/"],[2,[6,"show"],[2,[1,[2,[7,"/"],[3,"schema"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id(/:project_id)/show_match_basket/:match_basket_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} match_basket_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_show_match_basket_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"match_basket_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[2,[7,"/"],[2,[6,"show_match_basket"],[2,[7,"/"],[2,[3,"match_basket_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id(/:project_id)/structure(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_structure_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[2,[7,"/"],[2,[6,"structure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/test_formula(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_test_formula_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"test_formula"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/toggle_schema(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_toggle_schema_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_schema"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/update(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/update_default_preset(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_update_default_preset_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_default_preset"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/update_dg_permissions(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_update_dg_permissions_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_dg_permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/update/import_config/:project_id(/:config_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_update_import_config_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{"r":true},"config_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update"],[2,[7,"/"],[2,[6,"import_config"],[2,[7,"/"],[2,[3,"project_id"],[2,[1,[2,[7,"/"],[3,"config_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/update_navigation_tabs(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_update_navigation_tabs_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_navigation_tabs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/update_order(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_update_order_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_order"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:datagrid_id/preset/:id/update(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} datagrid_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_update_preset_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"datagrid_id":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"datagrid_id"],[2,[7,"/"],[2,[6,"preset"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/update_row/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_update_row_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_row"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/update_rows/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_update_rows_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_rows"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/datagrid/:id/update_selection_array(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datagrid_update_selection_array_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_selection_array"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dataset/clone/:uuid(.:format)
 * @param {any} programme_identifier
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataset_clone_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"uuid":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dataset"],[2,[7,"/"],[2,[6,"clone"],[2,[7,"/"],[2,[3,"uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dataset/delete/:uuid(.:format)
 * @param {any} programme_identifier
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataset_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"uuid":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dataset"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dataset/edit(/:uuid)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataset_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"uuid":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dataset"],[2,[7,"/"],[2,[6,"edit"],[2,[1,[2,[7,"/"],[3,"uuid"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dataset/form_options(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataset_form_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dataset"],[2,[7,"/"],[2,[6,"form_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dataset/get/:uuid(.:format)
 * @param {any} programme_identifier
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataset_get_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"uuid":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dataset"],[2,[7,"/"],[2,[6,"get"],[2,[7,"/"],[2,[3,"uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dataset/get_calculated_data(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataset_get_calculated_data_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dataset"],[2,[7,"/"],[2,[6,"get_calculated_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dataset/get_data/:uuid(/:output)(.:format)
 * @param {any} programme_identifier
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataset_get_data_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"uuid":{"r":true},"output":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dataset"],[2,[7,"/"],[2,[6,"get_data"],[2,[7,"/"],[2,[3,"uuid"],[2,[1,[2,[7,"/"],[3,"output"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dataset/get_datagrid_cols(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataset_get_datagrid_cols_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dataset"],[2,[7,"/"],[2,[6,"get_datagrid_cols"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dataset/get_input_data(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataset_get_input_data_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dataset"],[2,[7,"/"],[2,[6,"get_input_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dataset/get_source_labels(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataset_get_source_labels_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dataset"],[2,[7,"/"],[2,[6,"get_source_labels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dataset/list(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataset_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dataset"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dataset/list_filter_options/:source(.:format)
 * @param {any} programme_identifier
 * @param {any} source
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataset_list_filter_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"source":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dataset"],[2,[7,"/"],[2,[6,"list_filter_options"],[2,[7,"/"],[2,[3,"source"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dataset/list_group_by_options/:source(.:format)
 * @param {any} programme_identifier
 * @param {any} source
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataset_list_group_by_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"source":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dataset"],[2,[7,"/"],[2,[6,"list_group_by_options"],[2,[7,"/"],[2,[3,"source"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dataset/list_json(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataset_list_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dataset"],[2,[7,"/"],[2,[6,"list_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dataset/list_outputs_json(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataset_list_outputs_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dataset"],[2,[7,"/"],[2,[6,"list_outputs_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dataset/list_source_values(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataset_list_source_values_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dataset"],[2,[7,"/"],[2,[6,"list_source_values"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dataset/refresh(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataset_refresh_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dataset"],[2,[7,"/"],[2,[6,"refresh"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dataset/:id/show(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataset_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dataset"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dataset/update(/:uuid)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataset_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"uuid":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dataset"],[2,[7,"/"],[2,[6,"update"],[2,[1,[2,[7,"/"],[3,"uuid"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dataset/update_output_sort_model/:uuid(.:format)
 * @param {any} programme_identifier
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataset_update_output_sort_model_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"uuid":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dataset"],[2,[7,"/"],[2,[6,"update_output_sort_model"],[2,[7,"/"],[2,[3,"uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/:id/v2/datasources(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datasource_v2_create_datasource_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"datasources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/:id/v2/datasources(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datasource_v2_datasources_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"datasources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/:id/widget/:widget_id/v2/query(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} widget_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datasource_v2_query_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"widget_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"widget"],[2,[7,"/"],[2,[3,"widget_id"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"query"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/:id/v2/datasources/:datasource_id/refresh(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} datasource_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datasource_v2_refresh_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"datasource_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"datasources"],[2,[7,"/"],[2,[3,"datasource_id"],[2,[7,"/"],[2,[6,"refresh"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/:id/v2/datasources/:datasource_id/schema(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} datasource_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datasource_v2_schema_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"datasource_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"datasources"],[2,[7,"/"],[2,[3,"datasource_id"],[2,[7,"/"],[2,[6,"schema"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/:id/v2/sources(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datasource_v2_sources_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/:id/widget/:widget_id/v2/ssrm(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} widget_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datasource_v2_ssrm_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"widget_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"widget"],[2,[7,"/"],[2,[3,"widget_id"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"ssrm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dash/:id/widget/:widget_id/v2/settings(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} widget_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datasource_v2_update_widget_settings_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"widget_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"widget"],[2,[7,"/"],[2,[3,"widget_id"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/zabbix/delayed_jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delayed_job_count_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"zabbix"],[2,[7,"/"],[2,[6,"delayed_jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/evaluator_ai/delete_evaluation(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_ai_evaluation_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"evaluator_ai"],[2,[7,"/"],[2,[6,"delete_evaluation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/:project_id/delete_internal_file/:file_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_internal_project_file_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"file_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"delete_internal_file"],[2,[7,"/"],[2,[3,"file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/:project_id/delete_file/:file_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_project_file_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"file_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"delete_file"],[2,[7,"/"],[2,[3,"file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dimensions/categories/create(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dimension_category_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dimensions"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dimensions/categories/:category_id/delete(.:format)
 * @param {any} programme_identifier
 * @param {any} category_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dimension_category_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"category_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dimensions"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dimensions/categories/:category_id/update(.:format)
 * @param {any} programme_identifier
 * @param {any} category_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dimension_category_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"category_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dimensions"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dimensions/create(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dimension_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dimensions"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dimensions/:dimension_id/delete(.:format)
 * @param {any} programme_identifier
 * @param {any} dimension_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dimension_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"dimension_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dimensions"],[2,[7,"/"],[2,[3,"dimension_id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dimensions(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dimension_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dimensions"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dimensions/json(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dimension_list_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dimensions"],[2,[7,"/"],[2,[6,"json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dimensions/:dimension_id/update(.:format)
 * @param {any} programme_identifier
 * @param {any} dimension_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dimension_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"dimension_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dimensions"],[2,[7,"/"],[2,[3,"dimension_id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/dimensions/:dimension_id/update_use_in(.:format)
 * @param {any} programme_identifier
 * @param {any} dimension_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dimension_update_use_in_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"dimension_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"dimensions"],[2,[7,"/"],[2,[3,"dimension_id"],[2,[7,"/"],[2,[6,"update_use_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/discussion/create_comment(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discussion_create_comment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"discussion"],[2,[7,"/"],[2,[6,"create_comment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/discussion/delete_comment(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discussion_delete_comment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"discussion"],[2,[7,"/"],[2,[6,"delete_comment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/discussion/list_comments(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discussion_list_comments_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"discussion"],[2,[7,"/"],[2,[6,"list_comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/discussion/reply_input(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discussion_reply_input_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"discussion"],[2,[7,"/"],[2,[6,"reply_input"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/docai/thread_json/:thread_id(.:format)
 * @param {any} programme_identifier
 * @param {any} thread_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const docai_thread_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"thread_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"docai"],[2,[7,"/"],[2,[6,"thread_json"],[2,[7,"/"],[2,[3,"thread_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/docs/auth(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const docs_auth_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"auth"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/docusign_envelope_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const docusign_envelope_status_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"docusign_envelope_status"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/support/download_comment_attachment(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_comment_attachment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"download_comment_attachment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/:project_id/download_file/:file_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_project_file_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"file_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"download_file"],[2,[7,"/"],[2,[3,"file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/:project_id/download_internal_file/:file_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_project_internal_file_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"file_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"download_internal_file"],[2,[7,"/"],[2,[3,"file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/callback/ypa(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const e_authorization_callback_ypa_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"callback"],[2,[7,"/"],[2,[6,"ypa"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/register/ypa(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const e_authorization_register_ypa_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"register"],[2,[7,"/"],[2,[6,"ypa"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/stop_session/ypa(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const e_authorization_stop_organization_session_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"stop_session"],[2,[7,"/"],[2,[6,"ypa"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/companion/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_companion_preferences_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"companion"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/partners/edit_details/:code(.:format)
 * @param {any} programme_identifier
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_partner_details_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"code":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[6,"edit_details"],[2,[7,"/"],[2,[3,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/:project_id/edit_internal_file/:file_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_project_internal_file_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"file_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"edit_internal_file"],[2,[7,"/"],[2,[3,"file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/:project_id/edit_internal_file_permission/:file_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_project_internal_file_permission_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"file_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"edit_internal_file_permission"],[2,[7,"/"],[2,[3,"file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/:project_id/edit_shared_file/:file_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_project_shared_file_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"file_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"edit_shared_file"],[2,[7,"/"],[2,[3,"file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)(/:programme_identifier)/enter_new_password/:auth_code(.:format)
 * @param {any} auth_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enter_new_password_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{},"auth_code":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[1,[2,[7,"/"],[3,"programme_identifier"]]],[2,[7,"/"],[2,[6,"enter_new_password"],[2,[7,"/"],[2,[3,"auth_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/evaluator_ai/form_data_json(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const evaluation_form_data_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"evaluator_ai"],[2,[7,"/"],[2,[6,"form_data_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_call_phase/evaluation_summary_email/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const evaluation_summary_email_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_call_phase"],[2,[7,"/"],[2,[6,"evaluation_summary_email"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/event_feed_content_templates/:programme_id/edit(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const event_feed_content_template_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"event_feed_content_templates"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/event_feed_content_templates/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const event_feed_content_template_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"event_feed_content_templates"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/event_feed_content_templates/:programme_id/preview(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const event_feed_content_template_preview_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"event_feed_content_templates"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/event_feed_content_templates/:programme_id/reset(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const event_feed_content_template_reset_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"event_feed_content_templates"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/event_feed_content_templates/:programme_id/update(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const event_feed_content_template_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"event_feed_content_templates"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/event_feed/list/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const event_feed_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"event_feed"],[2,[7,"/"],[2,[6,"list"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/event_feed_setting/:person_id/list(.:format)
 * @param {any} programme_identifier
 * @param {any} person_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const event_feed_setting_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"person_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"event_feed_setting"],[2,[7,"/"],[2,[3,"person_id"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/event_feed_setting/:person_id/update(.:format)
 * @param {any} programme_identifier
 * @param {any} person_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const event_feed_setting_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"person_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"event_feed_setting"],[2,[7,"/"],[2,[3,"person_id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/smartme_academy/open(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ext_open_smartme_academy_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"smartme_academy"],[2,[7,"/"],[2,[6,"open"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/evaluation/evaluate/:project_id/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_evaluation_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"evaluation"],[2,[7,"/"],[2,[6,"evaluate"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/evaluation/support/create/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_evaluator_create_support_case_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"evaluation"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"create"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/evaluation/evaluation_summary/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_evaluator_evaluation_summary_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"evaluation"],[2,[7,"/"],[2,[6,"evaluation_summary"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/evaluation/evaluation_summary_data/:call_id/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} call_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_evaluator_evaluation_summary_data_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"evaluation"],[2,[7,"/"],[2,[6,"evaluation_summary_data"],[2,[7,"/"],[2,[3,"call_id"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/evaluation(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_evaluator_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"evaluation"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/evaluation/list/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_evaluator_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"evaluation"],[2,[7,"/"],[2,[6,"list"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/evaluation/list_phases(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_evaluator_list_phases_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"evaluation"],[2,[7,"/"],[2,[6,"list_phases"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/evaluation/summary/:note_id/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} note_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_evaluator_summary_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"note_id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"evaluation"],[2,[7,"/"],[2,[6,"summary"],[2,[7,"/"],[2,[3,"note_id"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/evaluation/support(/:case_id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_evaluator_support_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"case_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"evaluation"],[2,[7,"/"],[2,[6,"support"],[2,[1,[2,[7,"/"],[3,"case_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/faq/create/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const faq_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"faq"],[2,[7,"/"],[2,[6,"create"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/faq/delete/:programme_id/:faq_content_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} faq_content_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const faq_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"faq_content_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"faq"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[3,"faq_content_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/faq/delete_document/:programme_id/:file_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const faq_delete_document_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"file_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"faq"],[2,[7,"/"],[2,[6,"delete_document"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[3,"file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/faq/edit/:programme_id/:faq_content_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} faq_content_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const faq_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"faq_content_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"faq"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[3,"faq_content_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/faq/get_document/:programme_id/:file_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const faq_get_document_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"file_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"faq"],[2,[7,"/"],[2,[6,"get_document"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[3,"file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/faq/get_documents/:programme_id(/:for)(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const faq_get_documents_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"for":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"faq"],[2,[7,"/"],[2,[6,"get_documents"],[2,[7,"/"],[2,[3,"programme_id"],[2,[1,[2,[7,"/"],[3,"for"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/faq/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const faq_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"faq"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/faq/new/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const faq_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"faq"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/faq/preview/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const faq_preview_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"faq"],[2,[7,"/"],[2,[6,"preview"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/faq/update/:programme_id/:faq_content_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} faq_content_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const faq_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"faq_content_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"faq"],[2,[7,"/"],[2,[6,"update"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[3,"faq_content_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/faq/update_sort_order/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const faq_update_sort_order_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"faq"],[2,[7,"/"],[2,[6,"update_sort_order"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/faq/upload_document/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const faq_upload_document_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"faq"],[2,[7,"/"],[2,[6,"upload_document"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/feedback_submit/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feedback_submit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"feedback_submit"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/field_selector/fields(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_selector_list_form_fields_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"field_selector"],[2,[7,"/"],[2,[6,"fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/field_selector/forms(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_selector_list_forms_with_links_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"field_selector"],[2,[7,"/"],[2,[6,"forms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/:project_id/file_repository/:folder_id/add_restrictions(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_repository_add_restrictions_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"folder_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"file_repository"],[2,[7,"/"],[2,[3,"folder_id"],[2,[7,"/"],[2,[6,"add_restrictions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/:project_id/file_repository/assignable_users_json(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_repository_assignable_users_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"file_repository"],[2,[7,"/"],[2,[6,"assignable_users_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/:project_id/file_repository/:folder_id/file/create(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_repository_create_file_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"folder_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"file_repository"],[2,[7,"/"],[2,[3,"folder_id"],[2,[7,"/"],[2,[6,"file"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/:project_id/file_repository/folder/create(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_repository_create_folder_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"file_repository"],[2,[7,"/"],[2,[6,"folder"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/:project_id/file_repository/default_folder/:type(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_repository_default_folder_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"type":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"file_repository"],[2,[7,"/"],[2,[6,"default_folder"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/:project_id/file_repository/:folder_id/file/:file_id/delete(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} folder_id
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_repository_delete_file_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"folder_id":{"r":true},"file_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"file_repository"],[2,[7,"/"],[2,[3,"folder_id"],[2,[7,"/"],[2,[6,"file"],[2,[7,"/"],[2,[3,"file_id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/:project_id/file_repository/:folder_id/delete_restriction/:restriction_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} folder_id
 * @param {any} restriction_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_repository_delete_restriction_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"folder_id":{"r":true},"restriction_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"file_repository"],[2,[7,"/"],[2,[3,"folder_id"],[2,[7,"/"],[2,[6,"delete_restriction"],[2,[7,"/"],[2,[3,"restriction_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/:project_id/file_repository/favorite_status/:file_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_repository_favorite_status_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"file_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"file_repository"],[2,[7,"/"],[2,[6,"favorite_status"],[2,[7,"/"],[2,[3,"file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/:project_id/file_repository/file_name_is_unique(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_repository_file_name_is_unique_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"file_repository"],[2,[7,"/"],[2,[6,"file_name_is_unique"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/:project_id/file_repository/folder/:folder_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_repository_folder_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"folder_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"file_repository"],[2,[7,"/"],[2,[6,"folder"],[2,[7,"/"],[2,[3,"folder_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/:project_id/file_repository/folder_details_json/:folder_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_repository_folder_details_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"folder_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"file_repository"],[2,[7,"/"],[2,[6,"folder_details_json"],[2,[7,"/"],[2,[3,"folder_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/:project_id/file_repository/folder_files_json/:folder_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_repository_folder_files_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"folder_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"file_repository"],[2,[7,"/"],[2,[6,"folder_files_json"],[2,[7,"/"],[2,[3,"folder_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/:project_id/file_repository/folders_json(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_repository_folders_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"file_repository"],[2,[7,"/"],[2,[6,"folders_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/:project_id/file_repository/get_file_url/:file_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_repository_get_file_url_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"file_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"file_repository"],[2,[7,"/"],[2,[6,"get_file_url"],[2,[7,"/"],[2,[3,"file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/:project_id/file_repository/log_file_access/:file_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_repository_log_file_access_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"file_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"file_repository"],[2,[7,"/"],[2,[6,"log_file_access"],[2,[7,"/"],[2,[3,"file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/:project_id/file_repository/:folder_id/manage_restrictions(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_repository_manage_restrictions_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"folder_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"file_repository"],[2,[7,"/"],[2,[3,"folder_id"],[2,[7,"/"],[2,[6,"manage_restrictions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/:project_id/file_repository/my_files_json(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_repository_my_files_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"file_repository"],[2,[7,"/"],[2,[6,"my_files_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/:project_id/file_repository/recent_files_json(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_repository_recent_files_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"file_repository"],[2,[7,"/"],[2,[6,"recent_files_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/:project_id/file_repository/search(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_repository_search_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"file_repository"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/:project_id/file_repository/shared_files_json(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_repository_shared_files_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"file_repository"],[2,[7,"/"],[2,[6,"shared_files_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/:project_id/file_repository(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_repository_space_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"file_repository"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/:project_id/file_repository/starred_files_json(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_repository_starred_files_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"file_repository"],[2,[7,"/"],[2,[6,"starred_files_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/:project_id/file_repository/toggle_favorite/:file_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_repository_toggle_file_favorite_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"file_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"file_repository"],[2,[7,"/"],[2,[6,"toggle_favorite"],[2,[7,"/"],[2,[3,"file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/:project_id/file_repository/folder/update(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_repository_update_folder_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"file_repository"],[2,[7,"/"],[2,[6,"folder"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/:project_id/file_repository/:folder_id/update_restricted_visibility(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_repository_update_restricted_visibility_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"folder_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"file_repository"],[2,[7,"/"],[2,[3,"folder_id"],[2,[7,"/"],[2,[6,"update_restricted_visibility"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/:project_id/file_repository/update_tags(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_repository_update_tags_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"file_repository"],[2,[7,"/"],[2,[6,"update_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/financial_datagrid/:id/clone(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const financial_datagrid_clone_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"financial_datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/financial_datagrid/create_datagrid(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const financial_datagrid_create_datagrid_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"financial_datagrid"],[2,[7,"/"],[2,[6,"create_datagrid"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/financial_datagrid/:id/delete(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const financial_datagrid_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"financial_datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/financial_datagrid/:id/delete_data(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const financial_datagrid_delete_data_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"financial_datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_data"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/financial_datagrid/:id/edit(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const financial_datagrid_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"financial_datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/financial_datagrid/:id/edit_details(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const financial_datagrid_edit_details_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"financial_datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_details"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/financial_datagrid/general_list(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const financial_datagrid_general_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"financial_datagrid"],[2,[7,"/"],[2,[6,"general_list"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/financial_datagrid/:id/get(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const financial_datagrid_get_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"financial_datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/financial_datagrid/get_datagrid(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const financial_datagrid_get_datagrid_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"financial_datagrid"],[2,[7,"/"],[2,[6,"get_datagrid"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/financial_datagrid/:id/get_details(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const financial_datagrid_get_details_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"financial_datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_details"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/financial_datagrid/list(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const financial_datagrid_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"financial_datagrid"],[2,[7,"/"],[2,[6,"list"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/financial_datagrid/list_json(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const financial_datagrid_list_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"financial_datagrid"],[2,[7,"/"],[2,[6,"list_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/financial_datagrid/:id(/:project_id)/show(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const financial_datagrid_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"financial_datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[2,[7,"/"],[2,[6,"show"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/financial_datagrid/:id/update(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const financial_datagrid_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"financial_datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/form/create_comment/:programme_form_link_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_form_link_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const form_comment_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_form_link_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"form"],[2,[7,"/"],[2,[6,"create_comment"],[2,[7,"/"],[2,[3,"programme_form_link_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/form/delete_comment/:programme_form_link_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_form_link_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const form_comment_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_form_link_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"form"],[2,[7,"/"],[2,[6,"delete_comment"],[2,[7,"/"],[2,[3,"programme_form_link_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/form/edit_comment/:programme_form_link_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_form_link_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const form_comment_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_form_link_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"form"],[2,[7,"/"],[2,[6,"edit_comment"],[2,[7,"/"],[2,[3,"programme_form_link_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/form/get_comments/:programme_form_link_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_form_link_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const form_comment_get_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_form_link_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"form"],[2,[7,"/"],[2,[6,"get_comments"],[2,[7,"/"],[2,[3,"programme_form_link_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/form/get_comment_author/:author_id(.:format)
 * @param {any} programme_identifier
 * @param {any} author_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const form_comment_get_author_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"author_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"form"],[2,[7,"/"],[2,[6,"get_comment_author"],[2,[7,"/"],[2,[3,"author_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/form/toggle_thread_comment/:programme_form_link_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_form_link_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const form_comment_toggle_thread_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_form_link_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"form"],[2,[7,"/"],[2,[6,"toggle_thread_comment"],[2,[7,"/"],[2,[3,"programme_form_link_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/format_params(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const format_params_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"format_params"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /(:locale)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const front_page_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[7,"/"],[2,[1,[3,"locale"]],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/geo_json/create(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const geo_json_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"geo_json"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/geo_json/delete/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const geo_json_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"geo_json"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/geo_json/edit/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const geo_json_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"geo_json"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/geo_json/get/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const geo_json_get_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"geo_json"],[2,[7,"/"],[2,[6,"get"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/geo_json/list(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const geo_json_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"geo_json"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/geo_json/new(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const geo_json_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"geo_json"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/geo_json/update/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const geo_json_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"geo_json"],[2,[7,"/"],[2,[6,"update"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/get_attachment_token(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_attachment_token_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"get_attachment_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/grant_contract/new/:project_id/:upload_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} upload_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const grant_contract_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"upload_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"grant_contract"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"upload_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/grant_contract/attachment/:attachment/:contract_id(.:format)
 * @param {any} programme_identifier
 * @param {any} attachment
 * @param {any} contract_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const grant_contract_download_attachment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"attachment":{"r":true},"contract_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"grant_contract"],[2,[7,"/"],[2,[6,"attachment"],[2,[7,"/"],[2,[3,"attachment"],[2,[7,"/"],[2,[3,"contract_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/grant_contract/new/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const grant_contract_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"grant_contract"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/grant_contract/show/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const grant_contract_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"grant_contract"],[2,[7,"/"],[2,[6,"show"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/grant_contract/upload/:project_id/:upload_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} upload_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const grant_contract_upload_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"upload_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"grant_contract"],[2,[7,"/"],[2,[6,"upload"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"upload_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_call_phase/:phase_id/grant_extension_period/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const grant_extension_period_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_call_phase"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[6,"grant_extension_period"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/hide_old_browser_notification(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hide_old_browser_notification_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hide_old_browser_notification"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/indicator_value/copy_to_datagrid/:project_id/:indicator_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} indicator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const indicator_value_copy_to_datagrid_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"indicator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"indicator_value"],[2,[7,"/"],[2,[6,"copy_to_datagrid"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"indicator_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/indicator_value/delete/:indicator_id(.:format)
 * @param {any} programme_identifier
 * @param {any} indicator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const indicator_value_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"indicator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"indicator_value"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"indicator_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/indicator_value/delete_qualitative/:indicator_id(.:format)
 * @param {any} programme_identifier
 * @param {any} indicator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const indicator_value_delete_qualitative_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"indicator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"indicator_value"],[2,[7,"/"],[2,[6,"delete_qualitative"],[2,[7,"/"],[2,[3,"indicator_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/indicator_value/disaggregations_json/:project_id/:indicator_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} indicator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const indicator_value_disaggregations_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"indicator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"indicator_value"],[2,[7,"/"],[2,[6,"disaggregations_json"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"indicator_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/indicator_value/get_entity_columns_for_record/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const indicator_value_get_entity_columns_for_record_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"indicator_value"],[2,[7,"/"],[2,[6,"get_entity_columns_for_record"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/indicator_value_import/indicator_data(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const indicator_value_import_get_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"indicator_value_import"],[2,[7,"/"],[2,[6,"indicator_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/indicator_value_import/record_value(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const indicator_value_import_record_value_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"indicator_value_import"],[2,[7,"/"],[2,[6,"record_value"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/indicator_value/list/:project_id(/:date)(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const indicator_value_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"date":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"indicator_value"],[2,[7,"/"],[2,[6,"list"],[2,[7,"/"],[2,[3,"project_id"],[2,[1,[2,[7,"/"],[3,"date"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/indicator_value/list_all_json/:project_id/:indicator_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} indicator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const indicator_value_list_all_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"indicator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"indicator_value"],[2,[7,"/"],[2,[6,"list_all_json"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"indicator_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/indicator_value/list_indicators_and_values/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const indicator_value_list_indicators_and_values_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"indicator_value"],[2,[7,"/"],[2,[6,"list_indicators_and_values"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/indicator_value/list_json/:project_id(/:date)(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const indicator_value_list_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"date":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"indicator_value"],[2,[7,"/"],[2,[6,"list_json"],[2,[7,"/"],[2,[3,"project_id"],[2,[1,[2,[7,"/"],[3,"date"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/indicator_value/open_file/qualitative/:filename/:qualitative_indicator_value_id(.:format)
 * @param {any} programme_identifier
 * @param {any} filename
 * @param {any} qualitative_indicator_value_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const indicator_value_open_qualitative_file_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"filename":{"r":true},"qualitative_indicator_value_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"indicator_value"],[2,[7,"/"],[2,[6,"open_file"],[2,[7,"/"],[2,[6,"qualitative"],[2,[7,"/"],[2,[3,"filename"],[2,[7,"/"],[2,[3,"qualitative_indicator_value_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/indicator_value/pdf/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const indicator_value_pdf_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"indicator_value"],[2,[7,"/"],[2,[6,"pdf"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/indicator_value/perform_record/:project_id/:indicator_id(/:date)(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} indicator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const indicator_value_perform_record_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"indicator_id":{"r":true},"date":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"indicator_value"],[2,[7,"/"],[2,[6,"perform_record"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"indicator_id"],[2,[1,[2,[7,"/"],[3,"date"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/indicator_value/recalculate_values/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const indicator_value_recalculate_values_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"indicator_value"],[2,[7,"/"],[2,[6,"recalculate_values"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/indicator_value/show/:indicator_id(.:format)
 * @param {any} programme_identifier
 * @param {any} indicator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const indicator_value_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"indicator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"indicator_value"],[2,[7,"/"],[2,[6,"show"],[2,[7,"/"],[2,[3,"indicator_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/indicator_value/show_activity/:activity_status_id(.:format)
 * @param {any} programme_identifier
 * @param {any} activity_status_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const indicator_value_show_activity_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"activity_status_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"indicator_value"],[2,[7,"/"],[2,[6,"show_activity"],[2,[7,"/"],[2,[3,"activity_status_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/indicator_value/show_all/:project_id/:indicator_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} indicator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const indicator_value_show_all_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"indicator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"indicator_value"],[2,[7,"/"],[2,[6,"show_all"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"indicator_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/indicator_value/sync_external_values/:indicator_id(.:format)
 * @param {any} programme_identifier
 * @param {any} indicator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const indicator_value_sync_external_values_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"indicator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"indicator_value"],[2,[7,"/"],[2,[6,"sync_external_values"],[2,[7,"/"],[2,[3,"indicator_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/indicator_value/update/:indicator_id(.:format)
 * @param {any} programme_identifier
 * @param {any} indicator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const indicator_value_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"indicator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"indicator_value"],[2,[7,"/"],[2,[6,"update"],[2,[7,"/"],[2,[3,"indicator_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/indicator_value/update_labels(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const indicator_value_update_labels_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"indicator_value"],[2,[7,"/"],[2,[6,"update_labels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/indicator_value/update_qualitative/:indicator_id(.:format)
 * @param {any} programme_identifier
 * @param {any} indicator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const indicator_value_update_qualitative_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"indicator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"indicator_value"],[2,[7,"/"],[2,[6,"update_qualitative"],[2,[7,"/"],[2,[3,"indicator_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/indicator_value/update_statuses(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const indicator_value_update_statuses_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"indicator_value"],[2,[7,"/"],[2,[6,"update_statuses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/indicator_value/upload_file/:project_id/:upload_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} upload_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const indicator_value_upload_file_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"upload_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"indicator_value"],[2,[7,"/"],[2,[6,"upload_file"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"upload_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/indicator_value/value_set_options/:project_id/:indicator_id/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} indicator_id
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const indicator_value_value_set_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"indicator_id":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"indicator_value"],[2,[7,"/"],[2,[6,"value_set_options"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"indicator_id"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/integration/entity/get/:entity_id(.:format)
 * @param {any} programme_identifier
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integration_get_entity_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"integration"],[2,[7,"/"],[2,[6,"entity"],[2,[7,"/"],[2,[6,"get"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/integration/entity_accessors/get/:object_type(.:format)
 * @param {any} programme_identifier
 * @param {any} object_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integration_get_entity_accessors_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"object_type":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"integration"],[2,[7,"/"],[2,[6,"entity_accessors"],[2,[7,"/"],[2,[6,"get"],[2,[7,"/"],[2,[3,"object_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/integration/entity_form/get/:form_id(.:format)
 * @param {any} programme_identifier
 * @param {any} form_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integration_get_entity_form_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"form_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"integration"],[2,[7,"/"],[2,[6,"entity_form"],[2,[7,"/"],[2,[6,"get"],[2,[7,"/"],[2,[3,"form_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/integration/get_dependency_map(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integration_get_external_entity_dependency_map_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"integration"],[2,[7,"/"],[2,[6,"get_dependency_map"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/integrations(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integration_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/integration/endpoint/list(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integration_list_endpoints_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"integration"],[2,[7,"/"],[2,[6,"endpoint"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/integration/entity/list/:object_type(.:format)
 * @param {any} programme_identifier
 * @param {any} object_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integration_list_entities_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"object_type":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"integration"],[2,[7,"/"],[2,[6,"entity"],[2,[7,"/"],[2,[6,"list"],[2,[7,"/"],[2,[3,"object_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/integration/entity/list/project/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integration_list_entities_for_project_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"integration"],[2,[7,"/"],[2,[6,"entity"],[2,[7,"/"],[2,[6,"list"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/integration/entity_form/list/:object_type(.:format)
 * @param {any} programme_identifier
 * @param {any} object_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integration_list_entity_forms_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"object_type":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"integration"],[2,[7,"/"],[2,[6,"entity_form"],[2,[7,"/"],[2,[6,"list"],[2,[7,"/"],[2,[3,"object_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/integration/endpoint/perform_sync/:api_client_id/:endpoint(.:format)
 * @param {any} programme_identifier
 * @param {any} api_client_id
 * @param {any} endpoint
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integration_perform_sync_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"api_client_id":{"r":true},"endpoint":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"integration"],[2,[7,"/"],[2,[6,"endpoint"],[2,[7,"/"],[2,[6,"perform_sync"],[2,[7,"/"],[2,[3,"api_client_id"],[2,[7,"/"],[2,[3,"endpoint"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/integration/endpoint/sync/:api_client_id/:endpoint(.:format)
 * @param {any} programme_identifier
 * @param {any} api_client_id
 * @param {any} endpoint
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integration_sync_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"api_client_id":{"r":true},"endpoint":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"integration"],[2,[7,"/"],[2,[6,"endpoint"],[2,[7,"/"],[2,[6,"sync"],[2,[7,"/"],[2,[3,"api_client_id"],[2,[7,"/"],[2,[3,"endpoint"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/integration/trigger/mark_confirmed(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integration_trigger_queue_mark_confirmed_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"integration"],[2,[7,"/"],[2,[6,"trigger"],[2,[7,"/"],[2,[6,"mark_confirmed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/kms/:space_identifier/access/:page_id(.:format)
 * @param {any} programme_identifier
 * @param {any} space_identifier
 * @param {any} page_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kms_access_page_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"space_identifier":{"r":true},"page_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"kms"],[2,[7,"/"],[2,[3,"space_identifier"],[2,[7,"/"],[2,[6,"access"],[2,[7,"/"],[2,[3,"page_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/kms/activity_hook/:token(.:format)
 * @param {any} programme_identifier
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kms_activity_hook_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"token":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"kms"],[2,[7,"/"],[2,[6,"activity_hook"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/kms/:space_identifier/page/create/:parent_id(.:format)
 * @param {any} programme_identifier
 * @param {any} space_identifier
 * @param {any} parent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kms_create_page_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"space_identifier":{"r":true},"parent_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"kms"],[2,[7,"/"],[2,[3,"space_identifier"],[2,[7,"/"],[2,[6,"page"],[2,[7,"/"],[2,[6,"create"],[2,[7,"/"],[2,[3,"parent_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/kms/:space_identifier/root_page/create(.:format)
 * @param {any} programme_identifier
 * @param {any} space_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kms_create_root_page_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"space_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"kms"],[2,[7,"/"],[2,[3,"space_identifier"],[2,[7,"/"],[2,[6,"root_page"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/kms/:space_identifier/page/:page_id/delete(.:format)
 * @param {any} programme_identifier
 * @param {any} space_identifier
 * @param {any} page_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kms_delete_page_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"space_identifier":{"r":true},"page_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"kms"],[2,[7,"/"],[2,[3,"space_identifier"],[2,[7,"/"],[2,[6,"page"],[2,[7,"/"],[2,[3,"page_id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/kms/:space_identifier/page/:page_id/edit(.:format)
 * @param {any} programme_identifier
 * @param {any} space_identifier
 * @param {any} page_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kms_edit_page_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"space_identifier":{"r":true},"page_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"kms"],[2,[7,"/"],[2,[3,"space_identifier"],[2,[7,"/"],[2,[6,"page"],[2,[7,"/"],[2,[3,"page_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/kms/:space_identifier/page/:page_id(.:format)
 * @param {any} programme_identifier
 * @param {any} space_identifier
 * @param {any} page_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kms_page_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"space_identifier":{"r":true},"page_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"kms"],[2,[7,"/"],[2,[3,"space_identifier"],[2,[7,"/"],[2,[6,"page"],[2,[7,"/"],[2,[3,"page_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/kms/:space_identifier/page/:page_id/attachments(.:format)
 * @param {any} programme_identifier
 * @param {any} space_identifier
 * @param {any} page_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kms_page_attachments_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"space_identifier":{"r":true},"page_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"kms"],[2,[7,"/"],[2,[3,"space_identifier"],[2,[7,"/"],[2,[6,"page"],[2,[7,"/"],[2,[3,"page_id"],[2,[7,"/"],[2,[6,"attachments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/kms/:space_identifier/page_hierarchy(.:format)
 * @param {any} programme_identifier
 * @param {any} space_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kms_page_hierarchy_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"space_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"kms"],[2,[7,"/"],[2,[3,"space_identifier"],[2,[7,"/"],[2,[6,"page_hierarchy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/kms/:space_identifier/page/:page_id/permissions(.:format)
 * @param {any} programme_identifier
 * @param {any} space_identifier
 * @param {any} page_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kms_page_permissions_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"space_identifier":{"r":true},"page_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"kms"],[2,[7,"/"],[2,[3,"space_identifier"],[2,[7,"/"],[2,[6,"page"],[2,[7,"/"],[2,[3,"page_id"],[2,[7,"/"],[2,[6,"permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/:programme_id/kms(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kms_programme_space_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"kms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/kms/:space_identifier/project_options(.:format)
 * @param {any} programme_identifier
 * @param {any} space_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kms_project_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"space_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"kms"],[2,[7,"/"],[2,[3,"space_identifier"],[2,[7,"/"],[2,[6,"project_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/kms/:space_identifier/root_page_children/:page_id(.:format)
 * @param {any} programme_identifier
 * @param {any} space_identifier
 * @param {any} page_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kms_root_page_children_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"space_identifier":{"r":true},"page_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"kms"],[2,[7,"/"],[2,[3,"space_identifier"],[2,[7,"/"],[2,[6,"root_page_children"],[2,[7,"/"],[2,[3,"page_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/kms/:space_identifier/page/:page_id/save(.:format)
 * @param {any} programme_identifier
 * @param {any} space_identifier
 * @param {any} page_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kms_save_page_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"space_identifier":{"r":true},"page_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"kms"],[2,[7,"/"],[2,[3,"space_identifier"],[2,[7,"/"],[2,[6,"page"],[2,[7,"/"],[2,[3,"page_id"],[2,[7,"/"],[2,[6,"save"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/:programme_id/kms_settings(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kms_settings_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"kms_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/kms/:space_identifier(.:format)
 * @param {any} programme_identifier
 * @param {any} space_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kms_space_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"space_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"kms"],[2,[7,"/"],[2,[3,"space_identifier"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/kms/:space_identifier/page/:page_id/update_order/:new_id(.:format)
 * @param {any} programme_identifier
 * @param {any} space_identifier
 * @param {any} page_id
 * @param {any} new_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kms_update_order_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"space_identifier":{"r":true},"page_id":{"r":true},"new_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"kms"],[2,[7,"/"],[2,[3,"space_identifier"],[2,[7,"/"],[2,[6,"page"],[2,[7,"/"],[2,[3,"page_id"],[2,[7,"/"],[2,[6,"update_order"],[2,[7,"/"],[2,[3,"new_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/kms/:space_identifier/page/update(/:parent_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} space_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kms_update_page_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"space_identifier":{"r":true},"parent_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"kms"],[2,[7,"/"],[2,[3,"space_identifier"],[2,[7,"/"],[2,[6,"page"],[2,[7,"/"],[2,[6,"update"],[2,[1,[2,[7,"/"],[3,"parent_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/kms/:space_identifier/page/:page_id/update_permissions(.:format)
 * @param {any} programme_identifier
 * @param {any} space_identifier
 * @param {any} page_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kms_update_page_permissions_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"space_identifier":{"r":true},"page_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"kms"],[2,[7,"/"],[2,[3,"space_identifier"],[2,[7,"/"],[2,[6,"page"],[2,[7,"/"],[2,[3,"page_id"],[2,[7,"/"],[2,[6,"update_permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/kms/:space_identifier/page/:page_id/update_parent/:parent_id(.:format)
 * @param {any} programme_identifier
 * @param {any} space_identifier
 * @param {any} page_id
 * @param {any} parent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kms_update_parent_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"space_identifier":{"r":true},"page_id":{"r":true},"parent_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"kms"],[2,[7,"/"],[2,[3,"space_identifier"],[2,[7,"/"],[2,[6,"page"],[2,[7,"/"],[2,[3,"page_id"],[2,[7,"/"],[2,[6,"update_parent"],[2,[7,"/"],[2,[3,"parent_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/kms/:space_identifier/page/update_root_order/:root_id/:reorder_id(.:format)
 * @param {any} programme_identifier
 * @param {any} space_identifier
 * @param {any} root_id
 * @param {any} reorder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kms_update_root_order_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"space_identifier":{"r":true},"root_id":{"r":true},"reorder_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"kms"],[2,[7,"/"],[2,[3,"space_identifier"],[2,[7,"/"],[2,[6,"page"],[2,[7,"/"],[2,[6,"update_root_order"],[2,[7,"/"],[2,[3,"root_id"],[2,[7,"/"],[2,[3,"reorder_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/kms/:space_identifier/page/:page_id/user_types(.:format)
 * @param {any} programme_identifier
 * @param {any} space_identifier
 * @param {any} page_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kms_user_types_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"space_identifier":{"r":true},"page_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"kms"],[2,[7,"/"],[2,[3,"space_identifier"],[2,[7,"/"],[2,[6,"page"],[2,[7,"/"],[2,[3,"page_id"],[2,[7,"/"],[2,[6,"user_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/:project_id/list_files(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const list_project_files_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"list_files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/live_discussion/create_message/:discussion_id(.:format)
 * @param {any} programme_identifier
 * @param {any} discussion_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const live_discussion_create_message_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"discussion_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"live_discussion"],[2,[7,"/"],[2,[6,"create_message"],[2,[7,"/"],[2,[3,"discussion_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/live_discussion/delete_message/:message_id(.:format)
 * @param {any} programme_identifier
 * @param {any} message_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const live_discussion_delete_message_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"message_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"live_discussion"],[2,[7,"/"],[2,[6,"delete_message"],[2,[7,"/"],[2,[3,"message_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/live_discussion/delete_thread/:discussion_id(.:format)
 * @param {any} programme_identifier
 * @param {any} discussion_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const live_discussion_delete_thread_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"discussion_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"live_discussion"],[2,[7,"/"],[2,[6,"delete_thread"],[2,[7,"/"],[2,[3,"discussion_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/live_discussion/edit_message/:message_id(.:format)
 * @param {any} programme_identifier
 * @param {any} message_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const live_discussion_edit_message_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"message_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"live_discussion"],[2,[7,"/"],[2,[6,"edit_message"],[2,[7,"/"],[2,[3,"message_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/live_discussion/get_old_messages/:discussion_id/:old_message_id(.:format)
 * @param {any} programme_identifier
 * @param {any} discussion_id
 * @param {any} old_message_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const live_discussion_get_old_messages_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"discussion_id":{"r":true},"old_message_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"live_discussion"],[2,[7,"/"],[2,[6,"get_old_messages"],[2,[7,"/"],[2,[3,"discussion_id"],[2,[7,"/"],[2,[3,"old_message_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/live_discussion/get_props(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const live_discussion_get_props_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"live_discussion"],[2,[7,"/"],[2,[6,"get_props"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/live_discussion/get_threads_json/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const live_discussion_get_threads_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"live_discussion"],[2,[7,"/"],[2,[6,"get_threads_json"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/live_discussion/get_unread_discussions/:target_type/:target_id(.:format)
 * @param {any} programme_identifier
 * @param {any} target_type
 * @param {any} target_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const live_discussion_get_unread_discussions_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"target_type":{"r":true},"target_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"live_discussion"],[2,[7,"/"],[2,[6,"get_unread_discussions"],[2,[7,"/"],[2,[3,"target_type"],[2,[7,"/"],[2,[3,"target_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/live_discussion/init_messages/:target_type/:target_id/:discussion_type(.:format)
 * @param {any} programme_identifier
 * @param {any} target_type
 * @param {any} target_id
 * @param {any} discussion_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const live_discussion_init_messages_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"target_type":{"r":true},"target_id":{"r":true},"discussion_type":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"live_discussion"],[2,[7,"/"],[2,[6,"init_messages"],[2,[7,"/"],[2,[3,"target_type"],[2,[7,"/"],[2,[3,"target_id"],[2,[7,"/"],[2,[3,"discussion_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/live_discussion/initiate_thread/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const live_discussion_initiate_thread_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"live_discussion"],[2,[7,"/"],[2,[6,"initiate_thread"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/live_discussion/mark_target_read/:target_type/:target_id(.:format)
 * @param {any} programme_identifier
 * @param {any} target_type
 * @param {any} target_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const live_discussion_mark_target_read_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"target_type":{"r":true},"target_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"live_discussion"],[2,[7,"/"],[2,[6,"mark_target_read"],[2,[7,"/"],[2,[3,"target_type"],[2,[7,"/"],[2,[3,"target_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/live_discussion/project/:project_id/project_report_total_message/:target_type/:target_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} target_type
 * @param {any} target_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const live_discussion_project_report_total_message_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"target_type":{"r":true},"target_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"live_discussion"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project_report_total_message"],[2,[7,"/"],[2,[3,"target_type"],[2,[7,"/"],[2,[3,"target_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/live_discussion/reopen_thread/:discussion_id(.:format)
 * @param {any} programme_identifier
 * @param {any} discussion_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const live_discussion_reopen_thread_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"discussion_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"live_discussion"],[2,[7,"/"],[2,[6,"reopen_thread"],[2,[7,"/"],[2,[3,"discussion_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)(/:programme_identifier)/login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const login_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[1,[2,[7,"/"],[3,"programme_identifier"]]],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/login_link_sent(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const login_link_sent_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"login_link_sent"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)(/:programme_identifier)/login_message/:message(.:format)
 * @param {any} message
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const login_message_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{},"message":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[1,[2,[7,"/"],[3,"programme_identifier"]]],[2,[7,"/"],[2,[6,"login_message"],[2,[7,"/"],[2,[3,"message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)(/:programme_identifier)/logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logout_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[1,[2,[7,"/"],[3,"programme_identifier"]]],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/auth_result(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const long_running_task_auth_result_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"auth_result"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/long_running_task/clear_all(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const long_running_task_clear_all_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"long_running_task"],[2,[7,"/"],[2,[6,"clear_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/long_running_task/:id/delete(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const long_running_task_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"long_running_task"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/long_running_task/list_json(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const long_running_task_list_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"long_running_task"],[2,[7,"/"],[2,[6,"list_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/long_running_task/:id/mark_as_read_toggle(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const long_running_task_mark_as_read_toggle_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"long_running_task"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_read_toggle"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/long_running_task/:id/retry(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const long_running_task_retry_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"long_running_task"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/long_running_task_status_update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const long_running_task_status_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"long_running_task_status_update"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/match_basket/:match_basket_id/:datagrid_id/resolve/:datagrid_row_id(.:format)
 * @param {any} programme_identifier
 * @param {any} match_basket_id
 * @param {any} datagrid_id
 * @param {any} datagrid_row_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const match_basket_resolve_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"match_basket_id":{"r":true},"datagrid_id":{"r":true},"datagrid_row_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"match_basket"],[2,[7,"/"],[2,[3,"match_basket_id"],[2,[7,"/"],[2,[3,"datagrid_id"],[2,[7,"/"],[2,[6,"resolve"],[2,[7,"/"],[2,[3,"datagrid_row_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/match_basket/:match_basket_id/:datagrid_id/row_data(.:format)
 * @param {any} programme_identifier
 * @param {any} match_basket_id
 * @param {any} datagrid_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const match_basket_row_data_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"match_basket_id":{"r":true},"datagrid_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"match_basket"],[2,[7,"/"],[2,[3,"match_basket_id"],[2,[7,"/"],[2,[3,"datagrid_id"],[2,[7,"/"],[2,[6,"row_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/match_basket/run_comparison/:datagrid_id(.:format)
 * @param {any} programme_identifier
 * @param {any} datagrid_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const match_basket_run_comparison_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"datagrid_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"match_basket"],[2,[7,"/"],[2,[6,"run_comparison"],[2,[7,"/"],[2,[3,"datagrid_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/match_baskets/:datagrid_id(.:format)
 * @param {any} programme_identifier
 * @param {any} datagrid_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const match_baskets_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"datagrid_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"match_baskets"],[2,[7,"/"],[2,[3,"datagrid_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/match_threads/:match_basket_id(.:format)
 * @param {any} programme_identifier
 * @param {any} match_basket_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const match_programme_threads_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"match_basket_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"match_threads"],[2,[7,"/"],[2,[3,"match_basket_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/match_thread/create_message(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const match_thread_create_message_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"match_thread"],[2,[7,"/"],[2,[6,"create_message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/match_thread/:thread_hash/edit_message(.:format)
 * @param {any} programme_identifier
 * @param {any} thread_hash
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const match_thread_edit_message_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"thread_hash":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"match_thread"],[2,[7,"/"],[2,[3,"thread_hash"],[2,[7,"/"],[2,[6,"edit_message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/match_thread/get_messages(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const match_thread_get_messages_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"match_thread"],[2,[7,"/"],[2,[6,"get_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/match_thread/:thread_hash/:datagrid_id/row_ids(.:format)
 * @param {any} programme_identifier
 * @param {any} thread_hash
 * @param {any} datagrid_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const match_thread_get_row_ids_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"thread_hash":{"r":true},"datagrid_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"match_thread"],[2,[7,"/"],[2,[3,"thread_hash"],[2,[7,"/"],[2,[3,"datagrid_id"],[2,[7,"/"],[2,[6,"row_ids"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/match_threads/:datagrid_id/:match_basket_id(.:format)
 * @param {any} programme_identifier
 * @param {any} datagrid_id
 * @param {any} match_basket_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const match_threads_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"datagrid_id":{"r":true},"match_basket_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"match_threads"],[2,[7,"/"],[2,[3,"datagrid_id"],[2,[7,"/"],[2,[3,"match_basket_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/mfa_logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mfa_logout_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"mfa_logout"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)(/:programme_identifier)/mfa_confirm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mfa_view_code_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[1,[2,[7,"/"],[3,"programme_identifier"]]],[2,[7,"/"],[2,[6,"mfa_confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/mobile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mobile_qr_view_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"mobile"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/activity_discussion/:activity_id(.:format)
 * @param {any} programme_identifier
 * @param {any} activity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_activity_discussion_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"activity_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"activity_discussion"],[2,[7,"/"],[2,[3,"activity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/activity_row/:project_id/:activity_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} activity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_activity_row_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"activity_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"activity_row"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"activity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/column_settings(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_column_settings_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"column_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/confirm_payment/:payment_id(.:format)
 * @param {any} programme_identifier
 * @param {any} payment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_confirm_payment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"payment_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"confirm_payment"],[2,[7,"/"],[2,[3,"payment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/project/create(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/create_payment/:project_id/:payment_contract_id/:payment_type_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} payment_contract_id
 * @param {any} payment_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_create_payment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"payment_contract_id":{"r":true},"payment_type_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"create_payment"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"payment_contract_id"],[2,[7,"/"],[2,[3,"payment_type_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/create_support_case/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_create_support_case_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"create_support_case"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/project/create_with_owner(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_create_with_owner_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"create_with_owner"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/dashboard_data/call_status/:call_id(.:format)
 * @param {any} programme_identifier
 * @param {any} call_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_dashboard_call_status_data_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"dashboard_data"],[2,[7,"/"],[2,[6,"call_status"],[2,[7,"/"],[2,[3,"call_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/dashboard/list_calls/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_dashboard_list_calls_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"list_calls"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/dashboard/list_phases/:project_id/:call_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} call_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_dashboard_list_phases_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"call_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"list_phases"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"call_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/dashboard/list_reports/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_dashboard_list_reports_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"list_reports"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/dashboard/payments/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_dashboard_payments_data_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/dashboard_data/phase_progress/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_dashboard_phase_progress_data_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"dashboard_data"],[2,[7,"/"],[2,[6,"phase_progress"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/dashboard_data/report_status/:report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_dashboard_report_status_data_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"dashboard_data"],[2,[7,"/"],[2,[6,"report_status"],[2,[7,"/"],[2,[3,"report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/dashboard/sdg_widget/:project_id/:random(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} random
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_dashboard_sdg_widget_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"random":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"sdg_widget"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"random"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/delete_payment/:payment_id(.:format)
 * @param {any} programme_identifier
 * @param {any} payment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_delete_payment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"payment_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"delete_payment"],[2,[7,"/"],[2,[3,"payment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/deliverables_module/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_deliverables_module_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"deliverables_module"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/edit_activity_status/:activity_id(.:format)
 * @param {any} programme_identifier
 * @param {any} activity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_edit_activity_status_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"activity_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"edit_activity_status"],[2,[7,"/"],[2,[3,"activity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/edit_indicator_history_value/:indicator_value_id(.:format)
 * @param {any} programme_identifier
 * @param {any} indicator_value_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_edit_indicator_history_value_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"indicator_value_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"edit_indicator_history_value"],[2,[7,"/"],[2,[3,"indicator_value_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/edit_indicator_value/:indicator_value_id(.:format)
 * @param {any} programme_identifier
 * @param {any} indicator_value_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_edit_indicator_value_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"indicator_value_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"edit_indicator_value"],[2,[7,"/"],[2,[3,"indicator_value_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/edit_payment/:payment_id(.:format)
 * @param {any} programme_identifier
 * @param {any} payment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_edit_payment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"payment_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"edit_payment"],[2,[7,"/"],[2,[3,"payment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/export_excel_payments/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_export_excel_payments_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"export_excel_payments"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/fact_sheet/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_fact_sheet_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"fact_sheet"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/faq/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_faq_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"faq"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/indicator_value/show_all/:project_id/:indicator_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} indicator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_indicator_value_show_all_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"indicator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"indicator_value"],[2,[7,"/"],[2,[6,"show_all"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"indicator_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/indicator_value/update_hidden_fields/:project_id/:indicator_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} indicator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_indicator_value_update_hidden_fields_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"indicator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"indicator_value"],[2,[7,"/"],[2,[6,"update_hidden_fields"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"indicator_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/indicator_value/update_visible_entity_type/:project_id/:indicator_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} indicator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_indicator_value_update_visible_entity_type_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"indicator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"indicator_value"],[2,[7,"/"],[2,[6,"update_visible_entity_type"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"indicator_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/indicators/:project_id(/:date)(/:timeline_end_date)(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_indicators_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"date":{},"timeline_end_date":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"indicators"],[2,[7,"/"],[2,[3,"project_id"],[2,[1,[2,[7,"/"],[3,"date"]]],[2,[1,[2,[7,"/"],[3,"timeline_end_date"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/info/:project_id(/:tab)(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_info_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"tab":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[3,"project_id"],[2,[1,[2,[7,"/"],[3,"tab"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/list(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"list"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/list_files/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_list_files_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"list_files"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/list_page(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_list_page_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"list_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/list_payments_for_selection_json/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_list_payments_for_selection_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"list_payments_for_selection_json"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/list_payments_json/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_list_payments_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"list_payments_json"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/milestones/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_milestones_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/project/new(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/new_payment/:project_id/:payment_contract_id/:payment_type_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} payment_contract_id
 * @param {any} payment_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_new_payment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"payment_contract_id":{"r":true},"payment_type_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"new_payment"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"payment_contract_id"],[2,[7,"/"],[2,[3,"payment_type_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/payment_files/:payment_id(.:format)
 * @param {any} programme_identifier
 * @param {any} payment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_payment_files_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"payment_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"payment_files"],[2,[7,"/"],[2,[3,"payment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/payments/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_payments_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/payments_data_json/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_payments_data_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"payments_data_json"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/payments/:project_id/update_visible_columns(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_payments_update_visible_columns_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"update_visible_columns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/perform_confirm_payment/:payment_id(.:format)
 * @param {any} programme_identifier
 * @param {any} payment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_perform_confirm_payment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"payment_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"perform_confirm_payment"],[2,[7,"/"],[2,[3,"payment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/perform_request_payment_confirmation/:payment_id(.:format)
 * @param {any} programme_identifier
 * @param {any} payment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_perform_request_payment_confirmation_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"payment_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"perform_request_payment_confirmation"],[2,[7,"/"],[2,[3,"payment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/programme_payments/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_programme_payments_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"programme_payments"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/programme_progress/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_programme_progress_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"programme_progress"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/project_info/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_project_info_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"project_info"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/project_progress/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_project_progress_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"project_progress"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/project_selector_list(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_project_selector_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"project_selector_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/add_batch(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_add_batch_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_batch"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/add_data_capture/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_add_data_capture_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_data_capture"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/add_form_capture_config_link/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_add_form_capture_config_link_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_form_capture_config_link"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/add_restrictions(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_add_restrictions_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_restrictions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/analysis(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_analysis_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"analysis"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/assign_surveys(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_assign_surveys_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign_surveys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/assigned_surveys_links(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_assigned_surveys_links_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assigned_surveys_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/change_history(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_change_history_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/clone(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_clone_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/create(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/create_batch(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_create_batch_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_batch"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/create_follow_up_surveys/:target_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} target_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_create_follow_up_surveys_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"target_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_follow_up_surveys"],[2,[7,"/"],[2,[3,"target_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/delete(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/delete_data_capture/:phase_id/:data_capture_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} phase_id
 * @param {any} data_capture_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_delete_data_capture_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"phase_id":{"r":true},"data_capture_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_data_capture"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[3,"data_capture_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/delete_form(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_delete_form_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_form"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/delete_form_capture_config_link/:phase_id/:form_capture_config_link_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} phase_id
 * @param {any} form_capture_config_link_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_delete_form_capture_config_link_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"phase_id":{"r":true},"form_capture_config_link_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_form_capture_config_link"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[3,"form_capture_config_link_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/delete_prefill_context/:phase_id/:prefill_context_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} phase_id
 * @param {any} prefill_context_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_delete_prefill_context_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"phase_id":{"r":true},"prefill_context_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_prefill_context"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[3,"prefill_context_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/delete_restriction/:restriction_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} restriction_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_delete_restriction_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"restriction_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_restriction"],[2,[7,"/"],[2,[3,"restriction_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/edit(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/get_form_field_content(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_get_form_field_content_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_form_field_content"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/import_excel(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_import_excel_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"import_excel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/latest_report/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_latest_report_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"latest_report"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/list_reports(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_list_reports_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"list_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/manage_restrictions(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_manage_restrictions_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"manage_restrictions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/new(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/previous_form_capture_config_links/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_previous_form_capture_config_links_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"previous_form_capture_config_links"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/previous_form_fields/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_previous_form_fields_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"previous_form_fields"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/project_reports(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_project_reports_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"project_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/project_selector_columns(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_project_selector_columns_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"project_selector_columns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/report_request(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_report_request_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"report_request"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/report_requests(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_requests_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"report_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/save_prefill_context/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_save_prefill_context_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"save_prefill_context"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/send_report_request(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_send_report_request_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_report_request"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/set_default_columns(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_set_default_columns_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_default_columns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/set_default_columns(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_set_default_reporting_columns_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"set_default_columns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/show(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor_report_status/dashboard/report_phase_data(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_status_dashboard_report_phase_data_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor_report_status"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"report_phase_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor_report_status/dashboard/workflow_data(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_status_dashboard_workflow_data_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor_report_status"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"workflow_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/survey_assignment_form_options(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_survey_assignment_form_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"survey_assignment_form_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/update(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/update_approval_phase(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_update_approval_phase_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_approval_phase"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/update_form(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_update_form_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_form"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/update_form_order(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_update_form_order_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_form_order"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/update_phase/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_update_phase_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_phase"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/update_phases(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_update_phases_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_phases"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/update_restricted_visibility(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_update_restricted_visibility_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_restricted_visibility"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/:id/update_visible_columns(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_update_visible_columns_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_visible_columns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/update_visible_columns(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_report_update_visible_reporting_columns_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"update_visible_columns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/request_payment_confirmation/:payment_id(.:format)
 * @param {any} programme_identifier
 * @param {any} payment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_request_payment_confirmation_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"payment_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"request_payment_confirmation"],[2,[7,"/"],[2,[3,"payment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/results/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_results_framework_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"results"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/set_list_items_per_page/:items_per_page(.:format)
 * @param {any} programme_identifier
 * @param {any} items_per_page
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_set_list_items_per_page_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"items_per_page":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"set_list_items_per_page"],[2,[7,"/"],[2,[3,"items_per_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reporting/set_list_reports_per_page/:items_per_page(.:format)
 * @param {any} programme_identifier
 * @param {any} items_per_page
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_set_list_reports_per_page_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"items_per_page":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"set_list_reports_per_page"],[2,[7,"/"],[2,[3,"items_per_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/show_support_case/:support_case_id(.:format)
 * @param {any} programme_identifier
 * @param {any} support_case_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_show_support_case_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"support_case_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"show_support_case"],[2,[7,"/"],[2,[3,"support_case_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/support/:project_id/questions(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_support_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"questions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/update_activity_status/:activity_id(.:format)
 * @param {any} programme_identifier
 * @param {any} activity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_update_activity_status_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"activity_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"update_activity_status"],[2,[7,"/"],[2,[3,"activity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/update_indicator_history_value/:indicator_value_id(.:format)
 * @param {any} programme_identifier
 * @param {any} indicator_value_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_update_indicator_history_value_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"indicator_value_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"update_indicator_history_value"],[2,[7,"/"],[2,[3,"indicator_value_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/update_indicator_value/:indicator_value_id(.:format)
 * @param {any} programme_identifier
 * @param {any} indicator_value_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_update_indicator_value_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"indicator_value_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"update_indicator_value"],[2,[7,"/"],[2,[3,"indicator_value_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/update_indicator_value_date/:indicator_value_id(.:format)
 * @param {any} programme_identifier
 * @param {any} indicator_value_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_update_indicator_value_date_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"indicator_value_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"update_indicator_value_date"],[2,[7,"/"],[2,[3,"indicator_value_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/update_payment/:payment_id(.:format)
 * @param {any} programme_identifier
 * @param {any} payment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_update_payment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"payment_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"update_payment"],[2,[7,"/"],[2,[3,"payment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/update_payment_status/:payment_id/:status(.:format)
 * @param {any} programme_identifier
 * @param {any} payment_id
 * @param {any} status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_update_payment_status_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"payment_id":{"r":true},"status":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"update_payment_status"],[2,[7,"/"],[2,[3,"payment_id"],[2,[7,"/"],[2,[3,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/update_support_case_status/:support_case_id/:status(.:format)
 * @param {any} programme_identifier
 * @param {any} support_case_id
 * @param {any} status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_update_support_case_status_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"support_case_id":{"r":true},"status":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"update_support_case_status"],[2,[7,"/"],[2,[3,"support_case_id"],[2,[7,"/"],[2,[3,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/update_visible_columns(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_update_visible_columns_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"update_visible_columns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/user_management/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_user_management_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"user_management"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/work_plan/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_work_plan_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"work_plan"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/new_application/:programme_id/:person_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} person_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_application_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"person_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"new_application"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[3,"person_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/new_application_from_list/:call_id(.:format)
 * @param {any} programme_identifier
 * @param {any} call_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_application_from_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"new_application_from_list"],[2,[7,"/"],[2,[3,"call_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/new_application_from_list_options/:call_id(.:format)
 * @param {any} programme_identifier
 * @param {any} call_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_application_from_list_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"new_application_from_list_options"],[2,[7,"/"],[2,[3,"call_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_call_phase/:phase_id/extension_period/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_extension_period_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_call_phase"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[6,"extension_period"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_source_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/not_found(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const not_found_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"not_found"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/option/:option_set_id/bulk_update(.:format)
 * @param {any} programme_identifier
 * @param {any} option_set_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const option_bulk_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"option_set_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"option"],[2,[7,"/"],[2,[3,"option_set_id"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/option/columns(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const option_columns_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"option"],[2,[7,"/"],[2,[6,"columns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/option/:option_set_id/list_json(.:format)
 * @param {any} programme_identifier
 * @param {any} option_set_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const option_list_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"option_set_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"option"],[2,[7,"/"],[2,[3,"option_set_id"],[2,[7,"/"],[2,[6,"list_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/option/management(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const option_management_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"option"],[2,[7,"/"],[2,[6,"management"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/option_set/create(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const option_set_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"option_set"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/option_set/:option_set_id/delete(.:format)
 * @param {any} programme_identifier
 * @param {any} option_set_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const option_set_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"option_set_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"option_set"],[2,[7,"/"],[2,[3,"option_set_id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/option_set_hierarchy/create(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const option_set_hierarchy_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"option_set_hierarchy"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/option_set_hierarchy/list_json(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const option_set_hierarchy_list_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"option_set_hierarchy"],[2,[7,"/"],[2,[6,"list_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/option_set_hierarchy/management(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const option_set_hierarchy_management_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"option_set_hierarchy"],[2,[7,"/"],[2,[6,"management"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/option_set_hierarchy/:option_set_hierarchy_id/options/move(.:format)
 * @param {any} programme_identifier
 * @param {any} option_set_hierarchy_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const option_set_hierarchy_move_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"option_set_hierarchy_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"option_set_hierarchy"],[2,[7,"/"],[2,[3,"option_set_hierarchy_id"],[2,[7,"/"],[2,[6,"options"],[2,[7,"/"],[2,[6,"move"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/option_set_hierarchy/:option_set_hierarchy_id/nodes(.:format)
 * @param {any} programme_identifier
 * @param {any} option_set_hierarchy_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const option_set_hierarchy_nodes_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"option_set_hierarchy_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"option_set_hierarchy"],[2,[7,"/"],[2,[3,"option_set_hierarchy_id"],[2,[7,"/"],[2,[6,"nodes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/option_set_hierarchy/:option_set_hierarchy_key/selection_options(.:format)
 * @param {any} programme_identifier
 * @param {any} option_set_hierarchy_key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const option_set_hierarchy_selection_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"option_set_hierarchy_key":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"option_set_hierarchy"],[2,[7,"/"],[2,[3,"option_set_hierarchy_key"],[2,[7,"/"],[2,[6,"selection_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/option_set_hierarchy/:option_set_hierarchy_id(.:format)
 * @param {any} programme_identifier
 * @param {any} option_set_hierarchy_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const option_set_hierarchy_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"option_set_hierarchy_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"option_set_hierarchy"],[2,[7,"/"],[2,[3,"option_set_hierarchy_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/option_set_hierarchy/:option_set_hierarchy_key/translation_scopes(.:format)
 * @param {any} programme_identifier
 * @param {any} option_set_hierarchy_key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const option_set_hierarchy_translation_scopes_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"option_set_hierarchy_key":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"option_set_hierarchy"],[2,[7,"/"],[2,[3,"option_set_hierarchy_key"],[2,[7,"/"],[2,[6,"translation_scopes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/option_set_hierarchy/:option_set_hierarchy_id/update(.:format)
 * @param {any} programme_identifier
 * @param {any} option_set_hierarchy_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const option_set_hierarchy_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"option_set_hierarchy_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"option_set_hierarchy"],[2,[7,"/"],[2,[3,"option_set_hierarchy_id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/option_set_hierarchy/:option_set_hierarchy_id/option_sets/update(.:format)
 * @param {any} programme_identifier
 * @param {any} option_set_hierarchy_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const option_set_hierarchy_update_option_sets_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"option_set_hierarchy_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"option_set_hierarchy"],[2,[7,"/"],[2,[3,"option_set_hierarchy_id"],[2,[7,"/"],[2,[6,"option_sets"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/option_set/list_json(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const option_set_list_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"option_set"],[2,[7,"/"],[2,[6,"list_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/option_set/:option_set_id(.:format)
 * @param {any} programme_identifier
 * @param {any} option_set_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const option_set_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"option_set_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"option_set"],[2,[7,"/"],[2,[3,"option_set_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/option_set/:option_locale/:option_set_key(.:format)
 * @param {any} programme_identifier
 * @param {any} option_locale
 * @param {any} option_set_key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const option_set_translations_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"option_locale":{"r":true},"option_set_key":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"option_set"],[2,[7,"/"],[2,[3,"option_locale"],[2,[7,"/"],[2,[3,"option_set_key"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/option_set/:option_set_id/update(.:format)
 * @param {any} programme_identifier
 * @param {any} option_set_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const option_set_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"option_set_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"option_set"],[2,[7,"/"],[2,[3,"option_set_id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/option_set/:option_set_id/usages(.:format)
 * @param {any} programme_identifier
 * @param {any} option_set_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const option_set_usages_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"option_set_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"option_set"],[2,[7,"/"],[2,[3,"option_set_id"],[2,[7,"/"],[2,[6,"usages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/option/:option_locale/:option_set_key/translation/:translation_key(.:format)
 * @param {any} programme_identifier
 * @param {any} option_locale
 * @param {any} option_set_key
 * @param {any} translation_key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const option_translation_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"option_locale":{"r":true},"option_set_key":{"r":true},"translation_key":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"option"],[2,[7,"/"],[2,[3,"option_locale"],[2,[7,"/"],[2,[3,"option_set_key"],[2,[7,"/"],[2,[6,"translation"],[2,[7,"/"],[2,[3,"translation_key"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/organization_datagrid/:datagrid_row_id/bulk_connect_users(.:format)
 * @param {any} programme_identifier
 * @param {any} datagrid_row_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_datagrid_bulk_connect_users_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"datagrid_row_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"organization_datagrid"],[2,[7,"/"],[2,[3,"datagrid_row_id"],[2,[7,"/"],[2,[6,"bulk_connect_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/organization_datagrid/connectable_users(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_datagrid_connectable_users_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"organization_datagrid"],[2,[7,"/"],[2,[6,"connectable_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/organization_datagrid/get(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_datagrid_get_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"organization_datagrid"],[2,[7,"/"],[2,[6,"get"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/organization_datagrid/show(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_datagrid_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"organization_datagrid"],[2,[7,"/"],[2,[6,"show"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/organization_units/bulk_update(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_units_bulk_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"organization_units"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/organization_units(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_units_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"organization_units"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/organization_units/:id/delete(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_units_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"organization_units"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/organization_units(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_units_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"organization_units"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/organization_units/list(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_units_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"organization_units"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/organization_units/:id/move_user(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_units_move_user_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"organization_units"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"move_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/organization_units/:id/update(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_units_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"organization_units"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/partners/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const partner_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/partner_registration(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const partner_registration_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"partner_registration"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/partners/:partner_id/toggle_visibility(.:format)
 * @param {any} programme_identifier
 * @param {any} partner_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const partner_toggle_visibility_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"partner_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[3,"partner_id"],[2,[7,"/"],[2,[6,"toggle_visibility"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/payment_contract/edit/:project_id(/:id)(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payment_contract_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"payment_contract"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"project_id"],[2,[1,[2,[7,"/"],[3,"id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/payment_contract/list_json/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payment_contract_list_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"payment_contract"],[2,[7,"/"],[2,[6,"list_json"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/payment_contract/update/:project_id(/:id)(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payment_contract_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"payment_contract"],[2,[7,"/"],[2,[6,"update"],[2,[7,"/"],[2,[3,"project_id"],[2,[1,[2,[7,"/"],[3,"id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/payment/:id/mark_as_paid(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payment_mark_as_paid_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"payment"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_paid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/payment_type/delete/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payment_type_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"payment_type"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/payment_type/edit(/:id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payment_type_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"payment_type"],[2,[7,"/"],[2,[6,"edit"],[2,[1,[2,[7,"/"],[3,"id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/payment_type/list(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payment_type_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"payment_type"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/payment_type/list_names(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payment_type_list_names_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"payment_type"],[2,[7,"/"],[2,[6,"list_names"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/payment_type/update(/:id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payment_type_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"payment_type"],[2,[7,"/"],[2,[6,"update"],[2,[1,[2,[7,"/"],[3,"id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/pdf/designs/create(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pdf_config_create_design_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"pdf"],[2,[7,"/"],[2,[6,"designs"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/pdf/designs/delete/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pdf_config_delete_design_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"pdf"],[2,[7,"/"],[2,[6,"designs"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/pdf/designs/list(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pdf_config_list_designs_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"pdf"],[2,[7,"/"],[2,[6,"designs"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/perform_partner_registration(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const perform_partner_registration_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"perform_partner_registration"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/tender_notice_phase/perform_send_email/:notice_id(.:format)
 * @param {any} programme_identifier
 * @param {any} notice_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const perform_tender_notice_email_send_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"notice_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"tender_notice_phase"],[2,[7,"/"],[2,[6,"perform_send_email"],[2,[7,"/"],[2,[3,"notice_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/phases/create(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const phase_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"phases"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/phases/:phase_id/delete(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const phase_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"phases"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calls/details/:call_id(.:format)
 * @param {any} programme_identifier
 * @param {any} call_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const phase_management_call_details_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"details"],[2,[7,"/"],[2,[3,"call_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/phase_schemas/:schema_id/clone(.:format)
 * @param {any} programme_identifier
 * @param {any} schema_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const phase_schema_clone_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"schema_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"phase_schemas"],[2,[7,"/"],[2,[3,"schema_id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/phase_schemas/create(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const phase_schema_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"phase_schemas"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/phase_schemas/data(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const phase_schema_data_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"phase_schemas"],[2,[7,"/"],[2,[6,"data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/phase_schemas/:schema_id/delete(.:format)
 * @param {any} programme_identifier
 * @param {any} schema_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const phase_schema_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"schema_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"phase_schemas"],[2,[7,"/"],[2,[3,"schema_id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/phase_schemas/:schema_id/toggle_enabled(.:format)
 * @param {any} programme_identifier
 * @param {any} schema_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const phase_schema_toggle_enabled_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"schema_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"phase_schemas"],[2,[7,"/"],[2,[3,"schema_id"],[2,[7,"/"],[2,[6,"toggle_enabled"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/phase_schema_transitions/create(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const phase_schema_transition_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"phase_schema_transitions"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/phase_schema_transitions/:transition_id/delete(.:format)
 * @param {any} programme_identifier
 * @param {any} transition_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const phase_schema_transition_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"transition_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"phase_schema_transitions"],[2,[7,"/"],[2,[3,"transition_id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/phase_schema_transitions/:transition_id/update(.:format)
 * @param {any} programme_identifier
 * @param {any} transition_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const phase_schema_transition_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"transition_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"phase_schema_transitions"],[2,[7,"/"],[2,[3,"transition_id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/phase_schemas/:schema_id/update(.:format)
 * @param {any} programme_identifier
 * @param {any} schema_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const phase_schema_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"schema_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"phase_schemas"],[2,[7,"/"],[2,[3,"schema_id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/phases/:phase_id/update(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const phase_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"phases"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/pivot_datagrid/:id/add_row/:project_id/:pivot_edit_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} project_id
 * @param {any} pivot_edit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pivot_datagrid_add_row_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{"r":true},"pivot_edit_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"pivot_datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_row"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"pivot_edit_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/pivot_datagrid/:id/configs(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pivot_datagrid_configs_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"pivot_datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"configs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/pivot_datagrid/:id/get(/:project_id)/:pivot_edit_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} pivot_edit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pivot_datagrid_get_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"pivot_edit_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"pivot_datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[2,[7,"/"],[2,[3,"pivot_edit_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/pivot_datagrid/:id(/:project_id)/show/:pivot_edit_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} pivot_edit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pivot_datagrid_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{},"pivot_edit_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"pivot_datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[2,[7,"/"],[2,[6,"show"],[2,[7,"/"],[2,[3,"pivot_edit_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/pivot_datagrid/:id/update_row/:project_id/:pivot_edit_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} project_id
 * @param {any} pivot_edit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pivot_datagrid_update_row_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{"r":true},"pivot_edit_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"pivot_datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_row"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"pivot_edit_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/pivot_datagrid/:id/update_rows/:project_id/:pivot_edit_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} project_id
 * @param {any} pivot_edit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pivot_datagrid_update_rows_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_id":{"r":true},"pivot_edit_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"pivot_datagrid"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_rows"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"pivot_edit_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/appearance/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_appearance_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"appearance"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/appearance_save/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_appearance_save_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"appearance_save"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/communication_form_select/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_communication_form_select_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"communication_form_select"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/communication_logs/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_communication_logs_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"communication_logs"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/communication_logs_json/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_communication_logs_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"communication_logs_json"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/create_color_scheme/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_create_color_scheme_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"create_color_scheme"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/edit_color_scheme/:programme_id/:scheme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} scheme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_edit_color_scheme_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"scheme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"edit_color_scheme"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[3,"scheme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/email_templates/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_email_templates_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"email_templates"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_fact_sheet/browse_form_keys/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_fact_sheet_browse_form_keys_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_fact_sheet"],[2,[7,"/"],[2,[6,"browse_form_keys"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_fact_sheet/delete/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_fact_sheet_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_fact_sheet"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_fact_sheet/edit/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_fact_sheet_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_fact_sheet"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_fact_sheet/form_option_library/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_fact_sheet_form_option_library_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_fact_sheet"],[2,[7,"/"],[2,[6,"form_option_library"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_fact_sheet/edit/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_fact_sheet_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_fact_sheet"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_form/additional_info/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_additional_info_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_form"],[2,[7,"/"],[2,[6,"additional_info"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/:programme_id/browse_form_keys(/:form_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_browse_form_keys_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"form_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"browse_form_keys"],[2,[1,[2,[7,"/"],[3,"form_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/:programme_id/form/clone/:form_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} form_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_clone_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"form_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"form"],[2,[7,"/"],[2,[6,"clone"],[2,[7,"/"],[2,[3,"form_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_form/:programme_id/configure_data_capture/:form_id(/:entity_id/:entity_type)(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} form_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_configure_data_capture_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"form_id":{"r":true},"entity_id":{},"entity_type":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_form"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"configure_data_capture"],[2,[7,"/"],[2,[3,"form_id"],[2,[1,[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[3,"entity_type"]]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/:programme_id/form/new/:category/:type(/:entity_id/:entity_type)(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} category
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"category":{"r":true},"type":{"r":true},"entity_id":{},"entity_type":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"form"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[3,"category"],[2,[7,"/"],[2,[3,"type"],[2,[1,[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[3,"entity_type"]]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/:programme_id/form/delete/:form_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} form_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"form_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"form"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"form_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_form/:programme_id/delete_data_capture_configuration/:form_id/:configuration_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} form_id
 * @param {any} configuration_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_delete_data_capture_configuration_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"form_id":{"r":true},"configuration_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_form"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"delete_data_capture_configuration"],[2,[7,"/"],[2,[3,"form_id"],[2,[7,"/"],[2,[3,"configuration_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_form/download_attachment/:programme_form_link_id/:entity_id/:entity_type(/:person_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_form_link_id
 * @param {any} entity_id
 * @param {any} entity_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_download_attachment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_form_link_id":{"r":true},"entity_id":{"r":true},"entity_type":{"r":true},"person_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_form"],[2,[7,"/"],[2,[6,"download_attachment"],[2,[7,"/"],[2,[3,"programme_form_link_id"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"entity_type"],[2,[1,[2,[7,"/"],[3,"person_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/:programme_id/form/edit/:form_id(/:entity_id/:entity_type)(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} form_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"form_id":{"r":true},"entity_id":{},"entity_type":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"form"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"form_id"],[2,[1,[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[3,"entity_type"]]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_form/export_as_pdf/:programme_form_link_id/:entity_id/:entity_type(/:version)(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_form_link_id
 * @param {any} entity_id
 * @param {any} entity_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_export_as_pdf_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_form_link_id":{"r":true},"entity_id":{"r":true},"entity_type":{"r":true},"version":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_form"],[2,[7,"/"],[2,[6,"export_as_pdf"],[2,[7,"/"],[2,[3,"programme_form_link_id"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"entity_type"],[2,[1,[2,[7,"/"],[3,"version"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_form/get_form_fields/:programme_form_id/:type(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_form_id
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_get_form_fields_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_form_id":{"r":true},"type":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_form"],[2,[7,"/"],[2,[6,"get_form_fields"],[2,[7,"/"],[2,[3,"programme_form_id"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_form/get_form_question_data/:programme_form_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_form_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_get_form_question_data_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_form_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_form"],[2,[7,"/"],[2,[6,"get_form_question_data"],[2,[7,"/"],[2,[3,"programme_form_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_form/get_submitted_form_answers/:programme_form_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_form_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_get_submitted_form_answers_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_form_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_form"],[2,[7,"/"],[2,[6,"get_submitted_form_answers"],[2,[7,"/"],[2,[3,"programme_form_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/:programme_id/form_json/:form_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} form_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"form_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"form_json"],[2,[7,"/"],[2,[3,"form_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/:programme_id/forms(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"forms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/:programme_id/forms_list_json(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_list_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"forms_list_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/:programme_id/form/new/:category/:type(/:entity_id/:entity_type)(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} category
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"category":{"r":true},"type":{"r":true},"entity_id":{},"entity_type":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"form"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[3,"category"],[2,[7,"/"],[2,[3,"type"],[2,[1,[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[3,"entity_type"]]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/:programme_id/form/new/paged/:category/:type(/:entity_id/:entity_type)(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} category
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_new_paged_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"category":{"r":true},"type":{"r":true},"entity_id":{},"entity_type":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"form"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"paged"],[2,[7,"/"],[2,[3,"category"],[2,[7,"/"],[2,[3,"type"],[2,[1,[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[3,"entity_type"]]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/:programme_id/form_option_library(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_option_library_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"form_option_library"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/:programme_id/form_option_library_ag_grid_v(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_option_library_ag_grid_v_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"form_option_library_ag_grid_v"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/:programme_id/form_option_set_library_ag_grid_v(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_option_set_library_ag_grid_v_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"form_option_set_library_ag_grid_v"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_form/pdf/:programme_form_link_id/:entity_id/:entity_type(/:person_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_form_link_id
 * @param {any} entity_id
 * @param {any} entity_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_pdf_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_form_link_id":{"r":true},"entity_id":{"r":true},"entity_type":{"r":true},"person_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_form"],[2,[7,"/"],[2,[6,"pdf"],[2,[7,"/"],[2,[3,"programme_form_link_id"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"entity_type"],[2,[1,[2,[7,"/"],[3,"person_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_form/save_answer_blob/:programme_form_link_id/:entity_id/:entity_type(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_form_link_id
 * @param {any} entity_id
 * @param {any} entity_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_save_answer_blob_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_form_link_id":{"r":true},"entity_id":{"r":true},"entity_type":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_form"],[2,[7,"/"],[2,[6,"save_answer_blob"],[2,[7,"/"],[2,[3,"programme_form_link_id"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"entity_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_form/save_answers/:programme_form_link_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_form_link_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_save_answers_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_form_link_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_form"],[2,[7,"/"],[2,[6,"save_answers"],[2,[7,"/"],[2,[3,"programme_form_link_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_form/:programme_id/save_data_capture_configuration/:form_id(/:entity_id/:entity_type)(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} form_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_save_data_capture_configuration_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"form_id":{"r":true},"entity_id":{},"entity_type":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_form"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"save_data_capture_configuration"],[2,[7,"/"],[2,[3,"form_id"],[2,[1,[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[3,"entity_type"]]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_form/:programme_id/save_datagrid_context/:form_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} form_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_save_datagrid_context_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"form_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_form"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"save_datagrid_context"],[2,[7,"/"],[2,[3,"form_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_form/save_missing_attachments/:programme_form_link_id/:entity_id/:entity_type(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_form_link_id
 * @param {any} entity_id
 * @param {any} entity_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_save_missing_attachments_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_form_link_id":{"r":true},"entity_id":{"r":true},"entity_type":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_form"],[2,[7,"/"],[2,[6,"save_missing_attachments"],[2,[7,"/"],[2,[3,"programme_form_link_id"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"entity_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/:programme_id/set_list_forms_per_page(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_set_list_forms_per_page_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"set_list_forms_per_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_form/show/:programme_form_link_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_form_link_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_form_link_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_form"],[2,[7,"/"],[2,[6,"show"],[2,[7,"/"],[2,[3,"programme_form_link_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_form/:programme_id/simulate_data_capture/:form_id(/:entity_id/:entity_type)(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} form_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_simulate_data_capture_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"form_id":{"r":true},"entity_id":{},"entity_type":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_form"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"simulate_data_capture"],[2,[7,"/"],[2,[3,"form_id"],[2,[1,[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[3,"entity_type"]]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_form/:programme_id/toggle_safe_mode/:form_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} form_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_toggle_safe_mode_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"form_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_form"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"toggle_safe_mode"],[2,[7,"/"],[2,[3,"form_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/:programme_id/form/edit/:form_id(/:entity_id/:entity_type)(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} form_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"form_id":{"r":true},"entity_id":{},"entity_type":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"form"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"form_id"],[2,[1,[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[3,"entity_type"]]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_form/update_answer_field/:programme_form_answer_id(/:field_key/:field_value)(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_form_answer_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_update_answer_field_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_form_answer_id":{"r":true},"field_key":{},"field_value":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_form"],[2,[7,"/"],[2,[6,"update_answer_field"],[2,[7,"/"],[2,[3,"programme_form_answer_id"],[2,[1,[2,[7,"/"],[2,[3,"field_key"],[2,[7,"/"],[3,"field_value"]]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/:programme_id/view_as_pdf/:form_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} form_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_form_view_as_pdf_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"form_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"view_as_pdf"],[2,[7,"/"],[2,[3,"form_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/indicator_units/create/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_indicator_unit_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"indicator_units"],[2,[7,"/"],[2,[6,"create"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/indicator_units/delete/:unit_id(.:format)
 * @param {any} programme_identifier
 * @param {any} unit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_indicator_unit_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"unit_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"indicator_units"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"unit_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/indicator_units/edit/:unit_id(.:format)
 * @param {any} programme_identifier
 * @param {any} unit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_indicator_unit_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"unit_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"indicator_units"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"unit_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/indicator_units/list/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_indicator_unit_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"indicator_units"],[2,[7,"/"],[2,[6,"list"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/indicator_units/new/:programme_id(/:parent_unit_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_indicator_unit_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"parent_unit_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"indicator_units"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[3,"programme_id"],[2,[1,[2,[7,"/"],[3,"parent_unit_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/indicator_units/toggle_unit/:programme_id/:unit_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} unit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_indicator_unit_toggle_unit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"unit_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"indicator_units"],[2,[7,"/"],[2,[6,"toggle_unit"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[3,"unit_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/indicator_units/update/:unit_id(.:format)
 * @param {any} programme_identifier
 * @param {any} unit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_indicator_unit_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"unit_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"indicator_units"],[2,[7,"/"],[2,[6,"update"],[2,[7,"/"],[2,[3,"unit_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/management/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_management_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"management"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/call_list/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_management_call_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"call_list"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/color_schemes/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_management_color_schemes_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"color_schemes"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/communication/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_management_communication_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"communication"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/communication_save/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_management_communication_save_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"communication_save"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/milestones/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_management_milestones_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/results/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_management_results_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"results"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/management_save/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_management_save_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"management_save"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/new_color_scheme/:programme_id/:target(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} target
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_new_color_scheme_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"target":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"new_color_scheme"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[3,"target"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/phase_schemas/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_phase_schemas_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"phase_schemas"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/preview_email/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_preview_email_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"preview_email"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/preview_template/:programme_id/:template_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} template_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_preview_email_template_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"template_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"preview_template"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[3,"template_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/programme_settings_json/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_programme_settings_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"programme_settings_json"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/project_api_access/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_project_api_access_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"project_api_access"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/project_details/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_project_details_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"project_details"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/project_details_overview/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_project_details_overview_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"project_details_overview"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/project_details_save/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_project_details_save_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"project_details_save"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/project_details_setting/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_project_details_setting_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"project_details_setting"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/project_details_setting_save/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_project_details_setting_save_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"project_details_setting_save"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/project_section_configuration/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_project_section_configuration_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"project_section_configuration"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/management/:programme_id/project_users(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_project_users_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"management"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"project_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/management/:programme_id/project_users_json(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_project_users_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"management"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"project_users_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/project_workspace_settings/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_project_workspace_settings_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"project_workspace_settings"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/send_logo/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_send_logo_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"send_logo"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_translation/:language/backend/:translation_key(.:format)
 * @param {any} programme_identifier
 * @param {any} language
 * @param {any} translation_key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_translation_backend_translation_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"language":{"r":true},"translation_key":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_translation"],[2,[7,"/"],[2,[3,"language"],[2,[7,"/"],[2,[6,"backend"],[2,[7,"/"],[2,[3,"translation_key"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_translation/create(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_translation_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_translation"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_translation/delete/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_translation_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_translation"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_translation/edit/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_translation_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_translation"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_translation/get/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_translation_get_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_translation"],[2,[7,"/"],[2,[6,"get"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_translation/key_search(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_translation_key_search_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_translation"],[2,[7,"/"],[2,[6,"key_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_translation/list(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_translation_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_translation"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_translation/list_page(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_translation_list_page_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_translation"],[2,[7,"/"],[2,[6,"list_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/translation_mode/lookup(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_translation_mode_lookup_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"translation_mode"],[2,[7,"/"],[2,[6,"lookup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/translation_mode/save(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_translation_mode_save_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"translation_mode"],[2,[7,"/"],[2,[6,"save"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/translation_mode/terms(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_translation_mode_terms_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"translation_mode"],[2,[7,"/"],[2,[6,"terms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/translation_mode/terms_apply(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_translation_mode_terms_apply_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"translation_mode"],[2,[7,"/"],[2,[6,"terms_apply"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/translation_mode/terms_preview(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_translation_mode_terms_preview_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"translation_mode"],[2,[7,"/"],[2,[6,"terms_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/translation_mode/toggle(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_translation_mode_toggle_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"translation_mode"],[2,[7,"/"],[2,[6,"toggle"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_translation/new(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_translation_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_translation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_translation/reset_cache(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_translation_reset_cache_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_translation"],[2,[7,"/"],[2,[6,"reset_cache"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme_translation/update/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_translation_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme_translation"],[2,[7,"/"],[2,[6,"update"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/update_color_scheme/:scheme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} scheme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_update_color_scheme_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"scheme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"update_color_scheme"],[2,[7,"/"],[2,[3,"scheme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/update_project_overview_figures_settings/:section_id/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} section_id
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_update_project_overview_figures_settings_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"section_id":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"update_project_overview_figures_settings"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/update_project_section_configuration/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_update_project_section_configuration_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"update_project_section_configuration"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/update_project_workspace_settings/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_update_project_workspace_settings_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"update_project_workspace_settings"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/users/:project_id/list(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_users_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/users/:project_id/list_json(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programme_users_list_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"list_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/ai_evaluation_form/:note_id/:phase_id/:ai_evaluation_id(.:format)
 * @param {any} programme_identifier
 * @param {any} note_id
 * @param {any} phase_id
 * @param {any} ai_evaluation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_ai_evaluation_form_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"note_id":{"r":true},"phase_id":{"r":true},"ai_evaluation_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"ai_evaluation_form"],[2,[7,"/"],[2,[3,"note_id"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[3,"ai_evaluation_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/project_api_access/create/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_api_access_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"project_api_access"],[2,[7,"/"],[2,[6,"create"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/:programme_id/project_api_access/delete/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_api_access_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"project_api_access"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/project_api_access/new/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_api_access_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"project_api_access"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/:programme_id/project_api_access/show/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_api_access_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"project_api_access"],[2,[7,"/"],[2,[6,"show"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/archive_report_file/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_archive_report_file_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"archive_report_file"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/archive_report_file_options/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_archive_report_file_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"archive_report_file_options"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/assign_evaluator/:phase_id/:project_id/:person_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {any} project_id
 * @param {any} person_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_assign_evaluator_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"project_id":{"r":true},"person_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"assign_evaluator"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"person_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/budget_calculator(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_budget_calculator_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"budget_calculator"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/:project_id/bulk_add_project_files_tag/:type(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_bulk_add_project_files_tag_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"type":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"bulk_add_project_files_tag"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/:project_id/bulk_download_project_files/:type(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_bulk_download_project_files_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"type":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"bulk_download_project_files"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/:project_id/bulk_email_filter_recipients(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_bulk_email_filter_recipients_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"bulk_email_filter_recipients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/:project_id/bulk_update_project_files_tag/:type(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_bulk_update_project_files_tag_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"type":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"bulk_update_project_files_tag"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calls/create_call/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_create_call_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"create_call"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calls/create_phase/:type/:call_id(.:format)
 * @param {any} programme_identifier
 * @param {any} type
 * @param {any} call_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_create_phase_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"type":{"r":true},"call_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"create_phase"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"call_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calls/create_window/:call_id(.:format)
 * @param {any} programme_identifier
 * @param {any} call_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_create_window_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"create_window"],[2,[7,"/"],[2,[3,"call_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calls/delete_phase/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_delete_phase_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"delete_phase"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calls/delete_window/:window_id(.:format)
 * @param {any} programme_identifier
 * @param {any} window_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_delete_window_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"window_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"delete_window"],[2,[7,"/"],[2,[3,"window_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calls/edit_call/:call_id(.:format)
 * @param {any} programme_identifier
 * @param {any} call_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_edit_call_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"edit_call"],[2,[7,"/"],[2,[3,"call_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calls/edit_evaluation/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_edit_evaluation_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"edit_evaluation"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calls/edit_phase/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_edit_phase_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"edit_phase"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calls/edit_window/:window_id(.:format)
 * @param {any} programme_identifier
 * @param {any} window_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_edit_window_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"window_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"edit_window"],[2,[7,"/"],[2,[3,"window_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/evaluation_result_data/:note_id/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} note_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_evaluation_result_data_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"note_id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"evaluation_result_data"],[2,[7,"/"],[2,[3,"note_id"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calls/export_applications_zip/:call_id(.:format)
 * @param {any} programme_identifier
 * @param {any} call_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_export_applications_zip_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"export_applications_zip"],[2,[7,"/"],[2,[3,"call_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calls(/:progamme_id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"progamme_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calls"],[2,[1,[2,[7,"/"],[3,"progamme_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calls/management_phase_rows/:call_id(.:format)
 * @param {any} programme_identifier
 * @param {any} call_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_management_phase_rows_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"management_phase_rows"],[2,[7,"/"],[2,[3,"call_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calls/new_call/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_new_call_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"new_call"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calls/new_phase/:type/:call_id(.:format)
 * @param {any} programme_identifier
 * @param {any} type
 * @param {any} call_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_new_phase_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"type":{"r":true},"call_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"new_phase"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"call_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calls/new_window/:call_id(.:format)
 * @param {any} programme_identifier
 * @param {any} call_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_new_window_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"new_window"],[2,[7,"/"],[2,[3,"call_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calls/perform_delete_window/:window_id(.:format)
 * @param {any} programme_identifier
 * @param {any} window_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_perform_delete_window_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"window_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"perform_delete_window"],[2,[7,"/"],[2,[3,"window_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_call_phase/add_form_variable/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_phase_add_form_variable_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_call_phase"],[2,[7,"/"],[2,[6,"add_form_variable"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_annexes/:phase_id/:phase_content_id/edit(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {any} phase_content_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_phase_annexes_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"phase_content_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_annexes"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[3,"phase_content_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_annexes/:phase_id/:phase_content_id/update(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {any} phase_content_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_phase_annexes_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"phase_content_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_annexes"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[3,"phase_content_id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_call_phase/browse_form_keys/:phase_id(/:phase_content_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_phase_browse_form_keys_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"phase_content_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_call_phase"],[2,[7,"/"],[2,[6,"browse_form_keys"],[2,[7,"/"],[2,[3,"phase_id"],[2,[1,[2,[7,"/"],[3,"phase_content_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_call_phase/data_capture/delete/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_phase_capture_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_call_phase"],[2,[7,"/"],[2,[6,"data_capture"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_call_phase/data_capture/delete_v2/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_phase_capture_delete_v2_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_call_phase"],[2,[7,"/"],[2,[6,"data_capture"],[2,[7,"/"],[2,[6,"delete_v2"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_call_phase/data_capture/edit/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_phase_capture_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_call_phase"],[2,[7,"/"],[2,[6,"data_capture"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_call_phase/data_capture/update/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_phase_capture_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_call_phase"],[2,[7,"/"],[2,[6,"data_capture"],[2,[7,"/"],[2,[6,"update"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_call_phase/data_capture/update_v2/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_phase_capture_update_v2_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_call_phase"],[2,[7,"/"],[2,[6,"data_capture"],[2,[7,"/"],[2,[6,"update_v2"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_call_phase/configure_data_capture/:phase_id/:phase_content_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {any} phase_content_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_phase_configure_data_capture_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"phase_content_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_call_phase"],[2,[7,"/"],[2,[6,"configure_data_capture"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[3,"phase_content_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_call_phase/delete_data_capture_configuration/:phase_id/:phase_content_id/:configuration_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {any} phase_content_id
 * @param {any} configuration_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_phase_delete_data_capture_configuration_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"phase_content_id":{"r":true},"configuration_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_call_phase"],[2,[7,"/"],[2,[6,"delete_data_capture_configuration"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[3,"phase_content_id"],[2,[7,"/"],[2,[3,"configuration_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_call_phase/delete_form/:phase_id/:phase_content_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {any} phase_content_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_phase_delete_form_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"phase_content_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_call_phase"],[2,[7,"/"],[2,[6,"delete_form"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[3,"phase_content_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_call_phase/edit_form/:phase_id(/:phase_content_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_phase_edit_form_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"phase_content_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_call_phase"],[2,[7,"/"],[2,[6,"edit_form"],[2,[7,"/"],[2,[3,"phase_id"],[2,[1,[2,[7,"/"],[3,"phase_content_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_call_phase/form_option_library/:phase_id(/:phase_content_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_phase_form_option_library_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"phase_content_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_call_phase"],[2,[7,"/"],[2,[6,"form_option_library"],[2,[7,"/"],[2,[3,"phase_id"],[2,[1,[2,[7,"/"],[3,"phase_content_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_call_phase/form_option_library_ag_grid_v/:phase_id(/:phase_content_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_phase_form_option_library_ag_grid_v_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"phase_content_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_call_phase"],[2,[7,"/"],[2,[6,"form_option_library_ag_grid_v"],[2,[7,"/"],[2,[3,"phase_id"],[2,[1,[2,[7,"/"],[3,"phase_content_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_call_phase/list_forms/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_phase_list_forms_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_call_phase"],[2,[7,"/"],[2,[6,"list_forms"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calls/phase_management/:project_call_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_call_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_phase_management_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_call_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"phase_management"],[2,[7,"/"],[2,[3,"project_call_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calls/phase_management_save/:project_call_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_call_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_phase_management_save_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_call_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"phase_management_save"],[2,[7,"/"],[2,[3,"project_call_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calls/phase_management_windows/:call_id(.:format)
 * @param {any} programme_identifier
 * @param {any} call_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_phase_management_windows_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"phase_management_windows"],[2,[7,"/"],[2,[3,"call_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_call_phase/save_data_capture_configuration/:phase_id/:phase_content_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {any} phase_content_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_phase_save_data_capture_configuration_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"phase_content_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_call_phase"],[2,[7,"/"],[2,[6,"save_data_capture_configuration"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[3,"phase_content_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_call_phase/set_window_form(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_phase_set_window_form_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_call_phase"],[2,[7,"/"],[2,[6,"set_window_form"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_call_phase/simulate_data_capture/:phase_id/:phase_content_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {any} phase_content_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_phase_simulate_data_capture_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"phase_content_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_call_phase"],[2,[7,"/"],[2,[6,"simulate_data_capture"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[3,"phase_content_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_call_phase/update_evaluation_form/:phase_id(/:phase_content_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_phase_update_evaluation_form_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"phase_content_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_call_phase"],[2,[7,"/"],[2,[6,"update_evaluation_form"],[2,[7,"/"],[2,[3,"phase_id"],[2,[1,[2,[7,"/"],[3,"phase_content_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_call_phase/update_form/:phase_id(/:phase_content_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_phase_update_form_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"phase_content_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_call_phase"],[2,[7,"/"],[2,[6,"update_form"],[2,[7,"/"],[2,[3,"phase_id"],[2,[1,[2,[7,"/"],[3,"phase_content_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_call_phase/view_form_pdf/:phase_id(/:phase_content_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_phase_view_form_pdf_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"phase_content_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_call_phase"],[2,[7,"/"],[2,[6,"view_form_pdf"],[2,[7,"/"],[2,[3,"phase_id"],[2,[1,[2,[7,"/"],[3,"phase_content_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calls/publish_decisions/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_publish_decisions_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"publish_decisions"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calls/publish_evaluations/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_publish_evaluations_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"publish_evaluations"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calls/save_budget_settings/:call_id(.:format)
 * @param {any} programme_identifier
 * @param {any} call_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_save_budget_settings_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"save_budget_settings"],[2,[7,"/"],[2,[3,"call_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calls/unlock_window_changing/:call_id(.:format)
 * @param {any} programme_identifier
 * @param {any} call_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_unlock_window_changing_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"unlock_window_changing"],[2,[7,"/"],[2,[3,"call_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calls/update_call/:call_id(.:format)
 * @param {any} programme_identifier
 * @param {any} call_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_update_call_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"update_call"],[2,[7,"/"],[2,[3,"call_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calls/update_evaluation/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_update_evaluation_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"update_evaluation"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calls/update_phase/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_update_phase_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"update_phase"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calls/update_phase_sort_order/:call_id(.:format)
 * @param {any} programme_identifier
 * @param {any} call_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_update_phase_sort_order_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"update_phase_sort_order"],[2,[7,"/"],[2,[3,"call_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/calls/update_window/:window_id(.:format)
 * @param {any} programme_identifier
 * @param {any} window_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_call_update_window_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"window_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"update_window"],[2,[7,"/"],[2,[3,"window_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/:project_id/change_owner(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_change_owner_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"change_owner"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/clear_phase_status/:note_id/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} note_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_clear_phase_status_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"note_id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"clear_phase_status"],[2,[7,"/"],[2,[3,"note_id"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_contract/:project_id/earlier_versions/:version(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_contract_earlier_versions_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"version":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_contract"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"earlier_versions"],[2,[7,"/"],[2,[3,"version"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_contract/:project_id/edit_draft(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_contract_edit_draft_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_contract"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"edit_draft"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/:project_id/contract_editing(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_contract_editing_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"contract_editing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_contract/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_contract_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_contract"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_contract/:project_id/inforce_draft(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_contract_inforce_draft_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_contract"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"inforce_draft"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_contract/:project_id/initiate_contract(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_contract_initiate_contract_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_contract"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"initiate_contract"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_contract/:project_id/lock_draft(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_contract_lock_draft_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_contract"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"lock_draft"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_contract/:project_id/manage_milestones(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_contract_manage_milestones_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_contract"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage_milestones"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_contract/:project_id/modify(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_contract_modify_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_contract"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"modify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_contract/:project_id/preview(/:version)(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_contract_preview_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"version":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_contract"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"preview"],[2,[1,[2,[7,"/"],[3,"version"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/:project_id/contract_processing(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_contract_processing_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"contract_processing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_contract/:project_id/unlock_draft(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_contract_unlock_draft_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_contract"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"unlock_draft"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/delete/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/delete_attachment(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_delete_attachment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"delete_attachment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_deliverable/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_deliverable_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_deliverable"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_deliverable/:project_id/create_milestone(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_deliverable_create_milestone_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_deliverable"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"create_milestone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_deliverable/:project_id/delete/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_deliverable_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_deliverable"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_deliverable/:project_id/delete_milestone/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_deliverable_delete_milestone_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_deliverable"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"delete_milestone"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_deliverable/:project_id/grouped_options_for_select(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_deliverable_grouped_options_for_select_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_deliverable"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"grouped_options_for_select"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_deliverable/:project_id/mark_achievements/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_deliverable_mark_achievements_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_deliverable"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"mark_achievements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_deliverable/:project_id/open_attachment/:filename/:deliverable_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} filename
 * @param {any} deliverable_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_deliverable_open_attachment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"filename":{"r":true},"deliverable_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_deliverable"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"open_attachment"],[2,[7,"/"],[2,[3,"filename"],[2,[7,"/"],[2,[3,"deliverable_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_deliverable/:project_id/update/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_deliverable_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_deliverable"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"update"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_deliverable/:project_id/update_completion_percentages(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_deliverable_update_completion_percentages_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_deliverable"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"update_completion_percentages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_deliverable/:project_id/update_milestone/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_deliverable_update_milestone_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_deliverable"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"update_milestone"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_deliverable/:project_id/upload_attachment/:upload_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} upload_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_deliverable_upload_attachment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"upload_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_deliverable"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"upload_attachment"],[2,[7,"/"],[2,[3,"upload_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_document/:project_id/update(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_document_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_document"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/download_application_zip/:phase_id/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_download_application_zip_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"download_application_zip"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/download_attachment/:attachment_attr/:phase_id(/:note_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} attachment_attr
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_download_attachment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"attachment_attr":{"r":true},"phase_id":{"r":true},"note_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"download_attachment"],[2,[7,"/"],[2,[3,"attachment_attr"],[2,[7,"/"],[2,[3,"phase_id"],[2,[1,[2,[7,"/"],[3,"note_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/download_evaluation_attachment/:attachment_attr/:phase_id/:note_id/:evaluator_id(/:prescoring)(.:format)
 * @param {any} programme_identifier
 * @param {any} attachment_attr
 * @param {any} phase_id
 * @param {any} note_id
 * @param {any} evaluator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_download_evaluation_attachment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"attachment_attr":{"r":true},"phase_id":{"r":true},"note_id":{"r":true},"evaluator_id":{"r":true},"prescoring":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"download_evaluation_attachment"],[2,[7,"/"],[2,[3,"attachment_attr"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[3,"note_id"],[2,[7,"/"],[2,[3,"evaluator_id"],[2,[1,[2,[7,"/"],[3,"prescoring"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/edit_data_sheet/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_edit_data_sheet_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"edit_data_sheet"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/edit_phase_decision_comment/:note_id/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} note_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_edit_phase_decision_comment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"note_id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"edit_phase_decision_comment"],[2,[7,"/"],[2,[3,"note_id"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/edit_phase_multi_decision_comment/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_edit_phase_multi_decision_comment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"edit_phase_multi_decision_comment"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/edit_phase_status/:note_id/:phase_id/:status(.:format)
 * @param {any} programme_identifier
 * @param {any} note_id
 * @param {any} phase_id
 * @param {any} status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_edit_phase_status_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"note_id":{"r":true},"phase_id":{"r":true},"status":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"edit_phase_status"],[2,[7,"/"],[2,[3,"note_id"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[3,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/edit_phase_status_bulk/:phase_id/:status(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {any} status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_edit_phase_status_bulk_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"status":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"edit_phase_status_bulk"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[3,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/evaluate/:note_id/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} note_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_evaluate_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"note_id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"evaluate"],[2,[7,"/"],[2,[3,"note_id"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/evaluation_criterion_result/:note_id/:phase_id/:question_identifier(.:format)
 * @param {any} programme_identifier
 * @param {any} note_id
 * @param {any} phase_id
 * @param {any} question_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_evaluation_criterion_result_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"note_id":{"r":true},"phase_id":{"r":true},"question_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"evaluation_criterion_result"],[2,[7,"/"],[2,[3,"note_id"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[3,"question_identifier"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/evaluation_form/:note_id/:phase_id/:evaluator_id(.:format)
 * @param {any} programme_identifier
 * @param {any} note_id
 * @param {any} phase_id
 * @param {any} evaluator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_evaluation_form_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"note_id":{"r":true},"phase_id":{"r":true},"evaluator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"evaluation_form"],[2,[7,"/"],[2,[3,"note_id"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[3,"evaluator_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/evaluation_page/:call_id(/:phase_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} call_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_evaluation_list_page_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_id":{"r":true},"phase_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"evaluation_page"],[2,[7,"/"],[2,[3,"call_id"],[2,[1,[2,[7,"/"],[3,"phase_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/evaluation_summary/:note_id/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} note_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_evaluation_summary_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"note_id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"evaluation_summary"],[2,[7,"/"],[2,[3,"note_id"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/evaluations_excel/:project_id/:phase_id(/:person_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_evaluations_excel_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"phase_id":{"r":true},"person_id":{"d":null},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"evaluations_excel"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"phase_id"],[2,[1,[2,[7,"/"],[3,"person_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/excel_export/:call_id/:phase_id(/:export_type)(.:format)
 * @param {any} programme_identifier
 * @param {any} call_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_excel_export_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_id":{"r":true},"phase_id":{"r":true},"export_type":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"excel_export"],[2,[7,"/"],[2,[3,"call_id"],[2,[7,"/"],[2,[3,"phase_id"],[2,[1,[2,[7,"/"],[3,"export_type"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/excel_export_legacy/:call_id/:phase_id(/:export_type)(.:format)
 * @param {any} programme_identifier
 * @param {any} call_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_excel_export_legacy_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_id":{"r":true},"phase_id":{"r":true},"export_type":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"excel_export_legacy"],[2,[7,"/"],[2,[3,"call_id"],[2,[7,"/"],[2,[3,"phase_id"],[2,[1,[2,[7,"/"],[3,"export_type"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/excel_export_options/:call_id/:phase_id(/:export_type)(.:format)
 * @param {any} programme_identifier
 * @param {any} call_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_excel_export_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_id":{"r":true},"phase_id":{"r":true},"export_type":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"excel_export_options"],[2,[7,"/"],[2,[3,"call_id"],[2,[7,"/"],[2,[3,"phase_id"],[2,[1,[2,[7,"/"],[3,"export_type"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/excel_export_options_legacy/:call_id/:phase_id(/:export_type)(.:format)
 * @param {any} programme_identifier
 * @param {any} call_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_excel_export_options_legacy_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_id":{"r":true},"phase_id":{"r":true},"export_type":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"excel_export_options_legacy"],[2,[7,"/"],[2,[3,"call_id"],[2,[7,"/"],[2,[3,"phase_id"],[2,[1,[2,[7,"/"],[3,"export_type"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/fact_sheet/show/:project_id(/:status)(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_fact_sheet_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"status":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"fact_sheet"],[2,[7,"/"],[2,[6,"show"],[2,[7,"/"],[2,[3,"project_id"],[2,[1,[2,[7,"/"],[3,"status"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/fact_sheet/delete/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_fact_sheet_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"fact_sheet"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/fact_sheet/document/:project_id/:field_name/:locale(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} field_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_fact_sheet_document_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"field_name":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"fact_sheet"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"field_name"],[2,[7,"/"],[2,[3,"locale"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/fact_sheet/file/:project_id/:status/:attachment_attr/:locale(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} status
 * @param {any} attachment_attr
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_fact_sheet_download_attachment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"status":{"r":true},"attachment_attr":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"fact_sheet"],[2,[7,"/"],[2,[6,"file"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"status"],[2,[7,"/"],[2,[3,"attachment_attr"],[2,[7,"/"],[2,[3,"locale"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/fact_sheet/edit/:project_id(/:status)(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_fact_sheet_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"status":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"fact_sheet"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"project_id"],[2,[1,[2,[7,"/"],[3,"status"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/fact_sheet/reject/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_fact_sheet_perform_reject_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"fact_sheet"],[2,[7,"/"],[2,[6,"reject"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/fact_sheet/reject/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_fact_sheet_reject_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"fact_sheet"],[2,[7,"/"],[2,[6,"reject"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/fact_sheet/edit/:project_id/:locale(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_fact_sheet_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"fact_sheet"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"locale"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/fill_phase_summary/:note_id(/:phase_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} note_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_fill_phase_summary_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"note_id":{"r":true},"phase_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"fill_phase_summary"],[2,[7,"/"],[2,[3,"note_id"],[2,[1,[2,[7,"/"],[3,"phase_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/final_list_page/:call_id(/:phase_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} call_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_final_list_page_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_id":{"r":true},"phase_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"final_list_page"],[2,[7,"/"],[2,[3,"call_id"],[2,[1,[2,[7,"/"],[3,"phase_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_monitoring/finance/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_finance_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_monitoring"],[2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/form_list_page/:call_id(/:phase_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} call_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_form_list_page_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_id":{"r":true},"phase_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"form_list_page"],[2,[7,"/"],[2,[3,"call_id"],[2,[1,[2,[7,"/"],[3,"phase_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/form_list_page_update_visible_columns/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_form_list_page_update_visible_columns_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"form_list_page_update_visible_columns"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/evaluation_free_form_answers/:phase_id/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_free_form_answers_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"evaluation_free_form_answers"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/:project_id/form_answers(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_get_form_answers_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"form_answers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/get_phase_decision_comments/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_get_phase_decision_comments_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"get_phase_decision_comments"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/:project_id/get_project_file_list(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_get_project_file_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"get_project_file_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/project_header_json(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_header_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"project_header_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/history/:note_id/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} note_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_history_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"note_id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"history"],[2,[7,"/"],[2,[3,"note_id"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_info/:project_id/external_entity(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_info_external_entity_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_info"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"external_entity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_info/:project_id/project_progress(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_info_project_progress_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_info"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project_progress"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/list/:call_id/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} call_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"list"],[2,[7,"/"],[2,[3,"call_id"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_list/add_project_to_list(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_list_add_project_to_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_list"],[2,[7,"/"],[2,[6,"add_project_to_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_lists(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_list_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_lists/:id/delete(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_list_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_lists/:id/generate_document(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_list_generate_document_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate_document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_lists(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_list_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_lists/:id/remove_project_from_list/:project_to_remove_id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} project_to_remove_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_list_remove_project_from_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"project_to_remove_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_project_from_list"],[2,[7,"/"],[2,[3,"project_to_remove_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_list_templates/:id/clone(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_list_template_clone_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_list_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_list_templates(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_list_template_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_list_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_list_templates/:id/delete(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_list_template_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_list_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_list_templates(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_list_template_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_list_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_list_templates/:id/update(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_list_template_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_list_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_list_template/list(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_list_templates_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_list_template"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_lists/:id/update(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_list_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_lists/:id/view_projects(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_list_view_projects_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"view_projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_list/list(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_lists_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_list"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_list/lists_for_add(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_lists_for_add_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_list"],[2,[7,"/"],[2,[6,"lists_for_add"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/merge/:note_id/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} note_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_merge_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"note_id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"merge"],[2,[7,"/"],[2,[3,"note_id"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/merge_application/:note_id/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} note_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_merge_application_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"note_id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"merge_application"],[2,[7,"/"],[2,[3,"note_id"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/milestone/create/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_milestone_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"milestone"],[2,[7,"/"],[2,[6,"create"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/milestone/delete/:project_id/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_milestone_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"milestone"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/milestone/edit/:project_id/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_milestone_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"milestone"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/milestone/list/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_milestone_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"milestone"],[2,[7,"/"],[2,[6,"list"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/milestone/list_to_pdf/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_milestone_list_to_pdf_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"milestone"],[2,[7,"/"],[2,[6,"list_to_pdf"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/milestone/new/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_milestone_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"milestone"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/milestone/options_for_select/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_milestone_options_for_select_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"milestone"],[2,[7,"/"],[2,[6,"options_for_select"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/milestone/toggle_completion/:project_id/:milestone_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} milestone_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_milestone_toggle_completion_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"milestone_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"milestone"],[2,[7,"/"],[2,[6,"toggle_completion"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"milestone_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/milestone/update/:project_id/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_milestone_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"milestone"],[2,[7,"/"],[2,[6,"update"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_monitoring/in_force_milestones/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_monitoring_in_force_milestones_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_monitoring"],[2,[7,"/"],[2,[6,"in_force_milestones"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_monitoring/indicators/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_monitoring_indicators_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_monitoring"],[2,[7,"/"],[2,[6,"indicators"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_monitoring/milestones/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_monitoring_milestones_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_monitoring"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_monitoring_period/available_options(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_monitoring_period_available_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_monitoring_period"],[2,[7,"/"],[2,[6,"available_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_monitoring_period/list(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_monitoring_period_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_monitoring_period"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_monitoring_period/submit(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_monitoring_period_submit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_monitoring_period"],[2,[7,"/"],[2,[6,"submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_monitoring/user_worklogs/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_monitoring_user_worklogs_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_monitoring"],[2,[7,"/"],[2,[6,"user_worklogs"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_monitoring/worklogs/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_monitoring_worklogs_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_monitoring"],[2,[7,"/"],[2,[6,"worklogs"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/new(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_overview/:project_id/get_common_indicators(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_overview_get_common_indicators_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_overview"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"get_common_indicators"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_overview/:project_id/get_figures_data(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_overview_get_figures_data_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_overview"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"get_figures_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_overview/:project_id/get_json(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_overview_get_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_overview"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"get_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_overview/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_overview_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_overview"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_overview/:project_id/project_additional_info(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_overview_project_additional_info_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_overview"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project_additional_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_overview/:project_id/update(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_overview_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_overview"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/pdf/:phase_id(/:note_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_pdf_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"note_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"pdf"],[2,[7,"/"],[2,[3,"phase_id"],[2,[1,[2,[7,"/"],[3,"note_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/:project_id/perform_change_owner(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_perform_change_owner_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"perform_change_owner"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_phases/:project_id/add_deliverable/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_phase_add_deliverable_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_phases"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"add_deliverable"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_phases/:project_id/available_deliverable_resources(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_phase_available_deliverable_resources_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_phases"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"available_deliverable_resources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_phases/:project_id/create_report_for_deliverable_sequence_entry/:deliverable_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} deliverable_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_phase_create_report_for_deliverable_sequence_entry_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"deliverable_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_phases"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"create_report_for_deliverable_sequence_entry"],[2,[7,"/"],[2,[3,"deliverable_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_phases/:project_id/data(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_phase_data_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_phases"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_phases/:project_id/linked_report/:monitoring_report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} monitoring_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_phase_find_or_create_linked_report_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"monitoring_report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_phases"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"linked_report"],[2,[7,"/"],[2,[3,"monitoring_report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_phases/:project_id/form_deliverable/:deliverable_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} deliverable_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_phase_form_deliverable_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"deliverable_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_phases"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"form_deliverable"],[2,[7,"/"],[2,[3,"deliverable_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_phases/:project_id/mark_deliverable_sequence_entry_not_applicable/:deliverable_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} deliverable_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_phase_mark_deliverable_sequence_entry_not_applicable_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"deliverable_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_phases"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"mark_deliverable_sequence_entry_not_applicable"],[2,[7,"/"],[2,[3,"deliverable_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_phases/:project_id/redirect_to_report_for_deliverable_sequence_entry/:deliverable_id/:scheduled_period(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} deliverable_id
 * @param {any} scheduled_period
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_phase_redirect_to_report_for_deliverable_sequence_entry_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"deliverable_id":{"r":true},"scheduled_period":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_phases"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"redirect_to_report_for_deliverable_sequence_entry"],[2,[7,"/"],[2,[3,"deliverable_id"],[2,[7,"/"],[2,[3,"scheduled_period"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_phases/:project_id/step_to/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_phase_step_to_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_phases"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"step_to"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_phases/:project_id/update_deliverable_completion(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_phase_update_deliverable_completion_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_phases"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"update_deliverable_completion"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_phases/:project_id/update_deliverable_order(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_phase_update_deliverable_order_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_phases"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"update_deliverable_order"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_phases/:project_id/update_form_deliverable/:deliverable_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} deliverable_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_phase_update_form_deliverable_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"deliverable_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_phases"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"update_form_deliverable"],[2,[7,"/"],[2,[3,"deliverable_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_phases/:project_id/update_phases_dates(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_phase_update_phases_dates_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_phases"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"update_phases_dates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/phases_summary/:note_id(/:phase_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} note_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_phases_summary_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"note_id":{"r":true},"phase_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"phases_summary"],[2,[7,"/"],[2,[3,"note_id"],[2,[1,[2,[7,"/"],[3,"phase_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_portfolio_preset/:preset_id(.:format)
 * @param {any} programme_identifier
 * @param {any} preset_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_portfolio_preset_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"preset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_portfolio_preset"],[2,[7,"/"],[2,[3,"preset_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_portfolio_preset/:preset_id/additional_info_form(.:format)
 * @param {any} programme_identifier
 * @param {any} preset_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_portfolio_preset_additional_info_form_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"preset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_portfolio_preset"],[2,[7,"/"],[2,[3,"preset_id"],[2,[7,"/"],[2,[6,"additional_info_form"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_portfolio_preset/create(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_portfolio_preset_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_portfolio_preset"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_portfolio_preset/list/dashboard_presets(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_portfolio_preset_dashboard_presets_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_portfolio_preset"],[2,[7,"/"],[2,[6,"list"],[2,[7,"/"],[2,[6,"dashboard_presets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_portfolio_preset/:preset_id/delete(.:format)
 * @param {any} programme_identifier
 * @param {any} preset_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_portfolio_preset_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"preset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_portfolio_preset"],[2,[7,"/"],[2,[3,"preset_id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_portfolio_preset/:preset_id/personal_column_state(.:format)
 * @param {any} programme_identifier
 * @param {any} preset_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_portfolio_preset_personal_column_state_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"preset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_portfolio_preset"],[2,[7,"/"],[2,[3,"preset_id"],[2,[7,"/"],[2,[6,"personal_column_state"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_portfolio_preset/list/portfolio_presets(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_portfolio_preset_portfolio_presets_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_portfolio_preset"],[2,[7,"/"],[2,[6,"list"],[2,[7,"/"],[2,[6,"portfolio_presets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_portfolio_preset/:preset_id/update(.:format)
 * @param {any} programme_identifier
 * @param {any} preset_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_portfolio_preset_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"preset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_portfolio_preset"],[2,[7,"/"],[2,[3,"preset_id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_portfolio_preset/:preset_id/default_form_fills(.:format)
 * @param {any} programme_identifier
 * @param {any} preset_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_portfolio_preset_update_default_form_fills_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"preset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_portfolio_preset"],[2,[7,"/"],[2,[3,"preset_id"],[2,[7,"/"],[2,[6,"default_form_fills"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/prescoring/:project_id/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_prescoring_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"prescoring"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/:project_id/proceed_and_keep_contract_in_draft(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_proceed_and_keep_contract_in_draft_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"proceed_and_keep_contract_in_draft"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/:project_id/proceed_and_set_contract_into_force(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_proceed_and_set_contract_into_force_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"proceed_and_set_contract_into_force"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/amendment_requests/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_amendment_requests_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"amendment_requests"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/applicant_list_json(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_applicant_list_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"applicant_list_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/approve/:project_id/:form_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} form_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_approve_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"form_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"approve"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"form_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/bulk_close/:report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_bulk_close_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"bulk_close"],[2,[7,"/"],[2,[3,"report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/bulk_delete(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_bulk_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"bulk_delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/bulk_edit_deadline(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_bulk_edit_deadline_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"bulk_edit_deadline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/bulk_pdf(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_bulk_pdf_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"bulk_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/bulk_pdf_options(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_bulk_pdf_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"bulk_pdf_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/bulk_reopen/:report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_bulk_reopen_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"bulk_reopen"],[2,[7,"/"],[2,[3,"report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/bulk_update_deadline(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_bulk_update_deadline_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"bulk_update_deadline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/bulk_update_status/:report_id/:status(.:format)
 * @param {any} programme_identifier
 * @param {any} report_id
 * @param {any} status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_bulk_update_status_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"report_id":{"r":true},"status":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"bulk_update_status"],[2,[7,"/"],[2,[3,"report_id"],[2,[7,"/"],[2,[3,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/comments/:project_id/:project_report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} project_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_comments_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"project_report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"project_report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/comments_pdf/:project_id/:project_report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} project_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_comments_pdf_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"project_report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"comments_pdf"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"project_report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/compare_submissions/:project_id/:project_report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} project_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_compare_submissions_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"project_report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"compare_submissions"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"project_report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/decision/:project_id/:project_report_id/:report_phase_id(/:redirect_back_to)(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} project_report_id
 * @param {any} report_phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_decision_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"project_report_id":{"r":true},"report_phase_id":{"r":true},"redirect_back_to":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"decision"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"project_report_id"],[2,[7,"/"],[2,[3,"report_phase_id"],[2,[1,[2,[7,"/"],[3,"redirect_back_to"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/delete/:project_report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"project_report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report_docusign/assign_signatories/:project_id/:report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_docusign_assign_signatories_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report_docusign"],[2,[7,"/"],[2,[6,"assign_signatories"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report_docusign/cancel_signing/:project_id/:report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_docusign_cancel_signing_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report_docusign"],[2,[7,"/"],[2,[6,"cancel_signing"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report_docusign/initiate_signing/:project_id/:report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_docusign_initiate_signing_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report_docusign"],[2,[7,"/"],[2,[6,"initiate_signing"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report_docusign/initiate_signing_show/:project_id/:report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_docusign_initiate_signing_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report_docusign"],[2,[7,"/"],[2,[6,"initiate_signing_show"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report_docusign/resend_envelope/:project_id/:report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_docusign_resend_envelope_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report_docusign"],[2,[7,"/"],[2,[6,"resend_envelope"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report_docusign/signature_pdf/:project_id/:report_id/:monitoring_report_phase_id/:project_report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} report_id
 * @param {any} monitoring_report_phase_id
 * @param {any} project_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_docusign_signature_pdf_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"report_id":{"r":true},"monitoring_report_phase_id":{"r":true},"project_report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report_docusign"],[2,[7,"/"],[2,[6,"signature_pdf"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"report_id"],[2,[7,"/"],[2,[3,"monitoring_report_phase_id"],[2,[7,"/"],[2,[3,"project_report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/edit/:project_id/:form_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} form_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"form_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"form_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/edit_deadline/:project_report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_edit_deadline_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"edit_deadline"],[2,[7,"/"],[2,[3,"project_report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/edit_report/:project_id/:report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_edit_report_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"edit_report"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/edit_status/:project_report_id/:status(.:format)
 * @param {any} programme_identifier
 * @param {any} project_report_id
 * @param {any} status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_edit_status_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_report_id":{"r":true},"status":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"edit_status"],[2,[7,"/"],[2,[3,"project_report_id"],[2,[7,"/"],[2,[3,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/export_fill_phase_forms_as_pdf/:project_report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_export_fill_phase_forms_as_pdf_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"export_fill_phase_forms_as_pdf"],[2,[7,"/"],[2,[3,"project_report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/external_bulk_pdf(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_external_bulk_pdf_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"external_bulk_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/get_performance_data_single_submission/:project_report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_get_performance_data_single_submission_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"get_performance_data_single_submission"],[2,[7,"/"],[2,[3,"project_report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/get_performance_data_submissions/:monitoring_report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} monitoring_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_get_performance_data_submissions_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"monitoring_report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"get_performance_data_submissions"],[2,[7,"/"],[2,[3,"monitoring_report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/get_prefill_source_answers_for_links/:links(.:format)
 * @param {any} programme_identifier
 * @param {any} links
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_get_prefill_source_answers_for_links_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"links":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"get_prefill_source_answers_for_links"],[2,[7,"/"],[2,[3,"links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/get_status_tracker_data/:monitoring_report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} monitoring_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_get_status_tracker_data_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"monitoring_report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"get_status_tracker_data"],[2,[7,"/"],[2,[3,"monitoring_report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report_docusign/json_previous_phases_form/:project_id/:report_id/:monitoring_report_phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} report_id
 * @param {any} monitoring_report_phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_json_previous_phases_form_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"report_id":{"r":true},"monitoring_report_phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report_docusign"],[2,[7,"/"],[2,[6,"json_previous_phases_form"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"report_id"],[2,[7,"/"],[2,[3,"monitoring_report_phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/latest_reports_json/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_latest_reports_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"latest_reports_json"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/list_batch_projects_json/:project_report_id(/:report_phase_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} project_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_list_batch_projects_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_report_id":{"r":true},"report_phase_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"list_batch_projects_json"],[2,[7,"/"],[2,[3,"project_report_id"],[2,[1,[2,[7,"/"],[3,"report_phase_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/list_draft_disbursement_requests/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_list_draft_disbursements_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"list_draft_disbursement_requests"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/forms/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_list_forms_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/list_json(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_list_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"list_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/list_json_legacy(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_list_json_legacy_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"list_json_legacy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/next_review_phases/:project_report_id/:report_phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_report_id
 * @param {any} report_phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_next_review_phases_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_report_id":{"r":true},"report_phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"next_review_phases"],[2,[7,"/"],[2,[3,"project_report_id"],[2,[7,"/"],[2,[3,"report_phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/pdf/:project_report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_pdf_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"pdf"],[2,[7,"/"],[2,[3,"project_report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/pdf_options/:project_report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_pdf_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"pdf_options"],[2,[7,"/"],[2,[3,"project_report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/preview/:project_report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_preview_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"preview"],[2,[7,"/"],[2,[3,"project_report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/project_stories/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_project_stories_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"project_stories"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/reassign_approval/:project_report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_reassign_approval_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"reassign_approval"],[2,[7,"/"],[2,[3,"project_report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/reassign_review/:project_report_id/:report_phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_report_id
 * @param {any} report_phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_reassign_review_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_report_id":{"r":true},"report_phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"reassign_review"],[2,[7,"/"],[2,[3,"project_report_id"],[2,[7,"/"],[2,[3,"report_phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/reassignment_form_options/:project_report_id/:report_phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_report_id
 * @param {any} report_phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_reassignment_form_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_report_id":{"r":true},"report_phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"reassignment_form_options"],[2,[7,"/"],[2,[3,"project_report_id"],[2,[7,"/"],[2,[3,"report_phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/reports(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_reports_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/revert_review/:project_id/:project_report_id/:report_phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} project_report_id
 * @param {any} report_phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_revert_review_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"project_report_id":{"r":true},"report_phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"revert_review"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"project_report_id"],[2,[7,"/"],[2,[3,"report_phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/revert_submission/:project_id/:project_report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} project_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_revert_submission_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"project_report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"revert_submission"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"project_report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/review/:project_id/:project_report_id/:report_phase_id(/:redirect_back_to)(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} project_report_id
 * @param {any} report_phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_review_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"project_report_id":{"r":true},"report_phase_id":{"r":true},"redirect_back_to":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"project_report_id"],[2,[7,"/"],[2,[3,"report_phase_id"],[2,[1,[2,[7,"/"],[3,"redirect_back_to"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/save/:project_id/:project_report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} project_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_save_report_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"project_report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"save"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"project_report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/form/:project_id/:form_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} form_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_show_form_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"form_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"form"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"form_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/submit/:project_id/:project_report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} project_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_submit_report_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"project_report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"submit"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"project_report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/submit_review/:project_id/:project_report_id/:report_phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} project_report_id
 * @param {any} report_phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_submit_review_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"project_report_id":{"r":true},"report_phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"submit_review"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"project_report_id"],[2,[7,"/"],[2,[3,"report_phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/update_deadline/:project_report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_update_deadline_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"update_deadline"],[2,[7,"/"],[2,[3,"project_report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/update_selected_optional_forms/:project_id/:report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_update_selected_optional_forms_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"update_selected_optional_forms"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/update_status/:project_report_id/:status(.:format)
 * @param {any} programme_identifier
 * @param {any} project_report_id
 * @param {any} status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_update_status_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_report_id":{"r":true},"status":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"update_status"],[2,[7,"/"],[2,[3,"project_report_id"],[2,[7,"/"],[2,[3,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_report/update_visible_columns(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_report_update_visible_columns_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_report"],[2,[7,"/"],[2,[6,"update_visible_columns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/list/:call_id(.:format)
 * @param {any} programme_identifier
 * @param {any} call_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_resolve_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"list"],[2,[7,"/"],[2,[3,"call_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_resource/accept_cell/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_resource_accept_cell_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_resource"],[2,[7,"/"],[2,[6,"accept_cell"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_resource/create/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_resource_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_resource"],[2,[7,"/"],[2,[6,"create"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_resource/form_options/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_resource_form_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_resource"],[2,[7,"/"],[2,[6,"form_options"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_resource/list_json/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_resource_list_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_resource"],[2,[7,"/"],[2,[6,"list_json"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_resource/lock_cell/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_resource_lock_cell_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_resource"],[2,[7,"/"],[2,[6,"lock_cell"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_resource/mark_as_expired/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_resource_mark_as_expired_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_resource"],[2,[7,"/"],[2,[6,"mark_as_expired"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_resource/monitoring/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_resource_monitoring_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_resource"],[2,[7,"/"],[2,[6,"monitoring"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_resource/month_columns/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_resource_month_columns_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_resource"],[2,[7,"/"],[2,[6,"month_columns"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_resource/update_cell/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_resource_update_cell_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_resource"],[2,[7,"/"],[2,[6,"update_cell"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_resource/update_settings/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_resource_update_settings_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_resource"],[2,[7,"/"],[2,[6,"update_settings"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/save_form/:note_id/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} note_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_save_form_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"note_id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"save_form"],[2,[7,"/"],[2,[3,"note_id"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/save_prescoring/:project_id/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_save_prescoring_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"save_prescoring"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/save_state(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_save_state_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"save_state"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/select_window/:project_id/:window_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} window_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_select_window_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"window_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"select_window"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"window_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/applicant_select_window/:project_id(/:phase_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_select_window_for_applicant_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"phase_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"applicant_select_window"],[2,[7,"/"],[2,[3,"project_id"],[2,[1,[2,[7,"/"],[3,"phase_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/applicant_select_window_save/:project_id(/:phase_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_select_window_save_for_applicant_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"phase_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"applicant_select_window_save"],[2,[7,"/"],[2,[3,"project_id"],[2,[1,[2,[7,"/"],[3,"phase_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/set_items_per_page/:items_per_page(.:format)
 * @param {any} programme_identifier
 * @param {any} items_per_page
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_set_items_per_page_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"items_per_page":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"set_items_per_page"],[2,[7,"/"],[2,[3,"items_per_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/show/:note_id(/:phase_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} note_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"note_id":{"r":true},"phase_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"show"],[2,[7,"/"],[2,[3,"note_id"],[2,[1,[2,[7,"/"],[3,"phase_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/evaluation_result/:note_id/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} note_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_show_evaluation_result_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"note_id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"evaluation_result"],[2,[7,"/"],[2,[3,"note_id"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/show_form/:note_id/:phase_id(/:evaluation_phase_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} note_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_show_form_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"note_id":{"r":true},"phase_id":{"r":true},"evaluation_phase_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"show_form"],[2,[7,"/"],[2,[3,"note_id"],[2,[7,"/"],[2,[3,"phase_id"],[2,[1,[2,[7,"/"],[3,"evaluation_phase_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/show_form_diff/:note_id/:phase_id(/:evaluation_phase_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} note_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_show_form_diff_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"note_id":{"r":true},"phase_id":{"r":true},"evaluation_phase_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"show_form_diff"],[2,[7,"/"],[2,[3,"note_id"],[2,[7,"/"],[2,[3,"phase_id"],[2,[1,[2,[7,"/"],[3,"evaluation_phase_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/summary/:note_id(/:phase_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} note_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_summary_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"note_id":{"r":true},"phase_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"summary"],[2,[7,"/"],[2,[3,"note_id"],[2,[1,[2,[7,"/"],[3,"phase_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/tab/:tab/:note_id(/:phase_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} tab
 * @param {any} note_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_tab_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"tab":{"r":true},"note_id":{"r":true},"phase_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"tab"],[2,[7,"/"],[2,[3,"tab"],[2,[7,"/"],[2,[3,"note_id"],[2,[1,[2,[7,"/"],[3,"phase_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/unassign_evaluator/:phase_id/:project_id/:person_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {any} project_id
 * @param {any} person_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_unassign_evaluator_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"project_id":{"r":true},"person_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"unassign_evaluator"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"person_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/undo_evaluation/:project_id/:content_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} content_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_undo_evaluation_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"content_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"undo_evaluation"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"content_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/undo_submit/:phase_id/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_undo_submit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"undo_submit"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/update_data_sheet/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_update_data_sheet_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"update_data_sheet"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/update_editing_locks/:project_id/:editor_type/:is_locked(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} editor_type
 * @param {any} is_locked
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_update_editing_locks_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"editor_type":{"r":true},"is_locked":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"update_editing_locks"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"editor_type"],[2,[7,"/"],[2,[3,"is_locked"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/update_monitoring_status/:project_id/:monitoring_enabled(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} monitoring_enabled
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_update_monitoring_status_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"monitoring_enabled":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"update_monitoring_status"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"monitoring_enabled"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/update_phase_decision_comment/:note_id/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} note_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_update_phase_decision_comment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"note_id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"update_phase_decision_comment"],[2,[7,"/"],[2,[3,"note_id"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/update_phase_multi_decision_comment/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_update_phase_multi_decision_comment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"update_phase_multi_decision_comment"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/update_phase_status/:note_id/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} note_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_update_phase_status_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"note_id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"update_phase_status"],[2,[7,"/"],[2,[3,"note_id"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/update_phase_status_bulk/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_update_phase_status_bulk_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"update_phase_status_bulk"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/update_visible_columns/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_update_visible_columns_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"update_visible_columns"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/upload_attachment(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_upload_attachment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"upload_attachment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_user_group/create(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_user_group_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_user_group"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_user_group/:id/delete(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_user_group_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_user_group"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_user_group/:id/edit(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_user_group_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_user_group"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_user_group/:id/edit_name(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_user_group_edit_name_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_user_group"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_user_group/list(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_user_group_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_user_group"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_user_group/new(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_user_group_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_user_group"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_user_group/:id/update(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_user_group_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_user_group"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_user_group/:id/update_name(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_user_group_update_name_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_user_group"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/validate_form/:note_id/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} note_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_validate_form_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"note_id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"validate_form"],[2,[7,"/"],[2,[3,"note_id"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_workspace/:project_id/get_json(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_get_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_workspace"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"get_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_workspace/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_workspace"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_workspace/:project_id/update(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_workspace"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/public_dash/:id/clone(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_dashboard_clone_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"public_dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/public_dash/create(/:type)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_dashboard_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"type":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"public_dash"],[2,[7,"/"],[2,[6,"create"],[2,[1,[2,[7,"/"],[3,"type"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/public_dash/:id/delete(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_dashboard_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"public_dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/public_dash/:id/edit(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_dashboard_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"public_dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/public_dash/:id/edit_widgets(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_dashboard_edit_widgets_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"public_dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_widgets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/public_dashboard/:id/clone(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_dashboard_legacy_clone_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"public_dashboard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/public_dashboard/create(/:type)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_dashboard_legacy_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"type":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"public_dashboard"],[2,[7,"/"],[2,[6,"create"],[2,[1,[2,[7,"/"],[3,"type"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/public_dashboard/:id/delete(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_dashboard_legacy_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"public_dashboard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/public_dashboard/:id/edit(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_dashboard_legacy_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"public_dashboard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/public_dashboard/:id/edit_widgets(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_dashboard_legacy_edit_widgets_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"public_dashboard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_widgets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/public_dashboard/new(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_dashboard_legacy_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"public_dashboard"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/d/:dashboard_name(.:format)
 * @param {any} programme_identifier
 * @param {any} dashboard_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_dashboard_legacy_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"dashboard_name":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"d"],[2,[7,"/"],[2,[3,"dashboard_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/public_dashboard/:id/update(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_dashboard_legacy_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"public_dashboard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/public_dashboard/:id/update_widgets(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_dashboard_legacy_update_widgets_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"public_dashboard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_widgets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/public_dash/new(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_dashboard_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"public_dash"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/pd/:dashboard_name(.:format)
 * @param {any} programme_identifier
 * @param {any} dashboard_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_dashboard_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"dashboard_name":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[3,"dashboard_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/public_dash/:id/update(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_dashboard_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"public_dash"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/public_form/form/:person_id/:token(.:format)
 * @param {any} person_id
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_form_render_path = /*#__PURE__*/ __jsr.r({"locale":{},"person_id":{"r":true},"token":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"public_form"],[2,[7,"/"],[2,[6,"form"],[2,[7,"/"],[2,[3,"person_id"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/public_form/save_answer/:person_id/:token(.:format)
 * @param {any} person_id
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_form_save_answer_path = /*#__PURE__*/ __jsr.r({"locale":{},"person_id":{"r":true},"token":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"public_form"],[2,[7,"/"],[2,[6,"save_answer"],[2,[7,"/"],[2,[3,"person_id"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/docai/query(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const query_docai_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"docai"],[2,[7,"/"],[2,[6,"query"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/docai/query_thread/:thread_id(.:format)
 * @param {any} programme_identifier
 * @param {any} thread_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const query_docai_thread_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"thread_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"docai"],[2,[7,"/"],[2,[6,"query_thread"],[2,[7,"/"],[2,[3,"thread_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_incinerate_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_reroute_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_sources_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailgun_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_health_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_postmark_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_relay_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_sendgrid_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/report/create(/:programme_id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"create"],[2,[1,[2,[7,"/"],[3,"programme_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/report/delete/:report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/report/edit/:report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/report/report_data/:report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_get_data_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"report_data"],[2,[7,"/"],[2,[3,"report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/report/new(/:programme_id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"new"],[2,[1,[2,[7,"/"],[3,"programme_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/report/show/:report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"show"],[2,[7,"/"],[2,[3,"report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/report/dashboard/:report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_show_dashboard_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[3,"report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/report/report_to_excel/:report_id(/:status)(.:format)
 * @param {any} programme_identifier
 * @param {any} report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_to_excel_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"report_id":{"r":true},"status":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"report_to_excel"],[2,[7,"/"],[2,[3,"report_id"],[2,[1,[2,[7,"/"],[3,"status"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/report/update/:report_id(.:format)
 * @param {any} programme_identifier
 * @param {any} report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"update"],[2,[7,"/"],[2,[3,"report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/report/variable/create(/:programme_id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_variable_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"variable"],[2,[7,"/"],[2,[6,"create"],[2,[1,[2,[7,"/"],[3,"programme_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/report/variable/delete/:variable_id(.:format)
 * @param {any} programme_identifier
 * @param {any} variable_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_variable_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"variable_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"variable"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"variable_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/report/variable/edit/:variable_id(.:format)
 * @param {any} programme_identifier
 * @param {any} variable_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_variable_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"variable_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"variable"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"variable_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/report/variable/edit_inputs/:variable_id(.:format)
 * @param {any} programme_identifier
 * @param {any} variable_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_variable_edit_inputs_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"variable_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"variable"],[2,[7,"/"],[2,[6,"edit_inputs"],[2,[7,"/"],[2,[3,"variable_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/report/variables(/:programme_id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_variable_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"variables"],[2,[1,[2,[7,"/"],[3,"programme_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/report/variables_json(/:programme_id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_variable_list_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"variables_json"],[2,[1,[2,[7,"/"],[3,"programme_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/report/variable/new(/:programme_id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_variable_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"variable"],[2,[7,"/"],[2,[6,"new"],[2,[1,[2,[7,"/"],[3,"programme_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/report/variable/update/:variable_id(.:format)
 * @param {any} programme_identifier
 * @param {any} variable_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_variable_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"variable_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"variable"],[2,[7,"/"],[2,[6,"update"],[2,[7,"/"],[2,[3,"variable_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/report/variable/update_inputs/:variable_id(.:format)
 * @param {any} programme_identifier
 * @param {any} variable_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_variable_update_inputs_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"variable_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"variable"],[2,[7,"/"],[2,[6,"update_inputs"],[2,[7,"/"],[2,[3,"variable_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/report/variable/value/:variable_id(.:format)
 * @param {any} programme_identifier
 * @param {any} variable_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_variable_value_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"variable_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"variable"],[2,[7,"/"],[2,[6,"value"],[2,[7,"/"],[2,[3,"variable_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/reports(/:programme_id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"reports"],[2,[1,[2,[7,"/"],[3,"programme_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/request_login_link(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const request_partner_login_link_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"request_login_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)(/:programme_identifier)/reset_password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_password_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[1,[2,[7,"/"],[3,"programme_identifier"]]],[2,[7,"/"],[2,[6,"reset_password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/resource_locked/:locked_by(.:format)
 * @param {any} locked_by
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resource_locked_path = /*#__PURE__*/ __jsr.r({"locale":{},"locked_by":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"resource_locked"],[2,[7,"/"],[2,[3,"locked_by"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/activity_form_options/:result_framework_id(.:format)
 * @param {any} programme_identifier
 * @param {any} result_framework_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_activity_form_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"result_framework_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"activity_form_options"],[2,[7,"/"],[2,[3,"result_framework_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/common_indicator_in_use/:indicator_id(.:format)
 * @param {any} programme_identifier
 * @param {any} indicator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_common_indicator_in_use_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"indicator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"common_indicator_in_use"],[2,[7,"/"],[2,[3,"indicator_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/create_activity/:result_id(.:format)
 * @param {any} programme_identifier
 * @param {any} result_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_create_activity_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"result_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"create_activity"],[2,[7,"/"],[2,[3,"result_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/create_indicator/:result_id(.:format)
 * @param {any} programme_identifier
 * @param {any} result_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_create_indicator_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"result_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"create_indicator"],[2,[7,"/"],[2,[3,"result_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/create_result/:result_framework_id(.:format)
 * @param {any} programme_identifier
 * @param {any} result_framework_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_create_result_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"result_framework_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"create_result"],[2,[7,"/"],[2,[3,"result_framework_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/create_result_linking/:result_id(.:format)
 * @param {any} programme_identifier
 * @param {any} result_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_create_result_linking_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"result_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"create_result_linking"],[2,[7,"/"],[2,[3,"result_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/delete_activity/:activity_id(.:format)
 * @param {any} programme_identifier
 * @param {any} activity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_delete_activity_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"activity_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"delete_activity"],[2,[7,"/"],[2,[3,"activity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/delete_indicator/:indicator_id(.:format)
 * @param {any} programme_identifier
 * @param {any} indicator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_delete_indicator_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"indicator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"delete_indicator"],[2,[7,"/"],[2,[3,"indicator_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/delete_result/:result_id(.:format)
 * @param {any} programme_identifier
 * @param {any} result_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_delete_result_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"result_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"delete_result"],[2,[7,"/"],[2,[3,"result_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/delete_result_linking/:result_linking_id(.:format)
 * @param {any} programme_identifier
 * @param {any} result_linking_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_delete_result_linking_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"result_linking_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"delete_result_linking"],[2,[7,"/"],[2,[3,"result_linking_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/edit_activity_dialog/:activity_id(.:format)
 * @param {any} programme_identifier
 * @param {any} activity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_edit_activity_dialog_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"activity_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"edit_activity_dialog"],[2,[7,"/"],[2,[3,"activity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/edit_indicator/:indicator_id(.:format)
 * @param {any} programme_identifier
 * @param {any} indicator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_edit_indicator_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"indicator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"edit_indicator"],[2,[7,"/"],[2,[3,"indicator_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/edit_indicator_linking/:indicator_id(.:format)
 * @param {any} programme_identifier
 * @param {any} indicator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_edit_indicator_linking_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"indicator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"edit_indicator_linking"],[2,[7,"/"],[2,[3,"indicator_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/result_form_options/:result_framework_id(.:format)
 * @param {any} programme_identifier
 * @param {any} result_framework_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_form_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"result_framework_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"result_form_options"],[2,[7,"/"],[2,[3,"result_framework_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/get(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_framework_get_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"get"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/list_common_indicators_for_programme(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_framework_list_common_indicators_for_programme_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"list_common_indicators_for_programme"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/pdf/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_framework_pdf_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"pdf"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/show(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_framework_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"show"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework_template/apply/:template_id(.:format)
 * @param {any} programme_identifier
 * @param {any} template_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_framework_template_apply_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"template_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework_template"],[2,[7,"/"],[2,[6,"apply"],[2,[7,"/"],[2,[3,"template_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework_template/apply_common_indicators/:template_id(.:format)
 * @param {any} programme_identifier
 * @param {any} template_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_framework_template_apply_common_indicators_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"template_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework_template"],[2,[7,"/"],[2,[6,"apply_common_indicators"],[2,[7,"/"],[2,[3,"template_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework_template/clone/:template_id(.:format)
 * @param {any} programme_identifier
 * @param {any} template_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_framework_template_clone_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"template_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework_template"],[2,[7,"/"],[2,[6,"clone"],[2,[7,"/"],[2,[3,"template_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework_template/create(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_framework_template_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework_template"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework_template/delete/:template_id(.:format)
 * @param {any} programme_identifier
 * @param {any} template_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_framework_template_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"template_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework_template"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"template_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework_template/edit/:template_id(.:format)
 * @param {any} programme_identifier
 * @param {any} template_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_framework_template_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"template_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework_template"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"template_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework_template/list(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_framework_template_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework_template"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework_template/new(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_framework_template_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework_template"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework_template/perform_apply/:template_id(.:format)
 * @param {any} programme_identifier
 * @param {any} template_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_framework_template_perform_apply_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"template_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework_template"],[2,[7,"/"],[2,[6,"perform_apply"],[2,[7,"/"],[2,[3,"template_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework_template/perform_apply_common_indicators/:template_id(.:format)
 * @param {any} programme_identifier
 * @param {any} template_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_framework_template_perform_apply_common_indicators_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"template_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework_template"],[2,[7,"/"],[2,[6,"perform_apply_common_indicators"],[2,[7,"/"],[2,[3,"template_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework_template/set_as_default/:template_id(.:format)
 * @param {any} programme_identifier
 * @param {any} template_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_framework_template_set_as_default_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"template_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework_template"],[2,[7,"/"],[2,[6,"set_as_default"],[2,[7,"/"],[2,[3,"template_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework_template/show/:template_id(.:format)
 * @param {any} programme_identifier
 * @param {any} template_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_framework_template_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"template_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework_template"],[2,[7,"/"],[2,[6,"show"],[2,[7,"/"],[2,[3,"template_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework_template/update/:template_id(.:format)
 * @param {any} programme_identifier
 * @param {any} template_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_framework_template_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"template_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework_template"],[2,[7,"/"],[2,[6,"update"],[2,[7,"/"],[2,[3,"template_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/indicator_form_options/:result_framework_id(/:indicator_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} result_framework_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_indicator_form_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"result_framework_id":{"r":true},"indicator_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"indicator_form_options"],[2,[7,"/"],[2,[3,"result_framework_id"],[2,[1,[2,[7,"/"],[3,"indicator_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/link_sdg/:result_id(.:format)
 * @param {any} programme_identifier
 * @param {any} result_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_link_sdg_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"result_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"link_sdg"],[2,[7,"/"],[2,[3,"result_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/linking_results/:project_id/:result_framework_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} result_framework_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_list_results_for_linking_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"result_framework_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"linking_results"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"result_framework_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/new_indicator/:result_id(.:format)
 * @param {any} programme_identifier
 * @param {any} result_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_new_indicator_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"result_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"new_indicator"],[2,[7,"/"],[2,[3,"result_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/new_result_linking/:result_id(.:format)
 * @param {any} programme_identifier
 * @param {any} result_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_new_result_linking_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"result_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"new_result_linking"],[2,[7,"/"],[2,[3,"result_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/open_qualitative_indicator_file/:filename/:indicator_id(.:format)
 * @param {any} programme_identifier
 * @param {any} filename
 * @param {any} indicator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_open_qualitative_indicator_file_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"filename":{"r":true},"indicator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"open_qualitative_indicator_file"],[2,[7,"/"],[2,[3,"filename"],[2,[7,"/"],[2,[3,"indicator_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/perform_link_sdg/:result_id(.:format)
 * @param {any} programme_identifier
 * @param {any} result_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_perform_link_sdg_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"result_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"perform_link_sdg"],[2,[7,"/"],[2,[3,"result_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/project_baseline_and_targets/:indicator_id(.:format)
 * @param {any} programme_identifier
 * @param {any} indicator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_project_baseline_and_targets_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"indicator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"project_baseline_and_targets"],[2,[7,"/"],[2,[3,"indicator_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/toggle_common_indicator_visibility/:indicator_id(.:format)
 * @param {any} programme_identifier
 * @param {any} indicator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_toggle_common_indicator_visibility_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"indicator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"toggle_common_indicator_visibility"],[2,[7,"/"],[2,[3,"indicator_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/update_activity/:activity_id(.:format)
 * @param {any} programme_identifier
 * @param {any} activity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_update_activity_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"activity_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"update_activity"],[2,[7,"/"],[2,[3,"activity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/update_activity_dialog/:activity_id(.:format)
 * @param {any} programme_identifier
 * @param {any} activity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_update_activity_dialog_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"activity_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"update_activity_dialog"],[2,[7,"/"],[2,[3,"activity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/update_indicator/:indicator_id(.:format)
 * @param {any} programme_identifier
 * @param {any} indicator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_update_indicator_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"indicator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"update_indicator"],[2,[7,"/"],[2,[3,"indicator_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/update_indicator_linking/:indicator_id(.:format)
 * @param {any} programme_identifier
 * @param {any} indicator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_update_indicator_linking_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"indicator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"update_indicator_linking"],[2,[7,"/"],[2,[3,"indicator_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/update_indicator_parent/:indicator_id(.:format)
 * @param {any} programme_identifier
 * @param {any} indicator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_update_indicator_parent_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"indicator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"update_indicator_parent"],[2,[7,"/"],[2,[3,"indicator_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/update_project_baseline_and_targets/:indicator_id(.:format)
 * @param {any} programme_identifier
 * @param {any} indicator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_update_project_baseline_and_targets_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"indicator_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"update_project_baseline_and_targets"],[2,[7,"/"],[2,[3,"indicator_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/update_result/:result_id(.:format)
 * @param {any} programme_identifier
 * @param {any} result_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_update_result_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"result_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"update_result"],[2,[7,"/"],[2,[3,"result_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/update_result_framework_order(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_update_result_framework_order_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"update_result_framework_order"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/update_visibility/:result_id/:closed(.:format)
 * @param {any} programme_identifier
 * @param {any} result_id
 * @param {any} closed
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_update_visibility_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"result_id":{"r":true},"closed":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"update_visibility"],[2,[7,"/"],[2,[3,"result_id"],[2,[7,"/"],[2,[3,"closed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/result_framework/qualitative_indicator_upload_file/:result_framework_id/:upload_id(.:format)
 * @param {any} programme_identifier
 * @param {any} result_framework_id
 * @param {any} upload_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_upload_qualitative_indicator_file_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"result_framework_id":{"r":true},"upload_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"result_framework"],[2,[7,"/"],[2,[6,"qualitative_indicator_upload_file"],[2,[7,"/"],[2,[3,"result_framework_id"],[2,[7,"/"],[2,[3,"upload_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/risk_management/create_datagrid/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const risk_management_create_datagrid_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"risk_management"],[2,[7,"/"],[2,[6,"create_datagrid"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/risk_management/data/:project_id(/:context)(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const risk_management_data_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"context":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"risk_management"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[2,[3,"project_id"],[2,[1,[2,[7,"/"],[3,"context"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/risk_management/get_datagrid/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const risk_management_get_datagrid_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"risk_management"],[2,[7,"/"],[2,[6,"get_datagrid"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/risk_management/monitoring/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const risk_management_monitoring_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"risk_management"],[2,[7,"/"],[2,[6,"monitoring"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/risk_management/monitoring/:project_id/portfolio(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const risk_management_monitoring_portfolio_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"risk_management"],[2,[7,"/"],[2,[6,"monitoring"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"portfolio"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api-docs
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rswag_api_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"api-docs"]]);

/**
 * Generates rails route to
 * /api-docs
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rswag_ui_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"api-docs"]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/saml/consume(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const saml_consume_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"consume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/saml/init(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const saml_init_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"init"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/saml/metadata(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const saml_metadata_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"metadata"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/search_by_identifier(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_projects_by_identifier_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"search_by_identifier"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project_call_phase/send_evaluation_summary_email/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_evaluation_summary_email_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project_call_phase"],[2,[7,"/"],[2,[6,"send_evaluation_summary_email"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/partners/:programme_id/show/:partner_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} partner_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_partner_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"partner_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"show"],[2,[7,"/"],[2,[3,"partner_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/setting/site_help_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const site_help_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"setting"],[2,[7,"/"],[2,[6,"site_help_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/sms/check_confirmation/:identifier/:confirmation_code(.:format)
 * @param {any} programme_identifier
 * @param {any} identifier
 * @param {any} confirmation_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sms_check_confirmation_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"identifier":{"r":true},"confirmation_code":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"sms"],[2,[7,"/"],[2,[6,"check_confirmation"],[2,[7,"/"],[2,[3,"identifier"],[2,[7,"/"],[2,[3,"confirmation_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/sms/new_confirmation/:type(.:format)
 * @param {any} programme_identifier
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sms_new_confirmation_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"type":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"sms"],[2,[7,"/"],[2,[6,"new_confirmation"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/sms/receive_status_report(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sms_receive_status_report_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"sms"],[2,[7,"/"],[2,[6,"receive_status_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/sso_login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sso_login_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"sso_login"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/status/mail(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const status_mail_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"status"],[2,[7,"/"],[2,[6,"mail"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/status/scheduled_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const status_scheduled_tasks_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"status"],[2,[7,"/"],[2,[6,"scheduled_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/success_stories/create/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const success_story_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"success_stories"],[2,[7,"/"],[2,[6,"create"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/success_stories/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const success_story_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"success_stories"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/success_stories_json/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const success_story_list_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"success_stories_json"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/success_stories/open/:project_id/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const success_story_open_image_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"success_stories"],[2,[7,"/"],[2,[6,"open"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/ss/:identifier(.:format)
 * @param {any} programme_identifier
 * @param {any} identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const success_story_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"ss"],[2,[7,"/"],[2,[3,"identifier"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/success_stories/update/:project_id/:sid(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} sid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const success_story_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"sid":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"success_stories"],[2,[7,"/"],[2,[6,"update"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"sid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/success_stories/upload/:project_id/:upload_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} upload_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const success_story_upload_image_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"upload_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"success_stories"],[2,[7,"/"],[2,[6,"upload"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[3,"upload_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/supplier(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const supplier_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"supplier"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/supplier/list(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const supplier_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"supplier"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/supplier/list_json(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const supplier_list_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"supplier"],[2,[7,"/"],[2,[6,"list_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/supplier/support(/:case_id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const supplier_support_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"case_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"supplier"],[2,[7,"/"],[2,[6,"support"],[2,[1,[2,[7,"/"],[3,"case_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/support/create/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const support_case_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"create"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/support/:programme_id/new(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const support_form_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/support/:programme_id/delete/:support_form_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} support_form_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const support_form_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"support_form_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"support_form_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/support/:programme_id/edit/:support_form_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} support_form_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const support_form_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"support_form_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"support_form_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/support/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const support_form_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/support/:project_id/requests(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const support_form_list_requests_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/support/:programme_id/new(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const support_form_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/support/:project_id/request/show/:identifier(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const support_form_show_request_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"show"],[2,[7,"/"],[2,[3,"identifier"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/support/:programme_id/edit/:support_form_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} support_form_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const support_form_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"support_form_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"support_form_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/monitor/support/:project_id/update_visible_columns(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const support_form_update_visible_columns_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"monitor"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"update_visible_columns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/support/create_comment(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const support_request_create_comment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"create_comment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/support_request/edit_assignee/:identifier(.:format)
 * @param {any} programme_identifier
 * @param {any} identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const support_request_edit_assignee_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"support_request"],[2,[7,"/"],[2,[6,"edit_assignee"],[2,[7,"/"],[2,[3,"identifier"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/support_request/update_assignee/:support_request_id/:person_id(.:format)
 * @param {any} programme_identifier
 * @param {any} support_request_id
 * @param {any} person_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const support_request_update_assignee_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"support_request_id":{"r":true},"person_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"support_request"],[2,[7,"/"],[2,[6,"update_assignee"],[2,[7,"/"],[2,[3,"support_request_id"],[2,[7,"/"],[2,[3,"person_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/support/update_comment(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const support_request_update_comment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"update_comment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/support_request/update_status/:support_request_id/:status(.:format)
 * @param {any} programme_identifier
 * @param {any} support_request_id
 * @param {any} status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const support_request_update_status_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"support_request_id":{"r":true},"status":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"support_request"],[2,[7,"/"],[2,[6,"update_status"],[2,[7,"/"],[2,[3,"support_request_id"],[2,[7,"/"],[2,[3,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/support/update_user_settings(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const support_request_update_user_settings_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"update_user_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/support/show_support_request/:identifier(.:format)
 * @param {any} programme_identifier
 * @param {any} identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const support_show_support_request_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"show_support_request"],[2,[7,"/"],[2,[3,"identifier"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/survey/download_attachment/:programme_form_link_id/:survey_api_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_form_link_id
 * @param {any} survey_api_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const survey_download_attachment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_form_link_id":{"r":true},"survey_api_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"survey"],[2,[7,"/"],[2,[6,"download_attachment"],[2,[7,"/"],[2,[3,"programme_form_link_id"],[2,[7,"/"],[2,[3,"survey_api_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/survey/:survey_api_id(.:format)
 * @param {any} programme_identifier
 * @param {any} survey_api_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const survey_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"survey_api_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"survey"],[2,[7,"/"],[2,[3,"survey_api_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/survey_filled(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const survey_filled_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"survey_filled"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/survey/:survey_api_id/form/:programme_form_link_id(.:format)
 * @param {any} programme_identifier
 * @param {any} survey_api_id
 * @param {any} programme_form_link_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const survey_form_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"survey_api_id":{"r":true},"programme_form_link_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"survey"],[2,[7,"/"],[2,[3,"survey_api_id"],[2,[7,"/"],[2,[6,"form"],[2,[7,"/"],[2,[3,"programme_form_link_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/survey/new/:report_api_id(/:assignee_api_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} report_api_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const survey_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"report_api_id":{"r":true},"assignee_api_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"survey"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[3,"report_api_id"],[2,[1,[2,[7,"/"],[3,"assignee_api_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/survey/:survey_api_id/save_form/:programme_form_link_id(.:format)
 * @param {any} programme_identifier
 * @param {any} survey_api_id
 * @param {any} programme_form_link_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const survey_save_form_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"survey_api_id":{"r":true},"programme_form_link_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"survey"],[2,[7,"/"],[2,[3,"survey_api_id"],[2,[7,"/"],[2,[6,"save_form"],[2,[7,"/"],[2,[3,"programme_form_link_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/survey/:survey_api_id/submit(.:format)
 * @param {any} programme_identifier
 * @param {any} survey_api_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const survey_submit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"survey_api_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"survey"],[2,[7,"/"],[2,[3,"survey_api_id"],[2,[7,"/"],[2,[6,"submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/survey_filled(/:survey_api_id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const survey_successfully_filled_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"survey_api_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"survey_filled"],[2,[1,[2,[7,"/"],[3,"survey_api_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/survey/upload_attachment(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const survey_upload_attachment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"survey"],[2,[7,"/"],[2,[6,"upload_attachment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/task/column_options/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_column_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"task"],[2,[7,"/"],[2,[6,"column_options"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/task/create(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"task"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/task_link/create/:source/:target/:link_type/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} source
 * @param {any} target
 * @param {any} link_type
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_create_link_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"source":{"r":true},"target":{"r":true},"link_type":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"task_link"],[2,[7,"/"],[2,[6,"create"],[2,[7,"/"],[2,[3,"source"],[2,[7,"/"],[2,[3,"target"],[2,[7,"/"],[2,[3,"link_type"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/task_link/delete/:link_id/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} link_id
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_delete_link_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"link_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"task_link"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"link_id"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/task/edit_assignee/:task_id(.:format)
 * @param {any} programme_identifier
 * @param {any} task_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_edit_assignee_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"task_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"task"],[2,[7,"/"],[2,[6,"edit_assignee"],[2,[7,"/"],[2,[3,"task_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/task/form_options/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_form_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"task"],[2,[7,"/"],[2,[6,"form_options"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/task/links/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_links_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"task"],[2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/tasks(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/tasks_json/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_list_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"tasks_json"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/tasks_programme(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_list_programme_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"tasks_programme"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/task/monitoring/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_monitoring_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"task"],[2,[7,"/"],[2,[6,"monitoring"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/task/:identifier(.:format)
 * @param {any} programme_identifier
 * @param {any} identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"task"],[2,[7,"/"],[2,[3,"identifier"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/task/status_options(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_status_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"task"],[2,[7,"/"],[2,[6,"status_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/task_title_list_json(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_title_list_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"task_title_list_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/task/update(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"task"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/task/update_assignee/:task_id/:person_id(.:format)
 * @param {any} programme_identifier
 * @param {any} task_id
 * @param {any} person_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_update_assignee_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"task_id":{"r":true},"person_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"task"],[2,[7,"/"],[2,[6,"update_assignee"],[2,[7,"/"],[2,[3,"task_id"],[2,[7,"/"],[2,[3,"person_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/task/update_status/:task_id/:status(.:format)
 * @param {any} programme_identifier
 * @param {any} task_id
 * @param {any} status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_update_status_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"task_id":{"r":true},"status":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"task"],[2,[7,"/"],[2,[6,"update_status"],[2,[7,"/"],[2,[3,"task_id"],[2,[7,"/"],[2,[3,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/tasks/update_visible_columns/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_update_visible_columns_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"update_visible_columns"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/tender/delete_phase/:tender_id/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} tender_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_delete_phase_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"tender_id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"tender"],[2,[7,"/"],[2,[6,"delete_phase"],[2,[7,"/"],[2,[3,"tender_id"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/tender/edit_phase_status/:status/:phase_id/:tender_id(.:format)
 * @param {any} programme_identifier
 * @param {any} status
 * @param {any} phase_id
 * @param {any} tender_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_edit_phase_status_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"status":{"r":true},"phase_id":{"r":true},"tender_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"tender"],[2,[7,"/"],[2,[6,"edit_phase_status"],[2,[7,"/"],[2,[3,"status"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[3,"tender_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/tender/evaluate/:tender_id(/:phase_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} tender_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_evaluate_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"tender_id":{"r":true},"phase_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"tender"],[2,[7,"/"],[2,[6,"evaluate"],[2,[7,"/"],[2,[3,"tender_id"],[2,[1,[2,[7,"/"],[3,"phase_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/supplier/tender/form/:phase_id/:tender_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {any} tender_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_form_supplier_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"tender_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"supplier"],[2,[7,"/"],[2,[6,"tender"],[2,[7,"/"],[2,[6,"form"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[3,"tender_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/tenders/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_list_phase_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"tenders"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/supplier/tenders(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_list_supplier_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"supplier"],[2,[7,"/"],[2,[6,"tenders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/supplier/tender_notice/:notice_id/apply(.:format)
 * @param {any} programme_identifier
 * @param {any} notice_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_notice_apply_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"notice_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"supplier"],[2,[7,"/"],[2,[6,"tender_notice"],[2,[7,"/"],[2,[3,"notice_id"],[2,[7,"/"],[2,[6,"apply"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/tender_notice/new/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_notice_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"tender_notice"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/tender_notice/delete/:notice_id(.:format)
 * @param {any} programme_identifier
 * @param {any} notice_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_notice_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"notice_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"tender_notice"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"notice_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/tender_notice/edit/:notice_id(.:format)
 * @param {any} programme_identifier
 * @param {any} notice_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_notice_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"notice_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"tender_notice"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"notice_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/tender_notice_phase/send_email/:notice_id(.:format)
 * @param {any} programme_identifier
 * @param {any} notice_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_notice_email_send_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"notice_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"tender_notice_phase"],[2,[7,"/"],[2,[6,"send_email"],[2,[7,"/"],[2,[3,"notice_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/list/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_notice_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"list"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/tender_notice/list_json/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_notice_list_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"tender_notice"],[2,[7,"/"],[2,[6,"list_json"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/tender_notice/list/management/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_notice_list_management_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"tender_notice"],[2,[7,"/"],[2,[6,"list"],[2,[7,"/"],[2,[6,"management"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/tender_notice/list/management_json/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_notice_list_management_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"tender_notice"],[2,[7,"/"],[2,[6,"list"],[2,[7,"/"],[2,[6,"management_json"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/supplier/tender_notices/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_notice_list_supplier_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"supplier"],[2,[7,"/"],[2,[6,"tender_notices"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/tender_notice/list/supplier_json/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_notice_list_supplier_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"tender_notice"],[2,[7,"/"],[2,[6,"list"],[2,[7,"/"],[2,[6,"supplier_json"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/tender_notice/new/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_notice_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"tender_notice"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/tender_notice_phase/assign_evaluator/:phase_id/:tender_id/:person_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {any} tender_id
 * @param {any} person_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_notice_phase_assign_evaluator_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"tender_id":{"r":true},"person_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"tender_notice_phase"],[2,[7,"/"],[2,[6,"assign_evaluator"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[3,"tender_id"],[2,[7,"/"],[2,[3,"person_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/tender_notice_phase/new/:type/:notice_id(.:format)
 * @param {any} programme_identifier
 * @param {any} type
 * @param {any} notice_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_notice_phase_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"type":{"r":true},"notice_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"tender_notice_phase"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"notice_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/tender_notice_phase/delete/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_notice_phase_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"tender_notice_phase"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/tender_notice_phase/edit/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_notice_phase_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"tender_notice_phase"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/tender_notice_phase/edit_evaluators/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_notice_phase_edit_evaluators_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"tender_notice_phase"],[2,[7,"/"],[2,[6,"edit_evaluators"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/tender_notice_phase/new/:type/:notice_id(.:format)
 * @param {any} programme_identifier
 * @param {any} type
 * @param {any} notice_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_notice_phase_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"type":{"r":true},"notice_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"tender_notice_phase"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"notice_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/:notice_id/phase(.:format)
 * @param {any} programme_identifier
 * @param {any} notice_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_notice_phase_resolve_phase_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"notice_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[3,"notice_id"],[2,[7,"/"],[2,[6,"phase"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/:notice_id/phase/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} notice_id
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_notice_phase_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"notice_id":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[3,"notice_id"],[2,[7,"/"],[2,[6,"phase"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/tender_notice_phase/unassign_evaluator/:phase_id/:tender_id/:person_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {any} tender_id
 * @param {any} person_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_notice_phase_unassign_evaluator_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"tender_id":{"r":true},"person_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"tender_notice_phase"],[2,[7,"/"],[2,[6,"unassign_evaluator"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[3,"tender_id"],[2,[7,"/"],[2,[3,"person_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/tender_notice_phase/edit/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_notice_phase_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"tender_notice_phase"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/tender_notice_phase/edit_evaluators/:phase_id(.:format)
 * @param {any} programme_identifier
 * @param {any} phase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_notice_phase_update_evaluators_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"phase_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"tender_notice_phase"],[2,[7,"/"],[2,[6,"edit_evaluators"],[2,[7,"/"],[2,[3,"phase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/tender_notice_phase/update_order/:notice_id(.:format)
 * @param {any} programme_identifier
 * @param {any} notice_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_notice_phase_update_order_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"notice_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"tender_notice_phase"],[2,[7,"/"],[2,[6,"update_order"],[2,[7,"/"],[2,[3,"notice_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/tender_notice/management/:notice_id(.:format)
 * @param {any} programme_identifier
 * @param {any} notice_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_notice_show_management_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"notice_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"tender_notice"],[2,[7,"/"],[2,[6,"management"],[2,[7,"/"],[2,[3,"notice_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/supplier/tender_notice/:notice_id(.:format)
 * @param {any} programme_identifier
 * @param {any} notice_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_notice_show_supplier_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"notice_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"supplier"],[2,[7,"/"],[2,[6,"tender_notice"],[2,[7,"/"],[2,[3,"notice_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/tender_notice/edit/:notice_id(.:format)
 * @param {any} programme_identifier
 * @param {any} notice_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_notice_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"notice_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"tender_notice"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"notice_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/tender/progress/:tender_id(/:phase_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} tender_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_progress_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"tender_id":{"r":true},"phase_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"tender"],[2,[7,"/"],[2,[6,"progress"],[2,[7,"/"],[2,[3,"tender_id"],[2,[1,[2,[7,"/"],[3,"phase_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/supplier/tender/progress/:tender_id(.:format)
 * @param {any} programme_identifier
 * @param {any} tender_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_progress_supplier_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"tender_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"supplier"],[2,[7,"/"],[2,[6,"tender"],[2,[7,"/"],[2,[6,"progress"],[2,[7,"/"],[2,[3,"tender_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/procurement/tender/update_phase_status/:status/:phase_id/:tender_id(.:format)
 * @param {any} programme_identifier
 * @param {any} status
 * @param {any} phase_id
 * @param {any} tender_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tender_update_phase_status_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"status":{"r":true},"phase_id":{"r":true},"tender_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"tender"],[2,[7,"/"],[2,[6,"update_phase_status"],[2,[7,"/"],[2,[3,"status"],[2,[7,"/"],[2,[3,"phase_id"],[2,[7,"/"],[2,[3,"tender_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /recede_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_recede_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recede_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /refresh_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_refresh_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"refresh_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /resume_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_resume_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resume_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/files
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tus_server_path = /*#__PURE__*/ __jsr.r({"locale":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[6,"files"]]]);

/**
 * Generates rails route to
 * (/:locale)/companion/update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_companion_preferences_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"companion"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/partners/update/:partner_content_id(.:format)
 * @param {any} programme_identifier
 * @param {any} partner_content_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_partner_details_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"partner_content_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[6,"update"],[2,[7,"/"],[2,[3,"partner_content_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/partners/update_details/:code(.:format)
 * @param {any} programme_identifier
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_partner_details_with_code_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"code":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[6,"update_details"],[2,[7,"/"],[2,[3,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/:project_id/update_internal_file/:file_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_project_internal_file_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"file_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"update_internal_file"],[2,[7,"/"],[2,[3,"file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/:project_id/update_internal_file_permission/:file_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_project_internal_file_permission_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"file_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"update_internal_file_permission"],[2,[7,"/"],[2,[3,"file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/:project_id/update_shared_file/:file_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_project_shared_file_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"file_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"update_shared_file"],[2,[7,"/"],[2,[3,"file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/tasks/update_marker(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_task_marker_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"update_marker"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/support/upload_comment_attachment(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_comment_attachment_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"upload_comment_attachment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/:project_id/upload_file(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_project_file_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"upload_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/project/:project_id/upload_internal_file(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_project_internal_file_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"upload_internal_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/activate/:code(.:format)
 * @param {any} programme_identifier
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_account_activation_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"code":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"activate"],[2,[7,"/"],[2,[3,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/account_information(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_account_information_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"account_information"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/account_information_edit(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_account_information_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"account_information_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/account_information_update(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_account_information_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"account_information_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/activation/:message(.:format)
 * @param {any} programme_identifier
 * @param {any} message
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_activation_message_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"message":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"activation"],[2,[7,"/"],[2,[3,"message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user_agreement/accept/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_agreement_accept_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user_agreement"],[2,[7,"/"],[2,[6,"accept"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/user_agreement/create/:type(.:format)
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_agreement_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"type":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user_agreement"],[2,[7,"/"],[2,[6,"create"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/user_agreement/delete/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_agreement_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user_agreement"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/user_agreement/edit/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_agreement_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user_agreement"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user_agreement/latest_accepted(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_agreement_latest_accepted_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user_agreement"],[2,[7,"/"],[2,[6,"latest_accepted"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/user_agreement/list(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_agreement_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user_agreement"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/user_agreement/new/:type(.:format)
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_agreement_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"type":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user_agreement"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user_agreement/prompt/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_agreement_prompt_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user_agreement"],[2,[7,"/"],[2,[6,"prompt"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user_agreement/reject/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_agreement_reject_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user_agreement"],[2,[7,"/"],[2,[6,"reject"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/user_agreement/show/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_agreement_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user_agreement"],[2,[7,"/"],[2,[6,"show"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/user_agreement/update/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_agreement_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user_agreement"],[2,[7,"/"],[2,[6,"update"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/user_agreement/update_status/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_agreement_update_status_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user_agreement"],[2,[7,"/"],[2,[6,"update_status"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/cancel_email_change/:code(.:format)
 * @param {any} programme_identifier
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_cancel_email_change_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"code":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"cancel_email_change"],[2,[7,"/"],[2,[3,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/user/change_password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_change_own_password_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"change_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/check_form(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_check_form_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"check_form"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/user/close_system_message(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_close_system_message_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"close_system_message"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/confirm_account_activation(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_confirm_account_activation_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"confirm_account_activation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/confirm_email(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_confirm_email_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"confirm_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/confirm_email_change/:code(.:format)
 * @param {any} programme_identifier
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_confirm_email_change_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"code":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"confirm_email_change"],[2,[7,"/"],[2,[3,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/confirm_registration/:code(.:format)
 * @param {any} programme_identifier
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_confirm_registration_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"code":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"confirm_registration"],[2,[7,"/"],[2,[3,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/create/:programme_identifier(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"create"],[2,[7,"/"],[2,[3,"programme_identifier"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/supplier/login(/:programme_identifier)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_create_supplier_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"supplier"],[2,[7,"/"],[2,[6,"login"],[2,[1,[2,[7,"/"],[3,"programme_identifier"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/download_profile_pic/:profile_pic_id(.:format)
 * @param {any} programme_identifier
 * @param {any} profile_pic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_download_profile_pic_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"profile_pic_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"download_profile_pic"],[2,[7,"/"],[2,[3,"profile_pic_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/edit_account(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_edit_own_account_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"edit_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/email_change_message/:message(.:format)
 * @param {any} programme_identifier
 * @param {any} message
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_email_change_message_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"message":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"email_change_message"],[2,[7,"/"],[2,[3,"message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/management/:project_id/export_external_users_to_excel(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_export_external_users_to_excel_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"management"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"export_external_users_to_excel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/get_thumbnails_for_nav_bar/:user_id(.:format)
 * @param {any} programme_identifier
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_get_thumbnails_for_nav_bar_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"user_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"get_thumbnails_for_nav_bar"],[2,[7,"/"],[2,[3,"user_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/list_available_calls(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_list_available_calls_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"list_available_calls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/user/list_programmes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_list_programmes_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"list_programmes"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/login(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_login_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/login_credentials_update(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_login_credentials_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"login_credentials_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/supplier/confirm_login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_login_supplier_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"supplier"],[2,[7,"/"],[2,[6,"confirm_login"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/user/login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_login_with_resolve_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/logout(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_logout_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/management/:project_id/bulk_delete(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_management_bulk_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"management"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"bulk_delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/management/:project_id/cancel_invitation/:person_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} person_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_management_cancel_invitation_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"person_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"management"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"cancel_invitation"],[2,[7,"/"],[2,[3,"person_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/management/:project_id/create_invitation(/:type)(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_management_create_invitation_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"type":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"management"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"create_invitation"],[2,[1,[2,[7,"/"],[3,"type"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/management/:project_id/delete(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_management_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"management"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/management/:project_id/edit(/:type)(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_management_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"type":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"management"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"edit"],[2,[1,[2,[7,"/"],[3,"type"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/management/edit_own_fund_user_role(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_management_edit_own_fund_user_role_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"management"],[2,[7,"/"],[2,[6,"edit_own_fund_user_role"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/management/:project_id/edit_user_role/:person_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} person_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_management_edit_user_role_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"person_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"management"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"edit_user_role"],[2,[7,"/"],[2,[3,"person_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/management/:project_id/list(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_management_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"management"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/management/:project_id/list_json(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_management_list_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"management"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"list_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/management/:project_id/new_invitation(/:type)(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_management_new_invitation_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"type":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"management"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"new_invitation"],[2,[1,[2,[7,"/"],[3,"type"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/management/:project_id/resend_confirmation/:person_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} person_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_management_resend_confirmation_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"person_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"management"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"resend_confirmation"],[2,[7,"/"],[2,[3,"person_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/management/:project_id/resend_invitation/:person_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} person_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_management_resend_invitation_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"person_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"management"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"resend_invitation"],[2,[7,"/"],[2,[3,"person_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/management/:project_id/toggle_activity/:person_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} person_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_management_toggle_activity_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"person_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"management"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"toggle_activity"],[2,[7,"/"],[2,[3,"person_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/management/:project_id/toggle_permission/:person_id/:permission_str(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} person_id
 * @param {any} permission_str
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_management_toggle_permission_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"person_id":{"r":true},"permission_str":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"management"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"toggle_permission"],[2,[7,"/"],[2,[3,"person_id"],[2,[7,"/"],[2,[3,"permission_str"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/management/:project_id/update(/:type)(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_management_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"type":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"management"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"update"],[2,[1,[2,[7,"/"],[3,"type"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/management/update_own_fund_user_role(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_management_update_own_fund_user_role_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"management"],[2,[7,"/"],[2,[6,"update_own_fund_user_role"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/management/:project_id/update_user_role/:person_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {any} person_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_management_update_user_role_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"person_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"management"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"update_user_role"],[2,[7,"/"],[2,[3,"person_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/login/:programme_identifier(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"login"],[2,[7,"/"],[2,[3,"programme_identifier"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/supplier/login(/:programme_identifier)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_new_supplier_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"supplier"],[2,[7,"/"],[2,[6,"login"],[2,[1,[2,[7,"/"],[3,"programme_identifier"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user_notification/clear_all(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_notification_clear_all_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user_notification"],[2,[7,"/"],[2,[6,"clear_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user_notification/create(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_notification_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user_notification"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user_notification/:id/delete(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_notification_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user_notification"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user_notification/:id/delete_recipient(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_notification_delete_recipient_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user_notification"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_recipient"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user_notification/:id/get(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_notification_get_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user_notification"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user_notification/incoming_notifications(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_notification_incoming_notifications_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user_notification"],[2,[7,"/"],[2,[6,"incoming_notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user_notification/incoming_unread_notifications(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_notification_incoming_unread_notifications_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user_notification"],[2,[7,"/"],[2,[6,"incoming_unread_notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user_notification/list(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_notification_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user_notification"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user_notification/:id/mark_as_read(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_notification_mark_as_read_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user_notification"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_read"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user_notification/:id/publish(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_notification_publish_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user_notification"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user_notification/:id/show(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_notification_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user_notification"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user_notification/:id/update(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_notification_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user_notification"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/perform_send_email/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_perform_send_email_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"perform_send_email"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/register_as_applicant(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_register_as_applicant_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"register_as_applicant"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/registration(/:message)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_registration_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"message":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"registration"],[2,[1,[2,[7,"/"],[3,"message"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/select_call/:call_id(.:format)
 * @param {any} programme_identifier
 * @param {any} call_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_select_call_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"call_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"select_call"],[2,[7,"/"],[2,[3,"call_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/select_programme(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_select_programme_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"select_programme"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/send_email/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_send_email_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"send_email"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/set_locale/:new_locale(.:format)
 * @param {any} programme_identifier
 * @param {any} new_locale
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_set_locale_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"new_locale":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"set_locale"],[2,[7,"/"],[2,[3,"new_locale"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/roles/:programme_id/create/:user_group_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} user_group_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_type_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"user_group_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"create"],[2,[7,"/"],[2,[3,"user_group_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/roles/:programme_id/delete/:user_type_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} user_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_type_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"user_type_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"user_type_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/roles/:programme_id/edit/:user_type_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} user_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_type_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"user_type_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"user_type_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/roles/:programme_id/edit_restrictions/:user_type_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} user_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_type_edit_restrictions_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"user_type_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"edit_restrictions"],[2,[7,"/"],[2,[3,"user_type_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/roles/:programme_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_type_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"programme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/roles/:programme_id/new/:user_group_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} user_group_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_type_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"user_group_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[3,"user_group_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/roles/:programme_id/update/:user_type_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} user_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_type_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"user_type_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"update"],[2,[7,"/"],[2,[3,"user_type_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/programme/roles/:programme_id/update_restrictions/:user_type_id(.:format)
 * @param {any} programme_identifier
 * @param {any} programme_id
 * @param {any} user_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_type_update_restrictions_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"programme_id":{"r":true},"user_type_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"programme"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"programme_id"],[2,[7,"/"],[2,[6,"update_restrictions"],[2,[7,"/"],[2,[3,"user_type_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/update_mobile_number(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_update_mobile_number_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"update_mobile_number"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/update_mobile_number_confirm/:identifier(.:format)
 * @param {any} programme_identifier
 * @param {any} identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_update_mobile_number_confirm_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"update_mobile_number_confirm"],[2,[7,"/"],[2,[3,"identifier"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/update_mobile_number_save(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_update_mobile_number_save_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"update_mobile_number_save"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/update_account(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_update_own_account_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"update_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/user/update_password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_update_own_password_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"update_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/update_profile_pic/:user_id(.:format)
 * @param {any} programme_identifier
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_update_profile_pic_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"user_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"update_profile_pic"],[2,[7,"/"],[2,[3,"user_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/user/verify_email(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_verify_email_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"verify_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/virus_scanner/get_scan_result/:scan_id(.:format)
 * @param {any} scan_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const virus_scanner_get_scan_result_path = /*#__PURE__*/ __jsr.r({"locale":{},"scan_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"virus_scanner"],[2,[7,"/"],[2,[6,"get_scan_result"],[2,[7,"/"],[2,[3,"scan_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/virus_scanner/scan_finished(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const virus_scanner_scan_finished_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"virus_scanner"],[2,[7,"/"],[2,[6,"scan_finished"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/webhook_listing/create(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhook_listing_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"webhook_listing"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/webhook_listing/delete/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhook_listing_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"webhook_listing"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/webhook_listing/edit/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhook_listing_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"webhook_listing"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/webhook_listing/list(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhook_listing_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"webhook_listing"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/webhook_listing/new(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhook_listing_new_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"webhook_listing"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/webhook_listing/update/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhook_listing_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"webhook_listing"],[2,[7,"/"],[2,[6,"update"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/widget_task_list_json(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const widget_task_list_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"widget_task_list_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_logs_approval_requests(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_logs_approval_requests_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_logs_approval_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_logs_approval_requests/list(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_logs_approval_requests_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_logs_approval_requests"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_logs_approval_requests/:id/show(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_logs_approval_requests_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_logs_approval_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_logs_approval_requests/:id/update_status(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_logs_approval_requests_update_status_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_logs_approval_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_logs/assigned_project_options(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_logs_assigned_project_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_logs"],[2,[7,"/"],[2,[6,"assigned_project_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_logs/assigned_task_options/:target_project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} target_project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_logs_assigned_task_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"target_project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_logs"],[2,[7,"/"],[2,[6,"assigned_task_options"],[2,[7,"/"],[2,[3,"target_project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_logs/create(/:project_id)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_logs_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_logs"],[2,[7,"/"],[2,[6,"create"],[2,[1,[2,[7,"/"],[3,"project_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_logs/:id/delete(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_logs_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_logs/fund_user_options(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_logs_fund_user_options_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_logs"],[2,[7,"/"],[2,[6,"fund_user_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_logs(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_logs_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_logs/list(/:year)(/:month)(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_logs_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"year":{},"month":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_logs"],[2,[7,"/"],[2,[6,"list"],[2,[1,[2,[7,"/"],[3,"year"]]],[2,[1,[2,[7,"/"],[3,"month"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_logs/:project_id/list_for_project(/:year)(/:month)(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_logs_list_for_project_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"year":{},"month":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_logs"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"list_for_project"],[2,[1,[2,[7,"/"],[3,"year"]]],[2,[1,[2,[7,"/"],[3,"month"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_logs/:project_id/list_for_project_user(/:year)(/:month)(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_logs_list_for_project_user_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"year":{},"month":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_logs"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"list_for_project_user"],[2,[1,[2,[7,"/"],[3,"year"]]],[2,[1,[2,[7,"/"],[3,"month"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_logs/submit_for_approval/:year/:month(.:format)
 * @param {any} programme_identifier
 * @param {any} year
 * @param {any} month
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_logs_submit_for_approval_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"year":{"r":true},"month":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_logs"],[2,[7,"/"],[2,[6,"submit_for_approval"],[2,[7,"/"],[2,[3,"year"],[2,[7,"/"],[2,[3,"month"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_logs/:id/update(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_logs_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_package/create(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_package_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_package"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_package/:work_package_id/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} work_package_id
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_package_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"work_package_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_package"],[2,[7,"/"],[2,[3,"work_package_id"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_package/update/:work_package_id/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} work_package_id
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_package_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"work_package_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_package"],[2,[7,"/"],[2,[6,"update"],[2,[7,"/"],[2,[3,"work_package_id"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_plan/section/:project_id(/:section_id)(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_plan_section_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"section_id":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_plan"],[2,[7,"/"],[2,[6,"section"],[2,[7,"/"],[2,[3,"project_id"],[2,[1,[2,[7,"/"],[3,"section_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_plan/delete_section/:section_id(.:format)
 * @param {any} programme_identifier
 * @param {any} section_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_plan_section_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"section_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_plan"],[2,[7,"/"],[2,[6,"delete_section"],[2,[7,"/"],[2,[3,"section_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_plan/edit_section/:section_id(.:format)
 * @param {any} programme_identifier
 * @param {any} section_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_plan_section_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"section_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_plan"],[2,[7,"/"],[2,[6,"edit_section"],[2,[7,"/"],[2,[3,"section_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_plan/update_section_order/:section_id/:insert_type/:target_section_id(.:format)
 * @param {any} programme_identifier
 * @param {any} section_id
 * @param {any} insert_type
 * @param {any} target_section_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_plan_section_update_order_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"section_id":{"r":true},"insert_type":{"r":true},"target_section_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_plan"],[2,[7,"/"],[2,[6,"update_section_order"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[3,"insert_type"],[2,[7,"/"],[2,[3,"target_section_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_plan/:project_id(.:format)
 * @param {any} programme_identifier
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_plan_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_plan"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_plan/task/:section_id(.:format)
 * @param {any} programme_identifier
 * @param {any} section_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_plan_task_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"section_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_plan"],[2,[7,"/"],[2,[6,"task"],[2,[7,"/"],[2,[3,"section_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_plan/delete_task/:task_id(.:format)
 * @param {any} programme_identifier
 * @param {any} task_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_plan_task_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"task_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_plan"],[2,[7,"/"],[2,[6,"delete_task"],[2,[7,"/"],[2,[3,"task_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_plan/edit_task/:task_id(.:format)
 * @param {any} programme_identifier
 * @param {any} task_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_plan_task_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"task_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_plan"],[2,[7,"/"],[2,[6,"edit_task"],[2,[7,"/"],[2,[3,"task_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_plan/update_task_order/:task_id/:insert_type/:target_type/:target_id(.:format)
 * @param {any} programme_identifier
 * @param {any} task_id
 * @param {any} insert_type
 * @param {any} target_type
 * @param {any} target_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_plan_task_update_order_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"task_id":{"r":true},"insert_type":{"r":true},"target_type":{"r":true},"target_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_plan"],[2,[7,"/"],[2,[6,"update_task_order"],[2,[7,"/"],[2,[3,"task_id"],[2,[7,"/"],[2,[3,"insert_type"],[2,[7,"/"],[2,[3,"target_type"],[2,[7,"/"],[2,[3,"target_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_queues/:id/items/:item_id/assign(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_queue_assign_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"item_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_queues"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"item_id"],[2,[7,"/"],[2,[6,"assign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_queues/:id/bulk_assign(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_queue_bulk_assign_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_queues"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"bulk_assign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_queues/:id/items/:item_id/claim(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_queue_claim_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"item_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_queues"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"item_id"],[2,[7,"/"],[2,[6,"claim"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_queues/create(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_queue_create_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_queues"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_queues/:id/delete(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_queue_delete_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_queues"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_queues/:id/edit(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_queue_edit_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_queues"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_queues/:id/items(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_queue_items_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_queues"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_queues(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_queue_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_queues"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_queues/list_json(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_queue_list_json_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_queues"],[2,[7,"/"],[2,[6,"list_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_queues/:id/items/:item_id/release(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {any} item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_queue_release_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"item_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_queues"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"item_id"],[2,[7,"/"],[2,[6,"release"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_queues/:id(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_queue_show_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_queues"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_queues/:id/update(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_queue_update_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_queues"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/work_queues/:id/update_members(.:format)
 * @param {any} programme_identifier
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_queue_update_members_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"work_queues"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/workflow_inbox(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workflow_inbox_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"workflow_inbox"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/workflow_inbox/list(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workflow_inbox_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"workflow_inbox"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/workflow_inbox/:project_report_id/mark_as_read(.:format)
 * @param {any} programme_identifier
 * @param {any} project_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workflow_inbox_mark_as_read_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"project_report_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"workflow_inbox"],[2,[7,"/"],[2,[3,"project_report_id"],[2,[7,"/"],[2,[6,"mark_as_read"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:programme_identifier/workflow_inbox/unread_count(.:format)
 * @param {any} programme_identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workflow_inbox_unread_count_path = /*#__PURE__*/ __jsr.r({"locale":{},"programme_identifier":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"programme_identifier"],[2,[7,"/"],[2,[6,"workflow_inbox"],[2,[7,"/"],[2,[6,"unread_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

